"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[232],{

/***/ 77057:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ FullPage; }
});

// UNUSED EXPORTS: FullPageLayout

// EXTERNAL MODULE: ../node_modules/.pnpm/next@12.3.3_@babel+core@7.14.3_react-dom@18.2.0_react@18.2.0_sass@1.49.9/node_modules/next/router.js
var next_router = __webpack_require__(48275);
// EXTERNAL MODULE: ../node_modules/.pnpm/react-redux@7.2.8_react-dom@18.2.0_react@18.2.0/node_modules/react-redux/es/index.js + 22 modules
var es = __webpack_require__(3283);
// EXTERNAL MODULE: ../node_modules/.pnpm/@vinted+web-ui@39.0.0_@types+react@18.2.21_react-dom@18.2.0_react-lottie-player@1.5.4_react@18.2.0/node_modules/@vinted/web-ui/dist/esm/lib/Spacer/Spacer.js
var Spacer = __webpack_require__(94247);
// EXTERNAL MODULE: ../node_modules/.pnpm/classnames@2.2.6/node_modules/classnames/index.js
var classnames = __webpack_require__(3997);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ../app/components/Advertisement/Advertisement.tsx + 9 modules
var Advertisement = __webpack_require__(41098);
// EXTERNAL MODULE: ../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(70079);
// EXTERNAL MODULE: ../node_modules/.pnpm/axios@0.21.4/node_modules/axios/index.js
var axios = __webpack_require__(91431);
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);
// EXTERNAL MODULE: ../app/hooks/useTracking/useTracking.ts
var useTracking = __webpack_require__(22390);
// EXTERNAL MODULE: ../app/constants/ads.ts
var ads = __webpack_require__(12196);
// EXTERNAL MODULE: ../app/state/ads/selectors.ts
var selectors = __webpack_require__(21021);
// EXTERNAL MODULE: ../app/state/ads/slice.ts
var slice = __webpack_require__(98862);
// EXTERNAL MODULE: ../app/libs/common/event-tracker/events.ts
var events = __webpack_require__(77368);
// EXTERNAL MODULE: ../app/libs/utils/sessionStorage.ts
var sessionStorage = __webpack_require__(67094);
// EXTERNAL MODULE: ../app/libs/common/ad-manager/ad-manager.ts + 1 modules
var ad_manager = __webpack_require__(68387);
// EXTERNAL MODULE: ../app/state/session/selectors.ts
var session_selectors = __webpack_require__(32707);
// EXTERNAL MODULE: ../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(35250);
;// CONCATENATED MODULE: ../app/components/AdvertisementBlockCheck/AdvertisementBlockCheck.tsx













const AdvertisementBlockCheck = () => {
  const divRef = (0,react.useRef)(null);
  const userId = (0,es/* useSelector */.v9)(session_selectors/* getUserId */.n5);
  const anonId = (0,es/* useSelector */.v9)(session_selectors/* getAnonId */.L7);
  const isAdBlockerUsed = (0,es/* useSelector */.v9)(selectors/* getIsAdBlockerUsed */._W);
  const hasAdBlockerBeenTracked = (0,es/* useSelector */.v9)(selectors/* getHasAdBlockerBeenTracked */.sD);
  const adBlockerVisitorId = (0,es/* useSelector */.v9)(selectors/* getAdBlockerVisitorId */.I3);
  const visitorId = userId ? String(userId) : anonId;
  const dispatch = (0,es/* useDispatch */.I0)();
  const {
    track
  } = (0,useTracking/* default */.Z)();
  (0,react.useEffect)(() => {
    if (!divRef.current || isAdBlockerUsed !== null) return; // First check that can be done by checking if AdBlocker
    // loaded its own styles and hidden the `.ads-banner` element

    if (divRef.current.clientHeight > 0) {
      // Then we check if ad request is failing (is blocked)
      // and if it is, then we assume that ad blocker is enabled
      axios_default().head(ads/* AD_REQUEST_CHECK_URL */.SX, {
        withCredentials: false
      }).then(() => {
        dispatch(slice/* actions.setIsAdBlockerUsed */.Nw.setIsAdBlockerUsed({
          isAdBlockerUsed: false
        }));
      }).catch(() => {
        dispatch(slice/* actions.setIsAdBlockerUsed */.Nw.setIsAdBlockerUsed({
          isAdBlockerUsed: true
        }));
      });
    } else {
      dispatch(slice/* actions.setIsAdBlockerUsed */.Nw.setIsAdBlockerUsed({
        isAdBlockerUsed: true
      }));
    }
  }, [dispatch, isAdBlockerUsed]);
  (0,react.useEffect)(() => {
    // If it has not been tracked (in this session)
    // and if the value actually is set
    if (hasAdBlockerBeenTracked || isAdBlockerUsed === null) return; // Track the tracking event for ad block check

    track((0,events/* adBlockCheckEvent */.RB)({
      isMobileWeb: ad_manager/* default.getAdsPlatform */.Z.getAdsPlatform() === ads/* AdPlatform.Mobile */.vU.Mobile,
      isAdBlockerUsed
    })); // Save the value in Redux that event has been tracked

    dispatch(slice/* actions.setHasAdBlockerBeenTracked */.Nw.setHasAdBlockerBeenTracked({
      hasAdBlockerBeenTracked: true
    })); // Save the value of visitor id in Redux

    dispatch(slice/* actions.setAdBlockerVisitorId */.Nw.setAdBlockerVisitorId({
      id: visitorId
    })); // Save to session storage that ad blocker is used

    (0,sessionStorage/* setSessionStorageItem */.D9)(ads/* IS_AD_BLOCKER_USED_SESSION_KEY */.BY, String(isAdBlockerUsed)); // Save visitor id (user id or anon id) to identify
    // when user has logged in or out

    (0,sessionStorage/* setSessionStorageItem */.D9)(ads/* AD_BLOCKER_VISITOR_KEY */.Jl, visitorId);
  }, [isAdBlockerUsed, hasAdBlockerBeenTracked, track, dispatch, visitorId]);
  (0,react.useEffect)(() => {
    // Reset hasAdBlockerBeenTracked value to `false`
    // after user logged in or logged out, to track
    // if particular user is actually using the adblocker
    if (!hasAdBlockerBeenTracked || visitorId === adBlockerVisitorId) return;
    dispatch(slice/* actions.setHasAdBlockerBeenTracked */.Nw.setHasAdBlockerBeenTracked({
      hasAdBlockerBeenTracked: false
    }));
    dispatch(slice/* actions.setAdBlockerVisitorId */.Nw.setAdBlockerVisitorId({
      id: visitorId
    }));
  }, [dispatch, hasAdBlockerBeenTracked, adBlockerVisitorId, visitorId]);
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: "ads-banner",
    "data-testid": "ads-banner",
    ref: divRef,
    tabIndex: -1,
    style: {
      // We need a dummy div, however
      // we cannot set `display: none`
      // or `visibility: hidden` to make
      // it a valid check, because that's
      // what ad blocker uses to hide these
      // elements
      width: '1px',
      height: '1px',
      position: 'absolute',
      pointerEvents: 'none',
      background: 'transparent',
      left: 0,
      top: 0
    }
  });
};

/* harmony default export */ var AdvertisementBlockCheck_AdvertisementBlockCheck = (AdvertisementBlockCheck);
// EXTERNAL MODULE: ../node_modules/.pnpm/next@12.3.3_@babel+core@7.14.3_react-dom@18.2.0_react@18.2.0_sass@1.49.9/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(39565);
// EXTERNAL MODULE: ../node_modules/.pnpm/@vinted+web-ui@39.0.0_@types+react@18.2.21_react-dom@18.2.0_react-lottie-player@1.5.4_react@18.2.0/node_modules/@vinted/web-ui/dist/esm/lib/Button/Button.js
var Button = __webpack_require__(27846);
// EXTERNAL MODULE: ../node_modules/.pnpm/@vinted+web-ui@39.0.0_@types+react@18.2.21_react-dom@18.2.0_react-lottie-player@1.5.4_react@18.2.0/node_modules/@vinted/web-ui/dist/esm/lib/Cell/Cell.js
var Cell = __webpack_require__(54);
// EXTERNAL MODULE: ../node_modules/.pnpm/@vinted+web-ui@39.0.0_@types+react@18.2.21_react-dom@18.2.0_react-lottie-player@1.5.4_react@18.2.0/node_modules/@vinted/web-ui/dist/esm/lib/Text/Text.js
var Text = __webpack_require__(10956);
// EXTERNAL MODULE: ../node_modules/.pnpm/@vinted+web-ui@39.0.0_@types+react@18.2.21_react-dom@18.2.0_react-lottie-player@1.5.4_react@18.2.0/node_modules/@vinted/web-ui/dist/esm/lib/Rating/Rating.js
var Rating = __webpack_require__(12814);
// EXTERNAL MODULE: ../node_modules/.pnpm/@vinted+web-ui@39.0.0_@types+react@18.2.21_react-dom@18.2.0_react-lottie-player@1.5.4_react@18.2.0/node_modules/@vinted/web-ui/dist/esm/lib/Divider/Divider.js
var Divider = __webpack_require__(30842);
// EXTERNAL MODULE: ../node_modules/.pnpm/@vinted+web-ui@39.0.0_@types+react@18.2.21_react-dom@18.2.0_react-lottie-player@1.5.4_react@18.2.0/node_modules/@vinted/web-ui/dist/esm/lib/Image/Image.js
var Image = __webpack_require__(37417);
// EXTERNAL MODULE: ../app/hooks/useTranslate.ts
var useTranslate = __webpack_require__(77895);
// EXTERNAL MODULE: ../app/constants/date.ts
var date = __webpack_require__(56569);
// EXTERNAL MODULE: ../app/constants/index.ts
var constants = __webpack_require__(58814);
// EXTERNAL MODULE: ../app/constants/tracking/clickable-elements.ts
var clickable_elements = __webpack_require__(82722);
// EXTERNAL MODULE: ../app/constants/tracking/screens.ts
var screens = __webpack_require__(81898);
// EXTERNAL MODULE: ../app/libs/utils/cookies.ts
var cookies = __webpack_require__(49997);
// EXTERNAL MODULE: ../app/libs/utils/date.ts
var utils_date = __webpack_require__(20868);
// EXTERNAL MODULE: ../app/libs/utils/environment.ts
var environment = __webpack_require__(61928);
// EXTERNAL MODULE: ../app/libs/utils/userAgentParser.ts
var userAgentParser = __webpack_require__(12618);
// EXTERNAL MODULE: ../app/libs/utils/window.ts
var utils_window = __webpack_require__(25937);
// EXTERNAL MODULE: ../app/state/screen/selectors.ts
var screen_selectors = __webpack_require__(10707);
// EXTERNAL MODULE: ../app/state/ab-tests/selectors.ts
var ab_tests_selectors = __webpack_require__(15707);
;// CONCATENATED MODULE: ../app/components/AppBanner/AppBanner.tsx


function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}


















 // It is decided to have hardcoded app rating with no need to sync it with store



const APP_RATING = 4.5;
const APP_ICON = "".concat(constants/* STATIC_ASSETS_URL */.Fv, "/assets/logo/square/transparent.png");
const APP_URL = 'https://4uwb.adj.st/?adjust_t=l2fpdc8_rnxf4nj&adjust_campaign=UX_SmartBanner&adjust_engagement_type=fallback_click';
const COOKIE_NAME = 'app_banner';
const COOKIE_EXPIRATION_TIME = date/* SECONDS_PER_DAY */.Nf * 5;
const LATEST_ALLOWED_ANDROID_VERSION = 7;
const appBannerScreens = [screens/* Screen.NewsFeed */.l.NewsFeed, screens/* Screen.UserProfile */.l.UserProfile, screens/* Screen.ForumPosts */.l.ForumPosts, screens/* Screen.ForumTopic */.l.ForumTopic, screens/* Screen.Catalog */.l.Catalog];

const AppBanner = _ref => {
  let {
    userAgent = (0,utils_window/* getUserAgent */.ij)(),
    isHeader
  } = _ref;
  const {
    track
  } = (0,useTracking/* default */.Z)();
  const translate = (0,useTranslate/* default */.Z)('app_banner');
  const userId = (0,es/* useSelector */.v9)(session_selectors/* getUserId */.n5);
  const screenName = (0,es/* useSelector */.v9)(screen_selectors/* getScreenName */.G);
  const webToAppAbTest = (0,es/* useSelector */.v9)((0,ab_tests_selectors/* getAbTestByName */.uw)('web_2_app_conversion_v1'));
  const exposee = (0,es/* useSelector */.v9)(session_selectors/* getExposee */.WR);

  const getAndroidVersion = () => {
    const match = userAgent.toLowerCase().match(/android\s([0-9.]*)/i);
    return match ? parseInt(match[1], 10) : LATEST_ALLOWED_ANDROID_VERSION;
  };

  const shouldNotRenderOnMobile = () => !userAgentParser/* isIOS */.gn(userAgent) && !(userAgentParser/* isAndroid */.Dt(userAgent) && getAndroidVersion() >= LATEST_ALLOWED_ANDROID_VERSION);

  const {
    0: isHidden,
    1: setIsHidden
  } = (0,react.useState)(false);
  (0,react.useEffect)(() => {
    if (!webToAppAbTest) return;
    track((0,events/* abTestExposeEvent */.Nr)(_objectSpread(_objectSpread({}, exposee), webToAppAbTest)));
  }, [webToAppAbTest, exposee, track]);
  if (environment/* serverSide */.X) return null;
  if (isHidden) return null;
  if (userId) return null;
  if ((0,cookies/* getCookie */.ej)(COOKIE_NAME)) return null;
  if (shouldNotRenderOnMobile()) return null;
  if (!appBannerScreens.includes(screenName)) return null;
  if ((webToAppAbTest === null || webToAppAbTest === void 0 ? void 0 : webToAppAbTest.variant) === 'on' && !isHeader && screenName === screens/* Screen.NewsFeed */.l.NewsFeed) return null;

  function trackClick(target) {
    track((0,events/* clickEvent */.Q5)({
      target,
      targetDetails: userAgentParser/* parseOS */.Hp(userAgent)
    }));
  }

  function handleOpenClick() {
    trackClick(clickable_elements/* ClickableElement.InstallAppBanner */.U.InstallAppBanner);
  }

  function handleCloseClick() {
    setIsHidden(true);
    trackClick(clickable_elements/* ClickableElement.CancelInstallAppBanner */.U.CancelInstallAppBanner);
    (0,cookies/* saveCookie */.YB)(COOKIE_NAME, 'hidden', (0,utils_date/* relativeDate */.K8)({
      seconds: COOKIE_EXPIRATION_TIME
    }));
  }

  function renderActions() {
    return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "u-flexbox",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Button/* ButtonWithForwardedRef */.I, {
        size: Button/* ButtonWithForwardedRef.Size.Medium */.I.Size.Medium,
        text: translate('close_cta'),
        onClick: handleCloseClick,
        testId: "app-banner-close-button"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* default */.Z, {
        orientation: Spacer/* default.Orientation.Vertical */.Z.Orientation.Vertical
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* ButtonWithForwardedRef */.I, {
        theme: "primary",
        styling: Button/* ButtonWithForwardedRef.Styling.Filled */.I.Styling.Filled,
        size: Button/* ButtonWithForwardedRef.Size.Medium */.I.Size.Medium,
        text: translate('cta'),
        onClick: handleOpenClick,
        url: APP_URL,
        testId: "app-banner-open-button"
      })]
    });
  }

  function renderTabletActions() {
    return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "u-tablets-only",
      children: renderActions()
    });
  }

  function renderPhoneActions() {
    return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "u-phones-only",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* default */.Z, {
        size: Spacer/* default.Size.Large */.Z.Size.Large
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Cell/* default */.Z, {
        styling: Cell/* default.Styling.Tight */.Z.Styling.Tight,
        children: renderActions()
      })]
    });
  }

  function renderTitle() {
    return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "u-flexbox",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Text/* default */.Z, {
        type: Text/* default.Type.Title */.Z.Type.Title,
        text: translate('title'),
        truncate: true
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* default */.Z, {
        orientation: Spacer/* default.Orientation.Vertical */.Z.Orientation.Vertical,
        size: Spacer/* default.Size.Small */.Z.Size.Small
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* default */.Z, {
          size: Spacer/* default.Size.XSmall */.Z.Size.XSmall
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Rating/* default */.Z, {
          value: APP_RATING
        })]
      })]
    });
  }

  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: "app-banner",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: isHeader && (webToAppAbTest === null || webToAppAbTest === void 0 ? void 0 : webToAppAbTest.variant) === 'on' ? 'sticky-header' : 'sticky-footer',
      "data-testid": "app-banner-wrapper",
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "u-line-height-default",
        children: [!isHeader && /*#__PURE__*/(0,jsx_runtime.jsx)(Divider/* default */.Z, {}), /*#__PURE__*/(0,jsx_runtime.jsxs)(Cell/* default */.Z, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Cell/* default */.Z, {
            styling: Cell/* default.Styling.Tight */.Z.Styling.Tight,
            prefix: /*#__PURE__*/(0,jsx_runtime.jsx)(Image/* ImageWithForwardedRef */.U, {
              size: Image/* ImageWithForwardedRef.Size.Large */.U.Size.Large,
              src: APP_ICON
            }),
            suffix: renderTabletActions(),
            title: renderTitle(),
            body: /*#__PURE__*/(0,jsx_runtime.jsx)(Text/* default */.Z, {
              text: translate('description'),
              truncate: true
            }),
            fullWidthTitle: true
          }), renderPhoneActions()]
        }), isHeader && /*#__PURE__*/(0,jsx_runtime.jsx)(Divider/* default */.Z, {})]
      })
    })
  });
};

/* harmony default export */ var AppBanner_AppBanner = (AppBanner);
// EXTERNAL MODULE: ../node_modules/.pnpm/react-intl@6.0.3_react@18.2.0_typescript@5.1.6/node_modules/react-intl/lib/src/components/message.js
var message = __webpack_require__(41043);
// EXTERNAL MODULE: ../node_modules/.pnpm/@vinted+web-ui@39.0.0_@types+react@18.2.21_react-dom@18.2.0_react-lottie-player@1.5.4_react@18.2.0/node_modules/@vinted/web-ui/dist/esm/lib/DeprecatedIcon/DeprecatedIcon.js + 2 modules
var DeprecatedIcon = __webpack_require__(30272);
// EXTERNAL MODULE: ../node_modules/.pnpm/@vinted+web-ui@39.0.0_@types+react@18.2.21_react-dom@18.2.0_react-lottie-player@1.5.4_react@18.2.0/node_modules/@vinted/web-ui/dist/esm/lib/Modal/Modal.js
var Modal = __webpack_require__(77242);
// EXTERNAL MODULE: ../node_modules/.pnpm/@vinted+web-ui@39.0.0_@types+react@18.2.21_react-dom@18.2.0_react-lottie-player@1.5.4_react@18.2.0/node_modules/@vinted/web-ui/dist/esm/lib/Navigation/Navigation.js
var Navigation = __webpack_require__(66743);
;// CONCATENATED MODULE: ../app/constants/domain_selected_cookie.ts

const DOMAIN_SELECTED_COOKIE = 'domain_selected';
const DOMAIN_SELECTED_COOKIE_EXPIRATION_DATE = (0,utils_date/* relativeDate */.K8)({
  years: 20
}); // matches rails's `cookie.permanent`
;// CONCATENATED MODULE: ../app/components/DomainSelectModal/DomainSelectModal.tsx









const DomainSelectModal = _ref => {
  let {
    domainLinks
  } = _ref;
  const {
    0: show,
    1: setShow
  } = (0,react.useState)(true);

  function openCountryLink(link) {
    (0,utils_window/* navigateToPage */.ru)(link);
  }

  function handleCloseModal() {
    (0,cookies/* saveCookie */.YB)(DOMAIN_SELECTED_COOKIE, 'true', DOMAIN_SELECTED_COOKIE_EXPIRATION_DATE);
    setShow(false);
  }

  function renderCountryCell(countryLink, index) {
    const iconName = DeprecatedIcon/* default.buildIconName */.Z.buildIconName('flags', countryLink.code);
    return /*#__PURE__*/(0,jsx_runtime.jsx)(Cell/* default */.Z, {
      onClick: () => openCountryLink(countryLink.link),
      clickable: true,
      prefix: iconName && /*#__PURE__*/(0,jsx_runtime.jsx)(DeprecatedIcon/* default */.Z, {
        name: iconName
      }),
      title: /*#__PURE__*/(0,jsx_runtime.jsx)(Text/* default */.Z, {
        text: /*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, {
          id: "native_country_names.".concat(countryLink.code)
        }),
        type: Text/* default.Type.Title */.Z.Type.Title
      })
    }, index);
  }

  if (!domainLinks.length) return null;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Modal/* default */.Z, {
    show: show,
    hasScrollableContent: true,
    testId: "domain-select-modal",
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "u-ui-padding-regular u-fill-width",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Navigation/* default */.Z, {
        theme: "transparent",
        right: /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* ButtonWithForwardedRef */.I, {
          testId: "domain-select-modal-close-button",
          styling: Button/* ButtonWithForwardedRef.Styling.Flat */.I.Styling.Flat,
          onClick: handleCloseModal,
          deprecatedIconName: "x",
          inline: true
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Cell/* default */.Z, {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(Text/* default */.Z, {
          text: /*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, {
            id: "domain_selection.title"
          }),
          type: Text/* default.Type.Heading */.Z.Type.Heading,
          as: "h2"
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "u-fill-height u-overflow-auto",
        children: domainLinks.map(renderCountryCell)
      })]
    })
  });
};

/* harmony default export */ var DomainSelectModal_DomainSelectModal = (DomainSelectModal);
// EXTERNAL MODULE: ../app/constants/google.ts
var google = __webpack_require__(57802);
// EXTERNAL MODULE: ../app/hooks/useGoogleTagManagerTrack.ts + 1 modules
var useGoogleTagManagerTrack = __webpack_require__(58498);
;// CONCATENATED MODULE: ../app/components/Google/Analytics/GoogleAnalyticsTracker.tsx




const GoogleAnalyticsTracker = () => {
  const {
    googleAnalyticsTrack
  } = (0,useGoogleTagManagerTrack/* default */.Z)();
  (0,react.useEffect)(() => {
    googleAnalyticsTrack({
      event: google/* GoogleTagManagerEvent.pageLoad */.Nx.pageLoad
    });
  }, [googleAnalyticsTrack]);
  return null;
};

/* harmony default export */ var Analytics_GoogleAnalyticsTracker = (GoogleAnalyticsTracker);
// EXTERNAL MODULE: ../app/components/Auth/AuthModal/AuthModal.tsx
var AuthModal = __webpack_require__(44024);
// EXTERNAL MODULE: ../app/components/FaqEntryUrl/FaqEntryUrl.tsx
var FaqEntryUrl = __webpack_require__(37525);
;// CONCATENATED MODULE: ../app/components/HeaderHelpButton/HeaderHelpButton.tsx




const HeaderHelpButton = _ref => {
  let {
    testId,
    url
  } = _ref;
  const translate = (0,useTranslate/* default */.Z)('header'); // TODO: this is considered a UI debt, as all clickable icons should be placed into buttons

  return /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
    "data-testid": testId,
    className: "u-flexbox u-align-items-center",
    href: url,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(DeprecatedIcon/* default */.Z, {
      name: "question-circle",
      aria: {
        'aria-label': translate('a11y.help')
      },
      color: DeprecatedIcon/* default.Color.GreyscaleLevel4 */.Z.Color.GreyscaleLevel4
    })
  });
};

/* harmony default export */ var HeaderHelpButton_HeaderHelpButton = (HeaderHelpButton);
// EXTERNAL MODULE: ../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/lodash.js
var lodash = __webpack_require__(61888);
// EXTERNAL MODULE: ../app/constants/routes/index.ts
var routes = __webpack_require__(98923);
// EXTERNAL MODULE: ../app/libs/utils/portal.ts
var utils_portal = __webpack_require__(78239);
;// CONCATENATED MODULE: ../app/components/HeaderLogo/HeaderLogo.tsx















const LOGO_ASSET_URL = "".concat(constants/* STATIC_ASSETS_URL */.Fv, "/assets/web-logo");

const HeaderLogo = _ref => {
  let {
    portal,
    onClick = lodash.noop
  } = _ref;
  const translate = (0,useTranslate/* default */.Z)('header.a11y');
  const {
    track
  } = (0,useTracking/* default */.Z)();
  const user = (0,es/* useSelector */.v9)(session_selectors/* getUser */.PR);
  const isDe = ['de', 'de_babies'].includes(portal);
  const brand = (0,utils_portal/* portalLogoBrand */.R)(portal);

  const handleLogoClick = event => {
    const trakingEvent = (0,events/* clickEvent */.Q5)({
      target: clickable_elements/* ClickableElement.Logo */.U.Logo
    });
    track(trakingEvent);
    return onClick(event);
  };

  const renderDesktopLogo = () => /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: classnames_default()('l-header__logo-container', {
      'l-header__logo-container--wide': isDe
    }),
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(Image/* ImageWithForwardedRef */.U, {
      src: "".concat(LOGO_ASSET_URL, "/").concat(brand, "/logo.svg"),
      alt: translate('logo')
    })
  });

  const renderLogo = () => /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: "u-ui-padding-left-small",
    children: renderDesktopLogo()
  });

  const renderAuthenticatedLogo = () => /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "u-phones-only",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Image/* ImageWithForwardedRef */.U, {
        src: "".concat(LOGO_ASSET_URL, "/").concat(brand, "/symbol.svg"),
        alt: translate('logo')
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: classnames_default()('u-tablets-up-only', 'u-ui-padding-left-small'),
      children: renderDesktopLogo()
    })]
  });

  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: "l-header__logo",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
      className: "u-block",
      href: routes/* ROOT_URL */.mYc,
      title: translate('logo'),
      "aria-label": translate('logo'),
      onClick: handleLogoClick,
      "data-testid": "header-logo-id",
      children: user ? renderAuthenticatedLogo() : renderLogo()
    })
  });
};

/* harmony default export */ var HeaderLogo_HeaderLogo = (HeaderLogo);
// EXTERNAL MODULE: ../app/components/LanguageSelector/LanguageSelector.tsx + 2 modules
var LanguageSelector = __webpack_require__(22264);
// EXTERNAL MODULE: ../node_modules/.pnpm/react-intl@6.0.3_react@18.2.0_typescript@5.1.6/node_modules/react-intl/lib/src/components/injectIntl.js
var injectIntl = __webpack_require__(38590);
// EXTERNAL MODULE: ../node_modules/.pnpm/@vinted+web-ui@39.0.0_@types+react@18.2.21_react-dom@18.2.0_react-lottie-player@1.5.4_react@18.2.0/node_modules/@vinted/web-ui/dist/esm/lib/Chip/Chip.js
var Chip = __webpack_require__(16296);
// EXTERNAL MODULE: ../app/containers/TrackingProvider/wrapper.tsx
var wrapper = __webpack_require__(88708);
// EXTERNAL MODULE: ../app/state/saved-searches/actions.ts
var actions = __webpack_require__(62884);
// EXTERNAL MODULE: ../app/state/saved-searches/selectors.ts
var saved_searches_selectors = __webpack_require__(39192);
// EXTERNAL MODULE: ../app/state/items/selectors.ts
var items_selectors = __webpack_require__(70204);
// EXTERNAL MODULE: ../app/state/catalog-filters/selectors.ts
var catalog_filters_selectors = __webpack_require__(9023);
// EXTERNAL MODULE: ../app/components/Breakpoint/withBreakpoint.tsx
var withBreakpoint = __webpack_require__(74901);
;// CONCATENATED MODULE: ../app/components/SavedSearches/SearchSubscribeButton/SearchSubscribeButton.tsx















const mapStateToProps = state => ({
  currentSearch: (0,saved_searches_selectors/* getCurrentSearch */.B$)(state),
  query: (0,catalog_filters_selectors/* getQuery */.pm)(state),
  errors: (0,items_selectors/* getCatalogItemErrors */.aG)(state),
  isPopularCatalog: (0,catalog_filters_selectors/* getIsPopularInCatalog */.Vm)(state),
  searchSessionId: (0,catalog_filters_selectors/* getSearchSessionId */.LT)(state),
  globalSearchSessionId: (0,catalog_filters_selectors/* getGlobalSearchSessionId */.zO)(state),
  userId: (0,session_selectors/* getUserId */.n5)(state)
});

const mapActionsToProps = {
  toggle: actions/* toggleCurrentSearchSubscription */.F6
};
const connector = (0,es/* connect */.$j)(mapStateToProps, mapActionsToProps);

class SearchSubscribeButton extends react.Component {
  constructor() {
    super(...arguments);

    (0,defineProperty/* default */.Z)(this, "toggleSubscription", () => {
      var _currentSearch$search;

      const {
        userId,
        currentSearch,
        query,
        searchSessionId,
        toggle,
        track,
        globalSearchSessionId
      } = this.props;
      if (!userId) return;
      toggle({
        userId
      });
      track((0,events/* toggleSearchSubscriptionEvent */.hM)({
        isSubscribing: !(currentSearch !== null && currentSearch !== void 0 && currentSearch.subscribed),
        searchSessionId,
        searchTitle: currentSearch === null || currentSearch === void 0 ? void 0 : currentSearch.title,
        searchQuery: (_currentSearch$search = currentSearch === null || currentSearch === void 0 ? void 0 : currentSearch.search_text) !== null && _currentSearch$search !== void 0 ? _currentSearch$search : query,
        globalSearchSessionId
      }));
    });
  }

  renderIcon() {
    const {
      currentSearch,
      breakpoints
    } = this.props;
    return /*#__PURE__*/(0,jsx_runtime.jsx)(DeprecatedIcon/* default */.Z, {
      name: currentSearch !== null && currentSearch !== void 0 && currentSearch.subscribed ? 'bookmark-filled' : 'bookmark',
      color: currentSearch !== null && currentSearch !== void 0 && currentSearch.subscribed ? DeprecatedIcon/* default.Color.Primary */.Z.Color.Primary : DeprecatedIcon/* default.Color.GreyscaleLevel1 */.Z.Color.GreyscaleLevel1,
      size: breakpoints.phones ? DeprecatedIcon/* default.Size.Small */.Z.Size.Small : DeprecatedIcon/* default.Size.Regular */.Z.Size.Regular
    });
  }

  render() {
    const {
      currentSearch,
      errors,
      isPopularCatalog,
      breakpoints,
      intl,
      userId
    } = this.props;
    if (errors || isPopularCatalog || !userId) return null;
    const action = currentSearch !== null && currentSearch !== void 0 && currentSearch.subscribed ? 'delete' : 'save';

    const text = /*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, {
      id: "saved_searches.actions.".concat(action)
    });

    const a11yLabel = breakpoints.phones ? intl.formatMessage({
      id: "saved_searches.a11y.".concat(action)
    }) : undefined;
    return /*#__PURE__*/(0,jsx_runtime.jsx)(Chip/* ChipWithForwardedRef */.j, {
      text: !breakpoints.phones && text,
      textType: Text/* default.Type.Subtitle */.Z.Type.Subtitle,
      prefix: this.renderIcon(),
      onClick: this.toggleSubscription,
      aria: {
        'aria-label': a11yLabel
      },
      testId: "catalog-search-".concat(action, "-button")
    });
  }

}

const SearchSubscribeButtonComposed = (0,wrapper/* default */.Z)((0,injectIntl/* default */.ZP)((0,withBreakpoint/* default */.Z)(SearchSubscribeButton)));

/* harmony default export */ var SearchSubscribeButton_SearchSubscribeButton = (connector(SearchSubscribeButtonComposed));
// EXTERNAL MODULE: ../app/constants/faq-entry.ts
var faq_entry = __webpack_require__(23202);
// EXTERNAL MODULE: ../node_modules/.pnpm/@vinted+web-ui@39.0.0_@types+react@18.2.21_react-dom@18.2.0_react-lottie-player@1.5.4_react@18.2.0/node_modules/@vinted/web-ui/dist/esm/lib/Tabs/Tabs.js + 1 modules
var Tabs = __webpack_require__(53374);
// EXTERNAL MODULE: ../app/constants/catalog.ts
var catalog = __webpack_require__(47960);
// EXTERNAL MODULE: ../app/data/transformers/catalog.ts
var transformers_catalog = __webpack_require__(25096);
// EXTERNAL MODULE: ../node_modules/.pnpm/@vinted+web-ui@39.0.0_@types+react@18.2.21_react-dom@18.2.0_react-lottie-player@1.5.4_react@18.2.0/node_modules/@vinted/web-ui/dist/esm/lib/Card/Card.js
var Card = __webpack_require__(98398);
// EXTERNAL MODULE: ../app/state/feature-switches/selectors.ts
var feature_switches_selectors = __webpack_require__(84353);
// EXTERNAL MODULE: ../app/libs/utils/press-center.ts
var press_center = __webpack_require__(6933);
// EXTERNAL MODULE: ../app/state/intl/selectors.ts
var intl_selectors = __webpack_require__(12761);
;// CONCATENATED MODULE: ../app/components/Header/CatalogNavigation/AboutPanel/LinkCell/LinkCell.tsx



const LinkCell = _ref => {
  let {
    title,
    url,
    onClick,
    testId
  } = _ref;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Cell/* default */.Z, {
    type: Cell/* default.Type.Navigating */.Z.Type.Navigating,
    styling: Cell/* default.Styling.Narrow */.Z.Styling.Narrow,
    url: url,
    onClick: onClick,
    body: /*#__PURE__*/(0,jsx_runtime.jsx)(Text/* default */.Z, {
      children: title
    }),
    testId: testId
  });
};

/* harmony default export */ var LinkCell_LinkCell = (LinkCell);
// EXTERNAL MODULE: ../node_modules/.pnpm/@vinted+web-ui@39.0.0_@types+react@18.2.21_react-dom@18.2.0_react-lottie-player@1.5.4_react@18.2.0/node_modules/@vinted/web-ui/dist/esm/lib/Label/Label.js
var Label = __webpack_require__(31761);
;// CONCATENATED MODULE: ../app/components/Header/CatalogNavigation/AboutPanel/LinksGroup/LinksGroup.tsx





const LinksGroup = _ref => {
  let {
    title,
    children
  } = _ref;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Label/* default */.Z, {
      text: title,
      type: Label/* default.Type.Stacked */.Z.Type.Stacked,
      styling: Label/* default.Styling.Narrow */.Z.Styling.Narrow
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* default */.Z, {}), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      children: children
    })]
  });
};

/* harmony default export */ var LinksGroup_LinksGroup = (LinksGroup);
;// CONCATENATED MODULE: ../app/components/Header/CatalogNavigation/AboutPanel/FirstColumn/FirstColumn.tsx
















const FirstColumn = _ref => {
  let {
    isBusinessAccountLinksVisible
  } = _ref;
  const translate = (0,useTranslate/* default */.Z)('header.main_navigation.about');
  const {
    track
  } = (0,useTracking/* default */.Z)();
  const isSustainabilityPageEnabled = (0,es/* useSelector */.v9)((0,feature_switches_selectors/* getIsFeatureSwitchEnabled */.z)('sustainability_page_press_center_link'));
  const isPressMenuEnabled = (0,es/* useSelector */.v9)((0,feature_switches_selectors/* getIsFeatureSwitchEnabled */.z)('press_menu'));
  const isPressCenterLinkEnabled = (0,es/* useSelector */.v9)((0,feature_switches_selectors/* getIsFeatureSwitchEnabled */.z)('web_press_center_link'));
  const isJobsPageEnabled = (0,es/* useSelector */.v9)((0,feature_switches_selectors/* getIsFeatureSwitchEnabled */.z)('jobs_page'));
  const isNewJobsUrlEnabled = (0,es/* useSelector */.v9)((0,feature_switches_selectors/* getIsFeatureSwitchEnabled */.z)('new_jobs_career_portal'));
  const locale = (0,es/* useSelector */.v9)(intl_selectors/* getLocale */.K);

  const handleSustainabilityClick = () => {
    track((0,events/* clickEvent */.Q5)({
      target: clickable_elements/* ClickableElement.SustainabilityPageLink */.U.SustainabilityPageLink,
      targetDetails: 'navigation_web'
    }));
  };

  const renderDiscoverBlock = () => /*#__PURE__*/(0,jsx_runtime.jsxs)(LinksGroup_LinksGroup, {
    title: translate('discover.title'),
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(LinkCell_LinkCell, {
      title: translate('discover.items.how_it_works'),
      url: routes/* HOW_IT_WORKS_URL */.OkD
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(LinkCell_LinkCell, {
      title: translate('discover.items.app'),
      url: routes/* APP_LANDING_URL */.QwI
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(LinkCell_LinkCell, {
      title: translate('discover.items.help'),
      url: routes/* HELP_CENTER_URL */.lw5
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(LinkCell_LinkCell, {
      title: translate('discover.items.infoboard'),
      url: routes/* INFOBOARD_URL */.Ga_
    }), isBusinessAccountLinksVisible && /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(LinkCell_LinkCell, {
        title: translate('discover.items.pro'),
        url: routes/* BUSINESS_ACCOUNTS_HOMEPAGE */.Jo
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(LinkCell_LinkCell, {
        title: translate('discover.items.pro_guide'),
        url: routes/* BUSINESS_ACCOUNTS_GUIDE_URL */._qi
      })]
    })]
  });

  const renderCompanyBlock = () => {
    const shortLocale = String(locale.substring(0, 2));
    const pressUrl = isPressCenterLinkEnabled ? (0,press_center/* getPressCenterUrl */.J)(shortLocale) : routes/* PRESS_URL */.v6v;
    const jobsUrl = isNewJobsUrlEnabled ? routes/* JOBS_URL_NEW */.VHG : routes/* JOBS_URL */.Ch7;
    return /*#__PURE__*/(0,jsx_runtime.jsxs)(LinksGroup_LinksGroup, {
      title: translate('company.title'),
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(LinkCell_LinkCell, {
        title: translate('company.items.about'),
        url: routes/* MAIN_NAVIGATION_ABOUT_TAB_URL */.ouD
      }), isJobsPageEnabled && /*#__PURE__*/(0,jsx_runtime.jsx)(LinkCell_LinkCell, {
        testId: "jobs-link-header",
        title: translate('company.items.jobs'),
        url: jobsUrl
      }), isSustainabilityPageEnabled && /*#__PURE__*/(0,jsx_runtime.jsx)(LinkCell_LinkCell, {
        title: translate('company.items.sustainability'),
        url: (0,press_center/* getSustainabilityUrl */.E)(shortLocale),
        onClick: handleSustainabilityClick
      }), isPressMenuEnabled && /*#__PURE__*/(0,jsx_runtime.jsx)(LinkCell_LinkCell, {
        title: translate('company.items.press'),
        url: pressUrl,
        testId: "press-link"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(LinkCell_LinkCell, {
        title: translate('company.items.advertising'),
        url: routes/* ADVERTISING_URL */.E2e
      })]
    });
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    children: [renderDiscoverBlock(), /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* default */.Z, {
      size: Spacer/* default.Size.X2Large */.Z.Size.X2Large
    }), renderCompanyBlock()]
  });
};

/* harmony default export */ var FirstColumn_FirstColumn = (FirstColumn);
;// CONCATENATED MODULE: ../app/components/Header/CatalogNavigation/AboutPanel/SecondColumn/SecondColumn.tsx











const SecondColumn = _ref => {
  let {
    impressumUrl,
    isBusinessAccountLinksVisible
  } = _ref;
  const translate = (0,useTranslate/* default */.Z)('header.main_navigation.about');

  const handleCookiesClick = event => {
    event.preventDefault();
    (0,utils_window/* toggleOneTrustInfoDisplay */.ap)();
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(LinksGroup_LinksGroup, {
      title: translate('policies.title'),
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(LinkCell_LinkCell, {
        title: translate('policies.items.safety'),
        url: routes/* HELP_SAFETY_URL */.c1u
      }), impressumUrl && /*#__PURE__*/(0,jsx_runtime.jsx)(LinkCell_LinkCell, {
        title: translate('policies.items.impressum'),
        url: impressumUrl
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(LinkCell_LinkCell, {
        title: translate('policies.items.privacy_policy'),
        url: routes/* PRIVACY_POLICY_URL */.hOY
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(LinkCell_LinkCell, {
        title: translate('policies.items.terms_and_conditions'),
        url: routes/* TERMS_URL */.qyY
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(LinkCell_LinkCell, {
        title: translate('policies.items.cookie_policy'),
        url: routes/* COOKIE_POLICY_URL */.ljN
      }), isBusinessAccountLinksVisible && /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(LinkCell_LinkCell, {
          title: translate('policies.items.pro_terms_of_sale'),
          url: routes/* BUSINESS_TERMS_OF_SALE_URL */.$ru
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(LinkCell_LinkCell, {
          title: translate('policies.items.pro_terms_of_use'),
          url: routes/* BUSINESS_TERMS_URL */.vK_
        })]
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* default */.Z, {
      size: Spacer/* default.Size.X2Large */.Z.Size.X2Large
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(LinksGroup_LinksGroup, {
      title: translate('privacy.title'),
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(LinkCell_LinkCell, {
        title: translate('privacy.items.cookies'),
        url: catalog/* NAVIGATION_COOKIES_URL */.bd,
        onClick: handleCookiesClick,
        testId: "about-panel-cookie-settings-button"
      })
    })]
  });
};

/* harmony default export */ var SecondColumn_SecondColumn = (SecondColumn);
;// CONCATENATED MODULE: ../app/components/Header/CatalogNavigation/AboutPanel/ThirdColumn/ThirdColumn.tsx









const ThirdColumn = () => {
  const translate = (0,useTranslate/* default */.Z)('header.main_navigation.about.communities');
  const user = (0,es/* useSelector */.v9)(session_selectors/* getUser */.PR);
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(LinksGroup_LinksGroup, {
      title: translate('title'),
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(LinkCell_LinkCell, {
        title: translate('items.forum'),
        url: routes/* FORUM_HOME_URL */.R1Q
      }), !!(user !== null && user !== void 0 && user.favourite_topic_count) && /*#__PURE__*/(0,jsx_runtime.jsx)(LinkCell_LinkCell, {
        title: translate('items.forum_favourite_topics'),
        url: routes/* FORUM_FAVOURITE_TOPICS_URL */.Nei
      }), !!user && /*#__PURE__*/(0,jsx_runtime.jsx)(LinkCell_LinkCell, {
        title: translate('items.forum_own_topics'),
        url: routes/* FORUM_OWN_TOPICS_URL */.AnP
      })]
    })
  });
};

/* harmony default export */ var ThirdColumn_ThirdColumn = (ThirdColumn);
;// CONCATENATED MODULE: ../app/components/Header/CatalogNavigation/AboutPanel/AboutPanel.tsx










const AboutPanel = _ref => {
  let {
    impressumUrl,
    isBusinessAccountLinksVisible
  } = _ref;
  const isForumDisabled = (0,es/* useSelector */.v9)((0,feature_switches_selectors/* getIsFeatureSwitchEnabled */.z)('disable_forum_web'));

  const renderBody = () => /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: "catalog-dropdown__content",
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "u-flexbox u-nowrap",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(FirstColumn_FirstColumn, {
        isBusinessAccountLinksVisible: isBusinessAccountLinksVisible
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* default */.Z, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(SecondColumn_SecondColumn, {
        impressumUrl: impressumUrl,
        isBusinessAccountLinksVisible: isBusinessAccountLinksVisible
      }), !isForumDisabled && /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* default */.Z, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(ThirdColumn_ThirdColumn, {})]
      })]
    })
  });

  return /*#__PURE__*/(0,jsx_runtime.jsx)(Card/* default */.Z, {
    styling: Card/* default.Styling.Elevated */.Z.Styling.Elevated,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "u-overflow-auto",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Cell/* default */.Z, {
        body: renderBody()
      })
    })
  });
};

/* harmony default export */ var AboutPanel_AboutPanel = (AboutPanel);
// EXTERNAL MODULE: ../node_modules/.pnpm/@vinted+web-ui@39.0.0_@types+react@18.2.21_react-dom@18.2.0_react-lottie-player@1.5.4_react@18.2.0/node_modules/@vinted/web-ui/dist/esm/lib/Badge/Badge.js
var Badge = __webpack_require__(84322);
;// CONCATENATED MODULE: ../app/components/Header/CatalogNavigation/CatalogsPanel/CatalogsPanel.tsx


function CatalogsPanel_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function CatalogsPanel_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? CatalogsPanel_ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : CatalogsPanel_ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}









const CatalogsPanel = _ref => {
  let {
    selectedCategory,
    selectedCategoryId,
    triggerCatalogModal
  } = _ref;
  const translate = (0,useTranslate/* default */.Z)();
  const {
    track
  } = (0,useTracking/* default */.Z)();

  const parentCatalog = CatalogsPanel_objectSpread(CatalogsPanel_objectSpread({}, selectedCategory), {}, {
    code: catalog/* WEB_CATALOG_ROOT_ALL_CODE */.Vs,
    title: translate('header.main_navigation.catalogs.see_all')
  });

  const catalogList = [parentCatalog, ...selectedCategory.catalogs];

  const handleTitleClick = _ref2 => {
    let {
      id,
      title,
      landing
    } = _ref2;
    return event => {
      if (!landing) {
        const trakingEvent = (0,events/* selectCatalogEvent */.bc)({
          catalogIds: [id],
          attributeId: catalog/* CatalogAttribute.Navigation */.Oj.Navigation
        });
        track(trakingEvent);
        return;
      }

      event.preventDefault();
      triggerCatalogModal({
        catalogName: title,
        itemsRemaining: landing.itemsRemaining,
        imageUrl: landing.imageUrl
      });
    };
  };

  const renderCatalogItem = item => /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: "catalog-dropdown__item",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(Cell/* default */.Z, {
      suffix: item.landing && /*#__PURE__*/(0,jsx_runtime.jsx)(Badge/* default */.Z, {
        theme: "primary",
        content: translate('common.new_badge')
      }),
      type: Cell/* default.Type.Navigating */.Z.Type.Navigating,
      styling: Cell/* default.Styling.Narrow */.Z.Styling.Narrow,
      body: /*#__PURE__*/(0,jsx_runtime.jsx)(Text/* default */.Z, {
        truncate: true,
        children: item.title
      }),
      url: item.url,
      urlProps: {
        title: item.title
      },
      onClick: handleTitleClick(item),
      testId: "catalog-item-".concat(item.id),
      aria: {
        'aria-label': item.title
      }
    })
  }, item.id);

  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: classnames_default()('catalog-dropdown__category', {
      active: selectedCategory.id === selectedCategoryId
    }),
    children: catalogList.map(renderCatalogItem)
  });
};

/* harmony default export */ var CatalogsPanel_CatalogsPanel = (CatalogsPanel);
;// CONCATENATED MODULE: ../app/components/Header/CatalogNavigation/CategoriesPanel/CategoriesPanel.tsx


function CategoriesPanel_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function CategoriesPanel_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? CategoriesPanel_ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : CategoriesPanel_ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}










const CategoriesPanel = _ref => {
  var _rootCategory$catalog;

  let {
    rootCategory,
    triggerCatalogModal
  } = _ref;
  const translate = (0,useTranslate/* default */.Z)();
  const {
    0: selectedCategoryId,
    1: setSelectedCategoryId
  } = (0,react.useState)(((_rootCategory$catalog = rootCategory.catalogs[0]) === null || _rootCategory$catalog === void 0 ? void 0 : _rootCategory$catalog.id) || catalog/* ROOT_CATALOG_ID */.rs);

  const parentCatalog = CategoriesPanel_objectSpread(CategoriesPanel_objectSpread({}, rootCategory), {}, {
    code: catalog/* WEB_CATALOG_ROOT_ALL_CODE */.Vs,
    title: translate('header.main_navigation.catalogs.see_all')
  });

  const categoryList = [parentCatalog, ...rootCategory.catalogs];
  const categoriesCellStyling = categoryList.length >= catalog/* CATALOG_SHRINK_THRESHOLD */.eV ? Cell/* default.Styling.Narrow */.Z.Styling.Narrow : undefined;

  const handleTitleClick = _ref2 => {
    let {
      id,
      url,
      code,
      title,
      catalogs,
      landing
    } = _ref2;
    return event => {
      event.preventDefault();
      event.stopPropagation();

      if (catalogs.length && code !== catalog/* WEB_CATALOG_ROOT_ALL_CODE */.Vs && !landing) {
        event.nativeEvent.stopImmediatePropagation();
        setSelectedCategoryId(id);
      } else if (landing) {
        triggerCatalogModal({
          catalogName: title,
          itemsRemaining: landing.itemsRemaining,
          imageUrl: landing.imageUrl
        });
      } else {
        (0,utils_window/* navigateToPage */.ru)(url);
      }
    };
  };

  const renderCategoriesItem = item => {
    var _item$photo;

    return /*#__PURE__*/(0,jsx_runtime.jsx)(Cell/* default */.Z, {
      type: Cell/* default.Type.Navigating */.Z.Type.Navigating,
      styling: categoriesCellStyling,
      prefix: item.code === catalog/* WEB_CATALOG_ROOT_ALL_CODE */.Vs ? /*#__PURE__*/(0,jsx_runtime.jsx)(DeprecatedIcon/* default */.Z, {
        name: catalog/* ROOT_CATALOG_ICON_NAME */.s8,
        color: DeprecatedIcon/* default.Color.Primary */.Z.Color.Primary
      }) : /*#__PURE__*/(0,jsx_runtime.jsx)(Image/* ImageWithForwardedRef */.U, {
        src: (_item$photo = item.photo) === null || _item$photo === void 0 ? void 0 : _item$photo.url,
        scaling: Image/* ImageWithForwardedRef.Scaling.Cover */.U.Scaling.Cover,
        size: Image/* ImageWithForwardedRef.Size.Regular */.U.Size.Regular
      }),
      suffix: item.landing && /*#__PURE__*/(0,jsx_runtime.jsx)(Badge/* default */.Z, {
        theme: "primary",
        content: translate('common.new_badge')
      }),
      body: /*#__PURE__*/(0,jsx_runtime.jsx)(Text/* default */.Z, {
        truncate: true,
        bold: item.id === selectedCategoryId,
        theme: item.id === selectedCategoryId ? 'amplified' : 'inherit',
        children: item.title
      }),
      url: item.url,
      urlProps: {
        title: item.title
      },
      onClick: handleTitleClick(item),
      testId: "category-item-".concat(item.id),
      aria: {
        'aria-label': item.title
      }
    }, item.id);
  };

  const renderCatalogsItem = item => /*#__PURE__*/(0,jsx_runtime.jsx)(CatalogsPanel_CatalogsPanel, {
    selectedCategory: item,
    selectedCategoryId: selectedCategoryId,
    triggerCatalogModal: triggerCatalogModal
  }, item.id);

  const renderCategoriesBody = () => /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: "catalog-dropdown__content",
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "u-flexbox",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "catalog-dropdown__categories",
        children: categoryList.map(renderCategoriesItem)
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "catalog-dropdown__catalogs",
        children: categoryList.map(renderCatalogsItem)
      })]
    })
  });

  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: "catalog-dropdown",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(Card/* default */.Z, {
      styling: Card/* default.Styling.Elevated */.Z.Styling.Elevated,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "u-overflow-auto",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(Cell/* default */.Z, {
          styling: Cell/* default.Styling.Narrow */.Z.Styling.Narrow,
          body: renderCategoriesBody()
        })
      })
    })
  });
};

/* harmony default export */ var CategoriesPanel_CategoriesPanel = (CategoriesPanel);
;// CONCATENATED MODULE: ../app/components/Header/CatalogNavigation/CatalogNavigation.tsx

















const CatalogNavigation = _ref => {
  let {
    tree,
    impressumUrl,
    isBusinessAccountLinksVisible,
    isOurPlatformVisible
  } = _ref;
  const translate = (0,useTranslate/* default */.Z)('header.main_navigation');
  const {
    track
  } = (0,useTracking/* default */.Z)();
  const {
    0: activeTabId,
    1: setActiveTabId
  } = (0,react.useState)(catalog/* ROOT_CATALOG_ID */.rs);
  const {
    0: isModalOpen,
    1: setIsModalOpen
  } = (0,react.useState)(false);
  const {
    0: modalContent,
    1: setModalContent
  } = (0,react.useState)({
    catalogName: '',
    imageUrl: '',
    itemsRemaining: 0
  });
  const transformedTree = (0,react.useMemo)(() => (0,transformers_catalog/* transformCatalogDtoList */.Dx)(tree), [tree]);

  const openCatalogModal = _ref2 => {
    let {
      catalogName,
      itemsRemaining,
      imageUrl
    } = _ref2;
    setModalContent({
      catalogName,
      itemsRemaining,
      imageUrl
    });
    setIsModalOpen(true);
  };

  const closeCatalogModel = () => {
    setModalContent({
      catalogName: '',
      imageUrl: '',
      itemsRemaining: 0
    });
    setIsModalOpen(false);
  };

  const handleTabChange = (_ref3, event) => {
    let {
      id
    } = _ref3;
    event.nativeEvent.stopImmediatePropagation();

    if (id === activeTabId) {
      setActiveTabId(catalog/* ROOT_CATALOG_ID */.rs);
    } else {
      setActiveTabId(id);
    }

    if (id === catalog/* OUR_PLATFORM_ID */.fD) {
      (0,utils_window/* navigateToPage */.ru)(routes/* OUR_PLATFORM_URL */.Nc0);
    }
  };

  const handleTitleClick = event => {
    event.preventDefault();
  };

  const renderTabTitle = (url, title, testId) => /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
    className: "nav-links",
    role: "button",
    href: url,
    onClick: handleTitleClick,
    "data-testid": testId,
    tabIndex: -1,
    children: title
  });

  const renderTabContent = item => /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    id: "nav-menu-".concat(item.id),
    "aria-hidden": item.id !== activeTabId,
    "data-testid": "category-panel-".concat(item.id),
    className: classnames_default()('u-padding-none', {
      'is-active': item.id === activeTabId
    }),
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(CategoriesPanel_CategoriesPanel, {
      rootCategory: item,
      triggerCatalogModal: openCatalogModal
    })
  }, item.id);

  const renderAboutTabContent = isAboutPanelActive => /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    id: "nav-menu-about",
    "aria-hidden": !isAboutPanelActive,
    "data-testid": "category-panel-about",
    className: classnames_default()('u-padding-none', {
      'is-active': isAboutPanelActive
    }),
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(AboutPanel_AboutPanel, {
      impressumUrl: impressumUrl,
      isBusinessAccountLinksVisible: isBusinessAccountLinksVisible
    })
  });

  const getTabItems = () => {
    const newList = [];
    const isAboutPanelActive = activeTabId === catalog/* ABOUT_TAB_ID */.fN;
    transformedTree.forEach(item => {
      newList.push({
        id: item.id,
        title: renderTabTitle(item.url, item.title, "nav-tab-".concat(item.id)),
        aria: {
          'aria-expanded': activeTabId === item.id,
          'aria-controls': "nav-menu-".concat(item.id),
          'aria-label': item.title
        },
        contentExperimental: renderTabContent(item)
      });
    });
    newList.push({
      id: catalog/* ABOUT_TAB_ID */.fN,
      title: renderTabTitle(routes/* MAIN_NAVIGATION_ABOUT_TAB_URL */.ouD, translate('tabs.about'), 'nav-tab-about'),
      aria: {
        'aria-expanded': isAboutPanelActive,
        'aria-controls': 'nav-menu-about',
        'aria-label': translate('tabs.about')
      },
      contentExperimental: renderAboutTabContent(isAboutPanelActive)
    });

    if (isOurPlatformVisible) {
      newList.push({
        id: catalog/* OUR_PLATFORM_ID */.fD,
        title: renderTabTitle(routes/* OUR_PLATFORM_URL */.Nc0, translate('tabs.platform'), 'nav-tab-platform'),
        aria: {
          'aria-label': translate('tabs.platform')
        }
      });
    }

    return newList;
  };

  const handleClick = (0,react.useCallback)(() => {
    setActiveTabId(catalog/* ROOT_CATALOG_ID */.rs);
  }, []);
  (0,react.useEffect)(() => {
    if (activeTabId !== catalog/* ROOT_CATALOG_ID */.rs) {
      document.addEventListener('click', handleClick);
    }

    return () => document.removeEventListener('click', handleClick);
  }, [activeTabId, handleClick]);
  (0,react.useEffect)(() => {
    if (activeTabId === catalog/* ROOT_CATALOG_ID */.rs || activeTabId === catalog/* ABOUT_TAB_ID */.fN || activeTabId === catalog/* OUR_PLATFORM_ID */.fD) return;
    const trakingEvent = (0,events/* clickEvent */.Q5)({
      target: clickable_elements/* ClickableElement.CatalogTab */.U.CatalogTab,
      targetDetails: "".concat(activeTabId)
    });
    track(trakingEvent);
  }, [activeTabId, track]);
  const title = translate('catalogs.new.title', {
    name: modalContent.catalogName
  });
  const description = translate('catalogs.new.details', {
    count: modalContent.itemsRemaining
  }, {
    count: modalContent.itemsRemaining
  });
  const imageUrl = modalContent.imageUrl || undefined;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("nav", {
      className: "u-fit-content-width",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Tabs/* default */.Z, {
        items: getTabItems(),
        activeItemId: activeTabId,
        onClick: handleTabChange,
        role: "menu"
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Modal/* default */.Z, {
      show: isModalOpen,
      closeOnOverlay: true,
      defaultCallback: closeCatalogModel,
      imageUrl: imageUrl,
      title: title,
      body: description,
      actions: [{
        text: translate('catalogs.new.actions.upload'),
        style: Modal/* default.ActionStyling.Filled */.Z.ActionStyling.Filled,
        url: routes/* ITEM_UPLOAD_URL */.UNR
      }, {
        text: translate('catalogs.new.actions.close'),
        style: Modal/* default.ActionStyling.Flat */.Z.ActionStyling.Flat,
        callback: closeCatalogModel
      }]
    })]
  });
};

/* harmony default export */ var CatalogNavigation_CatalogNavigation = (CatalogNavigation);
// EXTERNAL MODULE: ../app/hooks/useRefUrl/useRefUrl.ts
var useRefUrl = __webpack_require__(59370);
// EXTERNAL MODULE: ../app/libs/utils/url.ts
var utils_url = __webpack_require__(18697);
// EXTERNAL MODULE: ../app/state/auth/slice.ts
var auth_slice = __webpack_require__(85314);
// EXTERNAL MODULE: ../app/state/auth/selectors.ts
var auth_selectors = __webpack_require__(64262);
;// CONCATENATED MODULE: ../app/components/Header/HeaderLoginButton/HeaderLoginButton.tsx













const HeaderLoginButton = () => {
  const dispatch = (0,es/* useDispatch */.I0)();
  const refUrl = (0,useRefUrl/* default */.Z)();
  const translate = (0,useTranslate/* default */.Z)();
  const {
    track
  } = (0,useTracking/* default */.Z)();
  const isAuthPageOpen = (0,es/* useSelector */.v9)(auth_selectors/* getIsAuthPageOpen */.Df);

  function handleClick(event) {
    track((0,events/* clickEvent */.Q5)({
      target: clickable_elements/* ClickableElement.Login */.U.Login
    }));
    if (isAuthPageOpen) return;
    event.preventDefault();
    dispatch(auth_slice/* actions.openAuthModal */.Nw.openAuthModal());
  }

  return /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* ButtonWithForwardedRef */.I, {
    text: translate('header.actions.login'),
    size: Button/* ButtonWithForwardedRef.Size.Small */.I.Size.Small,
    url: "".concat(routes/* SIGNUP_URL */.iGV, "?").concat((0,utils_url/* toUrlQuery */.Kf)({
      ref_url: refUrl
    })),
    onClick: handleClick,
    testId: "header--login-button"
  });
};

/* harmony default export */ var HeaderLoginButton_HeaderLoginButton = (HeaderLoginButton);
// EXTERNAL MODULE: ../node_modules/.pnpm/@vinted+web-ui@39.0.0_@types+react@18.2.21_react-dom@18.2.0_react-lottie-player@1.5.4_react@18.2.0/node_modules/@vinted/web-ui/dist/esm/constants/ui.js
var ui = __webpack_require__(88067);
;// CONCATENATED MODULE: ../app/components/Header/HeaderToggleMobileMenu/HeaderToggleMobileMenu.tsx







const HeaderToggleMobileMenu = _ref => {
  let {
    isActive,
    onToggle
  } = _ref;
  const {
    track
  } = (0,useTracking/* default */.Z)();
  const translate = (0,useTranslate/* default */.Z)('header');

  function trackClick() {
    track((0,events/* clickEvent */.Q5)({
      target: clickable_elements/* ClickableElement.NavigationMenuToggle */.U.NavigationMenuToggle
    }));
  }

  function handleToggleClick() {
    trackClick();
    onToggle();
  }

  const icon = isActive ? 'x' : 'menu';
  const menuKey = isActive ? 'close' : 'open';
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* ButtonWithForwardedRef */.I, {
    onClick: handleToggleClick,
    deprecatedIconName: icon,
    deprecatedIconColor: ui/* ColorCode.GreyscaleLevel3 */.S.GreyscaleLevel3,
    styling: Button/* ButtonWithForwardedRef.Styling.Flat */.I.Styling.Flat,
    aria: {
      'aria-label': translate("a11y.menu.".concat(menuKey))
    }
  });
};

/* harmony default export */ var HeaderToggleMobileMenu_HeaderToggleMobileMenu = (HeaderToggleMobileMenu);
;// CONCATENATED MODULE: ../app/components/Header/HeaderUploadItem/HeaderUploadItem.tsx











const HeaderUploadItem = () => {
  const userId = (0,es/* useSelector */.v9)(session_selectors/* getUserId */.n5);
  const translate = (0,useTranslate/* default */.Z)();
  const {
    track
  } = (0,useTracking/* default */.Z)();

  function handleAnchorClick() {
    track((0,events/* clickEvent */.Q5)({
      target: clickable_elements/* ClickableElement.UploadItem */.U.UploadItem
    }));
  }

  return /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* ButtonWithForwardedRef */.I, {
    text: translate('header.actions.upload_item'),
    styling: Button/* ButtonWithForwardedRef.Styling.Filled */.I.Styling.Filled,
    size: Button/* ButtonWithForwardedRef.Size.Small */.I.Size.Small,
    url: userId ? routes/* ITEM_UPLOAD_URL */.UNR : "".concat(routes/* SIGNUP_URL */.iGV, "?").concat((0,utils_url/* toUrlQuery */.Kf)({
      ref_url: routes/* ITEM_UPLOAD_URL */.UNR
    })),
    rel: "nofollow",
    onClick: handleAnchorClick
  });
};

/* harmony default export */ var HeaderUploadItem_HeaderUploadItem = (HeaderUploadItem);
// EXTERNAL MODULE: ../app/hooks/useUserStats/useUserStats.ts + 1 modules
var useUserStats = __webpack_require__(57190);
// EXTERNAL MODULE: ../app/constants/routes/inbox.ts
var inbox = __webpack_require__(99417);
// EXTERNAL MODULE: ../app/libs/common/braze/hooks/useBrazeInboxMessageCards.ts
var useBrazeInboxMessageCards = __webpack_require__(4535);
;// CONCATENATED MODULE: ../app/components/Header/HeaderUserActions/HeaderConversations/HeaderConversations.tsx







const MAX_BADGE_COUNT = 99;

const HeaderConversations = _ref => {
  var _inboxMessageCards$fi;

  let {
    unreadConversationCount = 0
  } = _ref;
  const translate = (0,useTranslate/* default */.Z)('header.a11y.conversations');
  const {
    inboxMessageCards
  } = (0,useBrazeInboxMessageCards/* default */.Z)();
  const brazeConversationCount = (_inboxMessageCards$fi = inboxMessageCards === null || inboxMessageCards === void 0 ? void 0 : inboxMessageCards.filter(card => !card.viewed).length) !== null && _inboxMessageCards$fi !== void 0 ? _inboxMessageCards$fi : 0;
  const mergedConversationCount = unreadConversationCount + brazeConversationCount;
  const badgeConversationCount = inboxMessageCards ? Math.min(mergedConversationCount, MAX_BADGE_COUNT) : 0;
  const badgeSuffix = mergedConversationCount > MAX_BADGE_COUNT ? '+' : '';
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Button/* ButtonWithForwardedRef */.I, {
      testId: "header-notification-button",
      styling: Button/* ButtonWithForwardedRef.Styling.Flat */.I.Styling.Flat,
      deprecatedIcon: /*#__PURE__*/(0,jsx_runtime.jsx)(DeprecatedIcon/* default */.Z, {
        name: "envelope",
        size: DeprecatedIcon/* default.Size.Regular */.Z.Size.Regular,
        color: DeprecatedIcon/* default.Color.GreyscaleLevel4 */.Z.Color.GreyscaleLevel4,
        aria: {
          'aria-label': mergedConversationCount ? translate('new_conversations', {
            count: mergedConversationCount
          }) : translate('conversations')
        }
      }),
      url: inbox/* INBOX_URL */.ZQ
    }), !!badgeConversationCount && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "user-actions__notification",
      "data-testid": "conversations-badge",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Badge/* default */.Z, {
        content: /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          "aria-hidden": "true",
          children: "".concat(badgeConversationCount).concat(badgeSuffix)
        }),
        theme: "warning"
      })
    })]
  });
};

/* harmony default export */ var HeaderConversations_HeaderConversations = (HeaderConversations);
// EXTERNAL MODULE: ../app/components/OutsideClick/OutsideClick.tsx
var OutsideClick = __webpack_require__(78870);
// EXTERNAL MODULE: ../app/constants/ui.ts
var constants_ui = __webpack_require__(55370);
// EXTERNAL MODULE: ../app/hooks/useFetchInboxNotifications.ts + 3 modules
var useFetchInboxNotifications = __webpack_require__(18475);
// EXTERNAL MODULE: ../app/libs/common/braze/hooks/useBrazeControlCardImpressionLogging.ts
var useBrazeControlCardImpressionLogging = __webpack_require__(78526);
// EXTERNAL MODULE: ../node_modules/.pnpm/@vinted+web-ui@39.0.0_@types+react@18.2.21_react-dom@18.2.0_react-lottie-player@1.5.4_react@18.2.0/node_modules/@vinted/web-ui/dist/esm/lib/Loader/Loader.js
var Loader = __webpack_require__(97677);
// EXTERNAL MODULE: ../node_modules/.pnpm/@vinted+web-ui@39.0.0_@types+react@18.2.21_react-dom@18.2.0_react-lottie-player@1.5.4_react@18.2.0/node_modules/@vinted/web-ui/dist/esm/lib/Animation/Animation.js + 3 modules
var Animation = __webpack_require__(19968);
// EXTERNAL MODULE: ../app/hooks/useInboxNotificationEvents.ts
var useInboxNotificationEvents = __webpack_require__(22194);
// EXTERNAL MODULE: ../app/components/ScrollableArea/ScrollableArea.tsx
var ScrollableArea = __webpack_require__(48846);
// EXTERNAL MODULE: ../app/components/SeparatedList/SeparatedList.tsx
var SeparatedList = __webpack_require__(31214);
// EXTERNAL MODULE: ../app/components/InboxNotificationItem/InboxNotificationItem.tsx
var InboxNotificationItem = __webpack_require__(97274);
;// CONCATENATED MODULE: ../app/components/Header/HeaderUserActions/HeaderNotifications/HeaderNotificationDropdown.tsx










const HeaderNotificationDropdown = _ref => {
  let {
    notifications,
    isLoading
  } = _ref;
  const translate = (0,useTranslate/* default */.Z)();
  const {
    onClick,
    onEnter
  } = (0,useInboxNotificationEvents/* default */.Z)();

  function renderNotification(notification) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(InboxNotificationItem/* default */.Z, {
      notification: notification,
      onClick: onClick(notification),
      onEnter: onEnter(notification),
      defaultHighlighted: !notification.isViewed
    }, notification.id);
  }

  if (isLoading) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "u-ui-margin-x-large u-flexbox u-justify-content-center",
      "data-testid": "loader",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Loader/* default */.Z, {
        size: Loader/* default.Size.Large */.Z.Size.Large
      })
    });
  }

  if (!notifications.length) {
    return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "u-ui-margin-vertical-x-large u-ui-margin-horizontal-x2-large u-flexbox u-flex-direction-column u-align-items-center",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Animation/* default */.Z, {
        animationUrl: "/assets/animations/notifications-empty-state.json",
        size: Animation/* default.Size.Large */.Z.Size.Large
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* default */.Z, {
        size: Spacer/* default.Size.Large */.Z.Size.Large
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Text/* default */.Z, {
        text: translate('header.notifications.empty_state.title'),
        alignment: Text/* default.Alignment.Center */.Z.Alignment.Center,
        type: Text/* default.Type.Title */.Z.Type.Title
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* default */.Z, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(Text/* default */.Z, {
        text: translate('header.notifications.empty_state.body'),
        alignment: Text/* default.Alignment.Center */.Z.Alignment.Center,
        type: Text/* default.Type.Body */.Z.Type.Body,
        html: true
      })]
    });
  }

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ScrollableArea/* default */.Z, {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "header-notification-dropdown__container",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(SeparatedList/* default */.Z, {
          separator: /*#__PURE__*/(0,jsx_runtime.jsx)(Divider/* default */.Z, {}),
          children: notifications.map(renderNotification)
        })
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "header-notification-dropdown__button-container",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* ButtonWithForwardedRef */.I, {
        url: routes/* NOTIFICATIONS_URL */.CqN,
        text: translate('header.notifications.see_all'),
        size: Button/* ButtonWithForwardedRef.Size.Medium */.I.Size.Medium
      })
    })]
  });
};

/* harmony default export */ var HeaderNotifications_HeaderNotificationDropdown = (HeaderNotificationDropdown);
;// CONCATENATED MODULE: ../app/components/Header/HeaderUserActions/HeaderNotifications/HeaderNotifications.tsx


function HeaderNotifications_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function HeaderNotifications_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? HeaderNotifications_ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : HeaderNotifications_ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}












const MAX_NOTIFICATIONS_AMOUNT = 5;
const HeaderNotifications_MAX_BADGE_COUNT = 99;

const HeaderNotifications = _ref => {
  let {
    unreadNotificationCount = 0,
    onNotificationsFetched
  } = _ref;
  const translate = (0,useTranslate/* default */.Z)('header.a11y.notifications');
  const {
    0: isDropdownVisible,
    1: setIsDropdownVisible
  } = (0,react.useState)(false);
  const {
    notifications,
    controlNotificationCards,
    setNotifications,
    brazeNotificationCount,
    uiState,
    setUiState
  } = (0,useFetchInboxNotifications/* default */.Z)();
  (0,useBrazeControlCardImpressionLogging/* default */.Z)(isDropdownVisible && controlNotificationCards ? controlNotificationCards.map(_ref2 => {
    let {
      id
    } = _ref2;
    return id;
  }) : []);
  (0,react.useEffect)(() => {
    if (uiState === constants_ui/* UiState.Success */.C.Success) onNotificationsFetched === null || onNotificationsFetched === void 0 ? void 0 : onNotificationsFetched();
  }, [uiState, onNotificationsFetched]);

  function handleDropdownVisibilityChange() {
    const wasVisible = isDropdownVisible;

    if (wasVisible) {
      setNotifications(items => items.map(item => item.isViewed ? item : HeaderNotifications_objectSpread(HeaderNotifications_objectSpread({}, item), {}, {
        isViewed: true
      })));
    }

    if (!wasVisible && (uiState === constants_ui/* UiState.Idle */.C.Idle || uiState === constants_ui/* UiState.Failure */.C.Failure)) {
      // TODO: [KK-1444] refactor to fetch notifications explicitly
      setUiState(constants_ui/* UiState.Pending */.C.Pending);
    }

    setIsDropdownVisible(!wasVisible);
  }

  function handleClick(event) {
    event.preventDefault();
    handleDropdownVisibilityChange();
  }

  function handleOutsideClick() {
    if (!isDropdownVisible) return;
    handleDropdownVisibilityChange();
  }

  const mergedNotificationCount = unreadNotificationCount + brazeNotificationCount;
  const badgeNotificationCount = Math.min(mergedNotificationCount, HeaderNotifications_MAX_BADGE_COUNT);
  const notificationSuffix = mergedNotificationCount > HeaderNotifications_MAX_BADGE_COUNT ? '+' : '';
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(OutsideClick/* default */.Z, {
    onOutsideClick: handleOutsideClick,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Button/* ButtonWithForwardedRef */.I, {
      testId: "header-notification-button",
      onClick: handleClick,
      styling: Button/* ButtonWithForwardedRef.Styling.Flat */.I.Styling.Flat,
      deprecatedIcon: /*#__PURE__*/(0,jsx_runtime.jsx)(DeprecatedIcon/* default */.Z, {
        name: "bell",
        size: DeprecatedIcon/* default.Size.Regular */.Z.Size.Regular,
        color: DeprecatedIcon/* default.Color.GreyscaleLevel4 */.Z.Color.GreyscaleLevel4,
        aria: {
          'aria-label': mergedNotificationCount ? translate('new_notifications', {
            count: mergedNotificationCount
          }) : translate('notifications')
        }
      }),
      url: routes/* NOTIFICATIONS_URL */.CqN
    }), !!badgeNotificationCount && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "user-actions__notification",
      "data-testid": "header-notifications-badge",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Badge/* default */.Z, {
        content: /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          "aria-hidden": "true",
          children: "".concat(badgeNotificationCount).concat(notificationSuffix)
        }),
        theme: "warning"
      })
    }), isDropdownVisible && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "header-notification-dropdown",
      "data-testid": "header-notification-dropdown",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(HeaderNotifications_HeaderNotificationDropdown, {
        isLoading: uiState === constants_ui/* UiState.Pending */.C.Pending,
        notifications: notifications.slice(0, MAX_NOTIFICATIONS_AMOUNT)
      })
    })]
  });
};

/* harmony default export */ var HeaderNotifications_HeaderNotifications = (HeaderNotifications);
;// CONCATENATED MODULE: ../app/components/Header/HeaderUserActions/HeaderUserActions.tsx











const HeaderUserActions = () => {
  const translate = (0,useTranslate/* default */.Z)('header');
  const {
    userStats,
    fetchUserStats
  } = (0,useUserStats/* default */.Z)();
  const {
    unreadMsgCount: unreadConversationCount = 0,
    unreadNotificationCount = 0
  } = userStats !== null && userStats !== void 0 ? userStats : {};
  const handleNotificationsFetched = (0,react.useCallback)(() => {
    if (unreadNotificationCount > 0) fetchUserStats();
  }, [unreadNotificationCount, fetchUserStats]);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "user-actions__action",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(HeaderConversations_HeaderConversations, {
        unreadConversationCount: unreadConversationCount
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "user-actions__action",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(HeaderNotifications_HeaderNotifications // When fetching the notifications, we tell the backend to mark ALL notifications as read.
      // To make sure that the stats reflect that, we refetch the stats *after* we fetch the notifications
      , {
        onNotificationsFetched: handleNotificationsFetched,
        unreadNotificationCount: unreadNotificationCount
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "user-actions__action",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* ButtonWithForwardedRef */.I, {
        deprecatedIconName: "heart",
        deprecatedIconColor: ui/* ColorCode.GreyscaleLevel4 */.S.GreyscaleLevel4,
        styling: Button/* ButtonWithForwardedRef.Styling.Flat */.I.Styling.Flat,
        url: routes/* USER_FAVOURITE_ITEMS_URL */.eUh,
        aria: {
          'aria-label': translate('a11y.favorited_items')
        }
      })
    })]
  });
};

/* harmony default export */ var HeaderUserActions_HeaderUserActions = (HeaderUserActions);
// EXTERNAL MODULE: ../node_modules/.pnpm/@vinted+web-ui@39.0.0_@types+react@18.2.21_react-dom@18.2.0_react-lottie-player@1.5.4_react@18.2.0/node_modules/@vinted/web-ui/dist/esm/lib/InputBar/InputBar.js
var InputBar = __webpack_require__(63024);
// EXTERNAL MODULE: ../node_modules/.pnpm/uuid@3.4.0/node_modules/uuid/index.js
var uuid = __webpack_require__(44275);
var uuid_default = /*#__PURE__*/__webpack_require__.n(uuid);
// EXTERNAL MODULE: ../app/constants/search.ts
var search = __webpack_require__(16092);
// EXTERNAL MODULE: ../app/constants/help-center.ts
var help_center = __webpack_require__(35045);
// EXTERNAL MODULE: ../app/constants/tracking/search.ts
var tracking_search = __webpack_require__(89435);
// EXTERNAL MODULE: ../node_modules/.pnpm/react-waypoint@10.3.0_react@18.2.0/node_modules/react-waypoint/es/index.js + 3 modules
var react_waypoint_es = __webpack_require__(72963);
// EXTERNAL MODULE: ../app/components/List/List.tsx
var List = __webpack_require__(78866);
// EXTERNAL MODULE: ../app/state/search-suggestions/slice.ts
var search_suggestions_slice = __webpack_require__(65901);
;// CONCATENATED MODULE: ../app/components/SearchSuggestions/SearchSuggestions.tsx


function SearchSuggestions_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function SearchSuggestions_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? SearchSuggestions_ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : SearchSuggestions_ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}
















const SearchSuggestions = _ref => {
  let {
    query,
    items,
    highlightedIndex,
    searchSessionId,
    globalSearchSessionId,
    suggestionUrl,
    setSuggestionsSessionId,
    suggestionsListId,
    onSuggestionClick = lodash.noop
  } = _ref;
  const {
    track
  } = (0,useTracking/* default */.Z)();
  const dispatch = (0,es/* useDispatch */.I0)();
  const prevItems = (0,react.useRef)();
  const trackedQuery = (0,react.useRef)(query);
  const suggestionsSessionId = (0,react.useRef)(null);
  const shouldAddViewSearchSuggestionEvent = (0,es/* useSelector */.v9)((0,feature_switches_selectors/* getIsFeatureSwitchEnabled */.z)('web_add_view_search_suggestion_event'));
  (0,react.useEffect)(() => {
    suggestionsSessionId.current = uuid_default().v4();
    setSuggestionsSessionId(suggestionsSessionId.current);
  }, [setSuggestionsSessionId]);
  (0,react.useEffect)(() => {
    trackedQuery.current = query;
  }, [query]);
  (0,react.useEffect)(() => {
    if (!items.length || (0,lodash.isEqual)(prevItems.current, items)) return;
    track((0,events/* viewSearchSuggestionsEvent */.ty)({
      suggestions: items.map(item => item.query),
      query: trackedQuery.current,
      suggestionsSessionId: suggestionsSessionId.current
    }));
    prevItems.current = items;
  }, [track, items]);
  (0,react.useEffect)(() => () => {
    dispatch(search_suggestions_slice/* actions.clearSuggestions */.Nw.clearSuggestions());
  }, [dispatch]);

  const handleItemClick = (suggestion, index) => event => {
    const scopedSuggestions = items.filter(item => item.type === search/* SearchSuggestionType.Scoped */.aS.Scoped);
    onSuggestionClick(suggestion, index, scopedSuggestions.length, event);
  };

  const getSuggestionKey = suggestion => {
    if (suggestion.type === search/* SearchSuggestionType.Scoped */.aS.Scoped) {
      return [suggestion.id, (0,lodash.kebabCase)(suggestion.subtitle)].join('-');
    }

    return suggestion.id;
  };

  const getHighlightedTitle = suggestionTitle => {
    const escapedQuery = (0,lodash.escape)(query);
    const escapedSuggestionTitle = (0,lodash.escape)(suggestionTitle);
    return escapedSuggestionTitle.replace(new RegExp("^".concat((0,lodash.escapeRegExp)(escapedQuery)), 'i'), '<b>$&</b>');
  };

  const renderSuggestion = (suggestion, index) => {
    const cellProps = {
      type: Cell/* default.Type.Navigating */.Z.Type.Navigating,
      url: suggestionUrl(suggestion),
      highlighted: highlightedIndex === index,
      testId: "suggestion-".concat(suggestion.id)
    };

    switch (suggestion.type) {
      case search/* SearchSuggestionType.Scoped */.aS.Scoped:
        return /*#__PURE__*/(0,react.createElement)(Cell/* default */.Z, SearchSuggestions_objectSpread(SearchSuggestions_objectSpread({}, cellProps), {}, {
          onClick: handleItemClick(suggestion, index),
          key: getSuggestionKey(suggestion)
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Text/* default */.Z, {
          theme: "amplified",
          text: getHighlightedTitle(suggestion.title),
          html: true,
          highlight: true,
          highlightTheme: "muted"
        }), ' ', /*#__PURE__*/(0,jsx_runtime.jsx)(Text/* default */.Z, {
          text: suggestion.subtitle,
          type: Text/* default.Type.Subtitle */.Z.Type.Subtitle,
          theme: "primary",
          as: "span"
        }));

      case search/* SearchSuggestionType.Multiword */.aS.Multiword:
      case search/* SearchSuggestionType.Brand */.aS.Brand:
      case search/* SearchSuggestionType.Catalog */.aS.Catalog:
        {
          return /*#__PURE__*/(0,react.createElement)(Cell/* default */.Z, SearchSuggestions_objectSpread(SearchSuggestions_objectSpread({}, cellProps), {}, {
            onClick: handleItemClick(suggestion, index),
            key: getSuggestionKey(suggestion)
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(Text/* default */.Z, {
            theme: "amplified",
            text: getHighlightedTitle(suggestion.title),
            html: true,
            highlight: true,
            highlightTheme: "muted"
          }));
        }

      case search/* SearchSuggestionType.Fallback */.aS.Fallback:
        return /*#__PURE__*/(0,react.createElement)(Cell/* default */.Z, SearchSuggestions_objectSpread(SearchSuggestions_objectSpread({}, cellProps), {}, {
          onClick: handleItemClick(suggestion, index),
          title: suggestion.title,
          key: getSuggestionKey(suggestion)
        }));

      default:
        return null;
    }
  };

  const handleItemView = (item, index) => () => {
    const isFrontendGeneratedTextSelected = item.type === search/* SearchSuggestionType.Fallback */.aS.Fallback;
    const trackingArgs = {
      frontendGeneratedTextSelected: isFrontendGeneratedTextSelected,
      globalSearchSessionId,
      query: item.query,
      searchSessionId: searchSessionId || null,
      selectedSuggestionText: isFrontendGeneratedTextSelected ? item.query : item.title,
      suggestionPosition: index + 1,
      suggestionsListId,
      suggestionsSessionId: suggestionsSessionId.current
    };

    if ('params' in item) {
      trackingArgs.params = item.params;
    }

    track((0,events/* viewSearchSuggestionEvent */.LY)(trackingArgs));
  };

  const renderSuggestions = suggestions => /*#__PURE__*/(0,jsx_runtime.jsx)(List/* default */.Z, {
    children: suggestions.map((suggestion, index) => /*#__PURE__*/(0,jsx_runtime.jsx)(react_waypoint_es/* Waypoint */.h, {
      onEnter: handleItemView(suggestion, index),
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        children: renderSuggestion(suggestion, index)
      })
    }, getSuggestionKey(suggestion)))
  });

  if (!items.length) return null;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Cell/* default */.Z, {
    styling: Cell/* default.Styling.Tight */.Z.Styling.Tight,
    children: shouldAddViewSearchSuggestionEvent ? renderSuggestions(items) : /*#__PURE__*/(0,jsx_runtime.jsx)(List/* default */.Z, {
      children: items.map((item, index) => renderSuggestion(item, index))
    })
  });
};

/* harmony default export */ var SearchSuggestions_SearchSuggestions = (SearchSuggestions);
// EXTERNAL MODULE: ../app/components/ListNavigator/ListNavigator.tsx
var ListNavigator = __webpack_require__(11150);
// EXTERNAL MODULE: ../app/constants/filter.ts
var filter = __webpack_require__(35486);
// EXTERNAL MODULE: ../app/libs/utils/object.ts
var object = __webpack_require__(22134);
;// CONCATENATED MODULE: ../app/state/saved-searches/transformers/search-dto-to-url-params.ts


const searchDtoToUrlParams = search => {
  var _search$price_from, _search$price_to, _search$price_from2, _search$price_to2;

  const {
    search_text
  } = search;
  const disposal = ['is_for_sell'].filter(option => search[option]).map(option => "search_".concat(option));
  const params = {
    search_text,
    brand_ids: search.brands.map(it => it.id),
    color_ids: search.color_ids,
    size_ids: search.size_ids,
    status_ids: search.status_ids,
    catalog: (0,lodash.compact)([search.catalog_id]),
    material_ids: search.material_ids,
    video_game_rating_ids: search.video_game_rating_ids,
    disposal: (0,lodash.compact)(disposal),
    price_from: (_search$price_from = search.price_from) === null || _search$price_from === void 0 ? void 0 : _search$price_from.amount,
    price_to: (_search$price_to = search.price_to) === null || _search$price_to === void 0 ? void 0 : _search$price_to.amount,
    currency: ((_search$price_from2 = search.price_from) === null || _search$price_from2 === void 0 ? void 0 : _search$price_from2.currency_code) || ((_search$price_to2 = search.price_to) === null || _search$price_to2 === void 0 ? void 0 : _search$price_to2.currency_code)
  };
  return (0,object/* filterEmptyValues */.Gj)(params);
};
;// CONCATENATED MODULE: ../app/components/SavedSearches/SavedSearchesList/SavedSearchesList.tsx


function SavedSearchesList_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function SavedSearchesList_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? SavedSearchesList_ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : SavedSearchesList_ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}













const SavedSearchesList = _ref => {
  let {
    searches,
    searchUrl,
    highlightedIndex,
    searchSessionId,
    globalSearchSessionId,
    onSearchClick,
    onSubscribeClick
  } = _ref;
  const translate = (0,useTranslate/* default */.Z)('saved_searches');
  const {
    track
  } = (0,useTracking/* default */.Z)();
  const activeSavedSearchRef = (0,react.useRef)(null);
  (0,react.useEffect)(() => {
    var _activeSavedSearchRef;

    (_activeSavedSearchRef = activeSavedSearchRef.current) === null || _activeSavedSearchRef === void 0 ? void 0 : _activeSavedSearchRef.scrollIntoView({
      behavior: 'smooth',
      block: 'nearest'
    });
  }, [highlightedIndex]);

  const onItemClick = search => event => {
    if (onSearchClick) onSearchClick(search, event);
  };

  const onSearchSubscribeClick = search => event => {
    event.stopPropagation();
    event.preventDefault();
    track((0,events/* toggleSearchSubscriptionEvent */.hM)({
      searchSessionId,
      isSubscribing: !search.subscribed,
      searchTitle: search.title,
      searchQuery: search.search_text,
      globalSearchSessionId
    }));
    if (onSubscribeClick) onSubscribeClick(search, event);
  };

  function renderSavedSearchSuffix(search) {
    const iconColor = search.subscribed ? DeprecatedIcon/* default.Color.Primary */.Z.Color.Primary : DeprecatedIcon/* default.Color.GreyscaleLevel1 */.Z.Color.GreyscaleLevel1;
    const iconName = search.subscribed ? 'bookmark-filled' : 'bookmark';
    return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "u-position-relative u-zindex-bump",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* ButtonWithForwardedRef */.I, {
        deprecatedIcon: /*#__PURE__*/(0,jsx_runtime.jsx)(DeprecatedIcon/* default */.Z, {
          name: iconName,
          color: iconColor,
          title: search.subscribed ? translate('a11y.remove_saved_search', {
            title: search.title
          }) : translate('a11y.save_search', {
            title: search.title
          })
        }),
        styling: Button/* ButtonWithForwardedRef.Styling.Flat */.I.Styling.Flat,
        theme: "muted",
        testId: "subscription-toggle",
        onClick: onSearchSubscribeClick(search)
      })
    });
  }

  function renderSavedSearchTitle(title, newItemsCount) {
    return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "u-flexbox",
      children: [!!newItemsCount && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "u-ui-padding-right-small",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(Text/* default */.Z, {
          text: "+".concat(newItemsCount),
          theme: "primary"
        })
      }), title]
    });
  }

  const renderSavedSearch = _ref2 => {
    let {
      search,
      index
    } = _ref2;
    const {
      id,
      title,
      subtitle,
      new_items_count: newItemsCount
    } = search;

    const params = SavedSearchesList_objectSpread(SavedSearchesList_objectSpread({}, searchDtoToUrlParams(search)), {}, {
      search_id: id,
      order: filter/* SortByOption.NewestFirst */.IE.NewestFirst
    });

    const url = "".concat(searchUrl, "?").concat((0,utils_url/* toUrlQuery */.Kf)(params));
    const isHighlighted = index === highlightedIndex;
    return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      ref: isHighlighted ? activeSavedSearchRef : null,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Cell/* default */.Z, {
        type: Cell/* default.Type.Navigating */.Z.Type.Navigating,
        title: renderSavedSearchTitle(title, newItemsCount),
        suffix: renderSavedSearchSuffix(search),
        highlighted: isHighlighted,
        url: url,
        onClick: onItemClick(search),
        aria: {
          'aria-label': search.title
        },
        children: !!subtitle && /*#__PURE__*/(0,jsx_runtime.jsx)(Text/* default */.Z, {
          text: subtitle
        })
      })
    }, id);
  };

  function renderSavedSearches() {
    return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Label/* default */.Z, {
        text: translate('list.title'),
        type: Label/* default.Type.Stacked */.Z.Type.Stacked
      }), searches.map((search, index) => renderSavedSearch({
        search,
        index
      }))]
    });
  }

  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: "saved-searches",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(Cell/* default */.Z, {
      styling: Cell/* default.Styling.Tight */.Z.Styling.Tight,
      testId: "saved-searches",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "saved-searches__content",
        children: renderSavedSearches()
      })
    })
  });
};

/* harmony default export */ var SavedSearchesList_SavedSearchesList = (SavedSearchesList);
;// CONCATENATED MODULE: ../app/components/SavedSearches/SearchSubscribeModal/SearchSubscribeModal.tsx






class SearchSubscribeModal extends react.PureComponent {
  constructor() {
    super(...arguments);

    (0,defineProperty/* default */.Z)(this, "translate", id => this.props.intl.formatMessage({
      id: "saved_searches.first_time_subscribe_modal.".concat(id)
    }));
  }

  render() {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(Modal/* default */.Z, {
      show: this.props.isOpen,
      testId: "search-subscribe-modal",
      title: this.translate('title'),
      body: this.translate('text'),
      actions: [{
        text: this.translate('action'),
        style: Modal/* default.ActionStyling.Filled */.Z.ActionStyling.Filled,
        callback: this.props.onClose,
        testId: 'search-subscribe-modal-close-button'
      }]
    });
  }

}

(0,defineProperty/* default */.Z)(SearchSubscribeModal, "defaultProps", {
  isOpen: false,
  onClose: null
});

/* harmony default export */ var SearchSubscribeModal_SearchSubscribeModal = ((0,injectIntl/* default */.ZP)(SearchSubscribeModal));
// EXTERNAL MODULE: ../app/hooks/useLocation/useLocation.ts
var useLocation = __webpack_require__(62889);
// EXTERNAL MODULE: ../app/state/saved-searches/slice.ts
var saved_searches_slice = __webpack_require__(31042);
// EXTERNAL MODULE: ../app/state/search-suggestions/constants.ts
var search_suggestions_constants = __webpack_require__(27364);
;// CONCATENATED MODULE: ../app/state/search-suggestions/selectors.ts


const localState = state => state[search_suggestions_constants/* stateName */.A];

const getSuggestions = state => localState(state).suggestions;
const getSuggestionsListId = state => localState(state).suggestionsListId;
// EXTERNAL MODULE: ../app/state/catalog-filters/slice.ts
var catalog_filters_slice = __webpack_require__(53145);
// EXTERNAL MODULE: ../app/state/catalog-filters/utils.ts
var utils = __webpack_require__(31787);
// EXTERNAL MODULE: ../app/libs/utils/search.ts
var utils_search = __webpack_require__(95084);
;// CONCATENATED MODULE: ../app/components/Header/SearchBar/TypeSelector/TypeSelector.tsx









const SEARCH_TYPES = [search/* SearchBarSearchType.Item */.lz.Item, search/* SearchBarSearchType.User */.lz.User, search/* SearchBarSearchType.Forum */.lz.Forum, search/* SearchBarSearchType.Faq */.lz.Faq];
const SELECTOR_DROPDOWN_WIDTH = 150;

const TypeSelector_mapStateToProps = state => ({
  isForumDisabled: (0,feature_switches_selectors/* getIsFeatureSwitchEnabled */.z)('disable_forum_web')(state)
});

const TypeSelector_connector = (0,es/* connect */.$j)(TypeSelector_mapStateToProps);

class TypeSelector extends react.Component {
  constructor() {
    super(...arguments);

    (0,defineProperty/* default */.Z)(this, "translate", id => this.props.intl.formatMessage({
      id: "searchbar.".concat(id)
    }));

    (0,defineProperty/* default */.Z)(this, "handleButtonClick", () => {
      if (this.props.onClick) this.props.onClick();
    });

    (0,defineProperty/* default */.Z)(this, "handleTypeClick", searchType => () => {
      if (this.props.onSelect) this.props.onSelect(searchType);
    });
  }

  renderDropdown(searchTypes) {
    if (!this.props.isOpen) return null;
    return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "u-ui-margin-top-regular u-position-absolute",
      style: {
        width: SELECTOR_DROPDOWN_WIDTH
      },
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Card/* default */.Z, {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "u-overflow-hidden",
          children: searchTypes.map(type => /*#__PURE__*/(0,jsx_runtime.jsx)(Cell/* default */.Z, {
            type: Cell/* default.Type.Navigating */.Z.Type.Navigating,
            styling: Cell/* default.Styling.Narrow */.Z.Styling.Narrow,
            onClick: this.handleTypeClick(type),
            testId: "search-bar-search-type-".concat(type),
            children: this.translate("types.".concat(type))
          }, type))
        })
      })
    });
  }

  render() {
    const {
      isForumDisabled
    } = this.props;
    const searchTypes = isForumDisabled ? SEARCH_TYPES.filter(type => type !== search/* SearchBarSearchType.Forum */.lz.Forum) : SEARCH_TYPES;
    const searchType = searchTypes.find(type => type === this.props.selectedType);
    if (!searchType) return null;
    return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "u-position-relative",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Button/* ButtonWithForwardedRef */.I, {
        text: /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          id: "search-".concat(searchType),
          children: this.translate("types.".concat(searchType))
        }),
        styling: Button/* ButtonWithForwardedRef.Styling.Flat */.I.Styling.Flat,
        size: Button/* ButtonWithForwardedRef.Size.Medium */.I.Size.Medium,
        theme: "muted",
        deprecatedIcon: /*#__PURE__*/(0,jsx_runtime.jsx)(DeprecatedIcon/* default */.Z, {
          name: "dropdown",
          size: DeprecatedIcon/* default.Size.Small */.Z.Size.Small,
          color: DeprecatedIcon/* default.Color.GreyscaleLevel3 */.Z.Color.GreyscaleLevel3
        }),
        iconPosition: Button/* ButtonWithForwardedRef.IconPosition.Right */.I.IconPosition.Right,
        onClick: this.handleButtonClick,
        testId: "search-bar-search-type",
        aria: {
          'aria-expanded': this.props.isOpen
        }
      }), this.renderDropdown(searchTypes)]
    });
  }

}

(0,defineProperty/* default */.Z)(TypeSelector, "defaultProps", {
  isOpen: false,
  selectedType: search/* SearchBarSearchType.Item */.lz.Item,
  onClick: null,
  onSelect: null
});

/* harmony default export */ var TypeSelector_TypeSelector = (TypeSelector_connector((0,injectIntl/* default */.ZP)(TypeSelector)));
;// CONCATENATED MODULE: ../app/components/Header/SearchBar/SearchBar.tsx


function SearchBar_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function SearchBar_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? SearchBar_ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : SearchBar_ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}







































const SEARCH_URLS = {
  [search/* SearchBarSearchType.Item */.lz.Item]: routes/* CATALOG_URL */.JXU,
  [search/* SearchBarSearchType.User */.lz.User]: routes/* USER_SEARCH_URL */.hIg,
  [search/* SearchBarSearchType.Faq */.lz.Faq]: routes/* HELP_SEARCH_URL */.ssV,
  [search/* SearchBarSearchType.Forum */.lz.Forum]: routes/* FORUM_SEARCH_URL */.qVU
};

const isSavedSearchesRendered = query => (0,lodash.isEmpty)(query) || query.length < constants/* SEARCH_SUGGESTION_MIN_QUERY_LENGTH */.MW;

const SearchBar = _ref => {
  let {
    searchType: initialSearchType = search/* SearchBarSearchType.Item */.lz.Item,
    isInCatalog = false
  } = _ref;
  const {
    searchParams
  } = (0,useLocation/* default */.Z)();
  const translate = (0,useTranslate/* default */.Z)();
  const {
    track
  } = (0,useTracking/* default */.Z)();
  const dispatch = (0,es/* useDispatch */.I0)();
  const userId = (0,es/* useSelector */.v9)(session_selectors/* getUserId */.n5);
  const isSubscribeModalOpen = (0,es/* useSelector */.v9)(saved_searches_selectors/* getIsSubscribedModalOpen */._m);
  const suggestions = (0,es/* useSelector */.v9)(getSuggestions);
  const savedSearches = (0,es/* useSelector */.v9)(saved_searches_selectors/* getSearches */.zi);
  const selectedCatalogs = (0,es/* useSelector */.v9)(catalog_filters_selectors/* getSelectedCatalogs */.O5);
  const userCountryCode = (0,es/* useSelector */.v9)(session_selectors/* getUserCountryCode */.G6);
  const countryCodeByIp = (0,es/* useSelector */.v9)(session_selectors/* getCountryCodeByIp */.SX);
  const searchSessionId = (0,es/* useSelector */.v9)(catalog_filters_selectors/* getSearchSessionId */.LT);
  const globalSearchSessionId = (0,es/* useSelector */.v9)(catalog_filters_selectors/* getGlobalSearchSessionId */.zO);
  const suggestionsListId = (0,es/* useSelector */.v9)(getSuggestionsListId);
  const isUpdateSelectSearchSuggestionsEventEnabled = (0,es/* useSelector */.v9)((0,feature_switches_selectors/* getIsFeatureSwitchEnabled */.z)('web_update_select_search_suggestions_event'));
  const isUpdateFilterItemsEventEnabled = (0,es/* useSelector */.v9)((0,feature_switches_selectors/* getIsFeatureSwitchEnabled */.z)('web_update_filter_items_event'));
  const isSearchSuggestionsAutofillEnabled = (0,es/* useSelector */.v9)((0,feature_switches_selectors/* getIsFeatureSwitchEnabled */.z)('web_search_suggestions_autofill_when_moving_arrows'));
  const initialQuery = (0,utils_url/* normalizedQueryParam */.pN)(searchParams.search_text);
  const {
    0: query,
    1: setQuery
  } = (0,react.useState)(initialQuery);
  const {
    0: searchType,
    1: setSearchType
  } = (0,react.useState)(initialSearchType);
  const {
    0: isFocused,
    1: setIsFocused
  } = (0,react.useState)(false);
  const {
    0: isTypeSelectorOpen,
    1: setIsTypeSelectorOpen
  } = (0,react.useState)(false);
  const {
    0: selectedSearch,
    1: setSelectedSearch
  } = (0,react.useState)(null);
  const inputRef = (0,react.useRef)(null);
  const suggestionsSessionId = (0,react.useRef)(null);
  const isSavedSearchesFetched = (0,react.useRef)(false);
  (0,react.useEffect)(() => {
    if (!isInCatalog) return;
    dispatch((0,actions/* checkCurrentSearch */.V9)());
  }, [dispatch, isInCatalog]);

  const setSuggestionsSessionId = id => {
    suggestionsSessionId.current = id;
  };

  const requestSearches = () => {
    if (!userId) return;
    dispatch((0,actions/* fetchSearchesRequest */.lT)({
      userId
    }));
    isSavedSearchesFetched.current = true;
  };

  const querySearchSuggestions = queryInput => {
    if (searchType !== search/* SearchBarSearchType.Item */.lz.Item || (0,lodash.isEmpty)(queryInput)) return;

    if (!isSavedSearchesRendered(queryInput)) {
      const title = translate('search_suggestions.suggestion_fallback', {
        query: queryInput
      });
      dispatch(search_suggestions_slice/* actions.fetchSuggestionsRequest */.Nw.fetchSuggestionsRequest({
        query: queryInput
      }, {
        title
      }));
    }
  };

  const focusInput = () => {
    var _inputRef$current;

    return (_inputRef$current = inputRef.current) === null || _inputRef$current === void 0 ? void 0 : _inputRef$current.focus();
  };

  const blurInput = () => {
    var _inputRef$current2;

    return (_inputRef$current2 = inputRef.current) === null || _inputRef$current2 === void 0 ? void 0 : _inputRef$current2.blur();
  };

  const toggleTypeSelector = () => setIsTypeSelectorOpen(prevState => !prevState);

  const searchSuggestionUrl = suggestion => {
    const {
      item: itemSearchUrl
    } = SEARCH_URLS;
    if (isInCatalog) return undefined;

    if (suggestion.type === search/* SearchSuggestionType.Scoped */.aS.Scoped) {
      const filterQuery = (0,utils_url/* toUrlQuery */.Kf)((0,utils/* searchSuggestionToUrlParams */.b0)(suggestion));
      return "".concat(itemSearchUrl, "?").concat(filterQuery);
    }

    return "".concat(itemSearchUrl, "?search_text=").concat(encodeURIComponent(suggestion.query));
  };

  const getPlaceholder = () => {
    const isCatalogPlaceholder = isInCatalog && selectedCatalogs.length;

    if (searchType === search/* SearchBarSearchType.Item */.lz.Item && isCatalogPlaceholder) {
      const catalogName = selectedCatalogs.map(catalog => catalog.title).join(', ');
      return translate("searchbar.placeholder.".concat(searchType, "_with_catalog_selected"), {
        catalog: catalogName
      });
    }

    return translate("searchbar.placeholder.".concat(searchType));
  };

  const handleQueryChange = event => {
    const newQuery = event.currentTarget.value;
    if (!(0,lodash.isEmpty)((0,lodash.trim)(newQuery))) querySearchSuggestions(newQuery);
    setQuery(newQuery);
  };

  const handleValueClear = () => setQuery('');

  const handleTypeSelectorClick = () => {
    setIsFocused(false);
    toggleTypeSelector();
    track((0,events/* clickEvent */.Q5)({
      target: clickable_elements/* ClickableElement.SearchBarType */.U.SearchBarType
    }));
  };

  const handleTypeSelectorSelect = newSearchType => {
    toggleTypeSelector();
    focusInput();
    if (searchType !== newSearchType) setSearchType(newSearchType);
  };

  const handleOutClick = () => {
    // Prevent excessive re-rendering
    if (isSubscribeModalOpen || !(isTypeSelectorOpen || isFocused)) return;
    setIsTypeSelectorOpen(false);
    setIsFocused(false);
  };

  const handleInputFocus = () => {
    if (!isSavedSearchesFetched.current) requestSearches();

    if (!isSavedSearchesRendered(query) && !isFocused) {
      querySearchSuggestions(query);
    }

    setIsTypeSelectorOpen(false);
    setIsFocused(true);
  };

  const handleInputClick = () => track((0,events/* clickEvent */.Q5)({
    target: clickable_elements/* ClickableElement.SearchBar */.U.SearchBar
  }));

  const handleSubscribeClick = search => {
    if (!userId) return;
    dispatch((0,actions/* toggleSearchSubscription */.nl)({
      userId,
      searchId: search.id
    }));
  };

  const handleSubscribeModalClose = () => {
    dispatch(saved_searches_slice/* actions.closeSubscribeModal */.Nw.closeSubscribeModal());
  };

  const handleSuggestionClick = (suggestion, index, scopedSuggestionCount) => {
    const trackingArgs = {
      suggestions: suggestions.map(item => item.query),
      suggestion: suggestion.query,
      query,
      scopedSuggestionCount,
      index,
      countryCode: userCountryCode || countryCodeByIp,
      searchSessionId,
      globalSearchSessionId,
      suggestionsSessionId: suggestionsSessionId.current,
      isFrontendGeneratedSuggestion: suggestion.type === search/* SearchSuggestionType.Fallback */.aS.Fallback
    };

    if (suggestion.type === search/* SearchSuggestionType.Scoped */.aS.Scoped) {
      trackingArgs.subtitle = suggestion.subtitle;
    }

    if ('params' in suggestion) {
      trackingArgs.params = suggestion.params;
    }

    if (isUpdateSelectSearchSuggestionsEventEnabled) {
      trackingArgs.suggestionPosition = index + 1;
      trackingArgs.suggestionsListId = suggestionsListId;
    } else {
      trackingArgs.type = suggestion.type;

      if ('typeId' in suggestion) {
        trackingArgs.typeId = suggestion.typeId;
      }
    }

    track((0,events/* selectSearchSuggestionEvent */.jO)(trackingArgs));

    if (suggestionsSessionId.current) {
      (0,utils_search/* setSearchStartData */.F7)({
        searchStartId: suggestionsSessionId.current,
        searchStartType: tracking_search/* SearchStartType.SearchSuggestions */.z.SearchSuggestions
      });
    }

    if (isInCatalog) {
      if (suggestion.type === search/* SearchSuggestionType.Scoped */.aS.Scoped) {
        dispatch(catalog_filters_slice/* actions.setFilters */.Nw.setFilters({
          filters: (0,utils/* searchSuggestionToFilters */.MT)(suggestion)
        }));
      }

      dispatch(catalog_filters_slice/* actions.setQuery */.Nw.setQuery({
        query: suggestion.query
      }));
    }

    setQuery(suggestion.query);
    setIsFocused(false);
  };

  const handleSavedSearchClick = savedSearch => {
    const savedSearchType = savedSearch.subscribed ? tracking_search/* SavedSearchType.SubscribedSearch */.L.SubscribedSearch : tracking_search/* SavedSearchType.RecentSearch */.L.RecentSearch;
    track((0,events/* selectSavedSearchEvent */.Ml)({
      searchSessionId,
      type: savedSearchType,
      searchTitle: savedSearch.title,
      globalSearchSessionId,
      newItemsCount: savedSearch.new_items_count,
      unrestrictedNewItemsCount: savedSearch.unrestricted_new_items_count
    }));
  };

  const handleSubmit = event => {
    if (searchType === search/* SearchBarSearchType.Faq */.lz.Faq) {
      const expirationDate = new Date();
      expirationDate.setTime(expirationDate.getTime() + date/* SECONDS_PER_DAY */.Nf * date/* MS_PER_SECOND */.L7);
      (0,cookies/* saveCookie */.YB)(help_center/* HC_SEARCH_SESSION_ID_COOKIE_KEY */.DA, uuid_default().v4(), expirationDate);
    }

    if (searchType !== search/* SearchBarSearchType.Item */.lz.Item) return;
    if (isInCatalog) event.preventDefault();

    if (isUpdateFilterItemsEventEnabled && suggestionsSessionId.current) {
      (0,utils_search/* setSearchStartData */.F7)({
        searchStartId: suggestionsSessionId.current,
        searchStartType: tracking_search/* SearchStartType.SearchManual */.z.SearchManual
      });
    }

    blurInput();
    setIsFocused(false);
    dispatch(catalog_filters_slice/* actions.setQuery */.Nw.setQuery({
      query
    }));
  };

  const handleSavedSearchOnEnter = highlightedResultIndex => {
    const highlightedSearch = savedSearches[highlightedResultIndex];

    const params = SearchBar_objectSpread(SearchBar_objectSpread({}, searchDtoToUrlParams(highlightedSearch)), {}, {
      search_id: highlightedSearch.id
    });

    const url = "".concat(SEARCH_URLS[search/* SearchBarSearchType.Item */.lz.Item], "?").concat((0,utils_url/* toUrlQuery */.Kf)(params));
    handleSavedSearchClick(highlightedSearch);
    (0,utils_window/* redirectToPage */.mZ)(url);
    blurInput();
  };

  const handleSearchSuggestionOnEnter = highlightedResultIndex => {
    const highlightedSuggestion = suggestions[highlightedResultIndex];
    const url = searchSuggestionUrl(highlightedSuggestion);
    const scopedSuggestions = suggestions.filter(item => item.type === search/* SearchSuggestionType.Scoped */.aS.Scoped);
    handleSuggestionClick(highlightedSuggestion, highlightedResultIndex, scopedSuggestions.length);
    if (url) (0,utils_window/* redirectToPage */.mZ)(url);
    blurInput();
  };

  const handleSuggestionNavigation = highlightedResultIndex => {
    if (highlightedResultIndex === null) {
      setSelectedSearch(null);
    } else if (isSavedSearchesRendered(query)) {
      setSelectedSearch(savedSearches[highlightedResultIndex].search_text);
    } else {
      setSelectedSearch(suggestions[highlightedResultIndex].query);
    }
  };

  const renderIcon = () => /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: "u-flexbox u-align-items-center",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(DeprecatedIcon/* default */.Z, {
      name: "search-filled",
      size: DeprecatedIcon/* default.Size.Small */.Z.Size.Small,
      color: DeprecatedIcon/* default.Color.GreyscaleLevel4 */.Z.Color.GreyscaleLevel4
    })
  });

  const renderPrefix = () => /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: "u-flexbox u-fill-height",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(TypeSelector_TypeSelector, {
      selectedType: searchType,
      isOpen: isTypeSelectorOpen,
      onClick: handleTypeSelectorClick,
      onSelect: handleTypeSelectorSelect
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Divider/* default */.Z, {
      orientation: Divider/* default.Orientation.Vertical */.Z.Orientation.Vertical
    })]
  });

  const renderSuggestions = highlightedResultIndex => /*#__PURE__*/(0,jsx_runtime.jsx)(SearchSuggestions_SearchSuggestions, {
    query: query,
    items: suggestions,
    highlightedIndex: highlightedResultIndex,
    onSuggestionClick: handleSuggestionClick,
    suggestionUrl: searchSuggestionUrl,
    searchSessionId: searchSessionId,
    globalSearchSessionId: globalSearchSessionId,
    setSuggestionsSessionId: setSuggestionsSessionId,
    suggestionsListId: suggestionsListId
  });

  const renderSavedSearches = highlightedResultIndex => {
    if (!userId || !savedSearches.length) return null;
    return /*#__PURE__*/(0,jsx_runtime.jsx)(SavedSearchesList_SavedSearchesList, {
      searches: savedSearches,
      highlightedIndex: highlightedResultIndex,
      onSubscribeClick: handleSubscribeClick,
      searchUrl: SEARCH_URLS[search/* SearchBarSearchType.Item */.lz.Item],
      searchSessionId: searchSessionId,
      globalSearchSessionId: globalSearchSessionId,
      onSearchClick: handleSavedSearchClick
    });
  };

  const renderDropdown = highlightedResultIndex => {
    if (searchType !== search/* SearchBarSearchType.Item */.lz.Item || !isFocused) return null;
    const dropdownContent = isSavedSearchesRendered(query) ? renderSavedSearches(highlightedResultIndex) : renderSuggestions(highlightedResultIndex);
    if ((0,lodash.isEmpty)(dropdownContent)) return null;
    return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "u-ui-margin-top-regular u-position-absolute u-fill-width",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Card/* default */.Z, {
        styling: Card/* default.Styling.Lifted */.Z.Styling.Lifted,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "u-overflow-hidden",
          children: dropdownContent
        })
      })
    });
  };

  const renderAccessChannel = () => {
    if (searchType !== 'faq') return null;
    return /*#__PURE__*/(0,jsx_runtime.jsx)("input", {
      type: "hidden",
      name: "access_channel",
      value: "hc_search"
    });
  };

  let resultsCount = savedSearches.length;
  let onSelect = handleSavedSearchOnEnter;

  if (!isSavedSearchesRendered(query)) {
    resultsCount = suggestions.length;
    onSelect = handleSearchSuggestionOnEnter;
  }

  return /*#__PURE__*/(0,jsx_runtime.jsx)(OutsideClick/* default */.Z, {
    onOutsideClick: handleOutClick,
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("form", {
      onSubmit: handleSubmit,
      method: "get",
      action: SEARCH_URLS[searchType],
      children: [renderAccessChannel(), /*#__PURE__*/(0,jsx_runtime.jsx)(ListNavigator/* default */.Z, {
        itemCount: resultsCount,
        onSelect: onSelect,
        onHighlightedResultChange: isSearchSuggestionsAutofillEnabled ? handleSuggestionNavigation : undefined,
        children: _ref2 => {
          let {
            highlightedResultIndex,
            handleKeyNavigation
          } = _ref2;
          return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: "u-position-relative",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(InputBar/* InputBarWithForwardedRef */.N, {
              inputAria: {
                'aria-labelledby': "search-".concat(searchType)
              },
              clearButtonAria: {
                'aria-label': translate('searchbar.button.clear')
              },
              name: "search_text",
              placeholder: getPlaceholder(),
              value: isSearchSuggestionsAutofillEnabled ? selectedSearch || query : query,
              deprecatedIcon: renderIcon(),
              prefix: renderPrefix(),
              onChange: handleQueryChange,
              onFocus: handleInputFocus,
              onKeyDown: handleKeyNavigation,
              onValueClear: handleValueClear,
              onInputClick: handleInputClick,
              ref: inputRef,
              testId: "search-text"
            }), renderDropdown(highlightedResultIndex)]
          });
        }
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(SearchSubscribeModal_SearchSubscribeModal, {
        isOpen: isSubscribeModalOpen,
        onClose: handleSubscribeModalClose
      })]
    })
  });
};

/* harmony default export */ var SearchBar_SearchBar = (SearchBar);
// EXTERNAL MODULE: ../app/data/transformers/user.ts
var user = __webpack_require__(63097);
// EXTERNAL MODULE: ../app/data/api/account.ts
var account = __webpack_require__(81091);
// EXTERNAL MODULE: ../app/constants/my-orders.ts
var my_orders = __webpack_require__(2685);
// EXTERNAL MODULE: ../app/state/selectors.ts
var state_selectors = __webpack_require__(43526);
// EXTERNAL MODULE: ../app/hooks/useShouldShowDarkModeBanner.ts
var useShouldShowDarkModeBanner = __webpack_require__(30249);
;// CONCATENATED MODULE: ../app/components/Header/SideNavigation/AccountLinks/AccountLink.tsx



const AccountLink = _ref => {
  let {
    title,
    url,
    suffix,
    onClick,
    testId
  } = _ref;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Cell/* default */.Z, {
    testId: testId,
    type: Cell/* default.Type.Navigating */.Z.Type.Navigating,
    body: /*#__PURE__*/(0,jsx_runtime.jsx)(Text/* default */.Z, {
      text: title
    }),
    url: url,
    onClick: onClick,
    suffix: suffix
  });
};

/* harmony default export */ var AccountLinks_AccountLink = (AccountLink);
;// CONCATENATED MODULE: ../app/components/Header/SideNavigation/AccountLinks/AccountLinks.tsx



















const AccountLinks = _ref => {
  let {
    userId
  } = _ref;
  const translate = (0,useTranslate/* default */.Z)();
  const {
    track
  } = (0,useTracking/* default */.Z)();
  const isPaymentsEnabled = (0,es/* useSelector */.v9)((0,feature_switches_selectors/* getIsFeatureSwitchEnabled */.z)('payments'));
  const isMyOrdersNavAndFiltersEnabled = (0,es/* useSelector */.v9)((0,feature_switches_selectors/* getIsFeatureSwitchEnabled */.z)('my_orders_nav_and_filters'));
  const isMyOrdersEnabled = (0,es/* useSelector */.v9)((0,feature_switches_selectors/* getIsFeatureSwitchEnabled */.z)('next_page_my_orders'));
  const showFundraiser = (0,es/* useSelector */.v9)(state_selectors/* getShowFundraiser */.Gf);
  const isReferralsEnabled = (0,es/* useSelector */.v9)(state_selectors/* getIsReferralsEnabled */.QA);
  const shouldShowDarkModeAdoption = (0,useShouldShowDarkModeBanner/* default */.Z)();

  const handleLogoutClick = async () => {
    const response = await (0,account/* logoutUser */.TX)();
    if (response) (0,utils_window/* navigateToPage */.ru)(routes/* ROOT_URL */.mYc);
  };

  const handleFundraiserClick = () => {
    track((0,events/* donationsClickEvent */.a8)({
      target: clickable_elements/* ClickableElement.EnterDonationsFromWebMenu */.U.EnterDonationsFromWebMenu
    }));
  };

  const renderSettingsSuffix = () => {
    if (!shouldShowDarkModeAdoption) return null;
    return /*#__PURE__*/(0,jsx_runtime.jsx)(Badge/* default */.Z, {
      theme: "primary",
      content: translate('common.new_badge')
    });
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Label/* default */.Z, {
      styling: Label/* default.Styling.Wide */.Z.Styling.Wide,
      text: translate('header.user_menu.account.title')
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(SeparatedList/* default */.Z, {
      separator: /*#__PURE__*/(0,jsx_runtime.jsx)(Divider/* default */.Z, {}),
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(AccountLinks_AccountLink, {
        title: translate('header.user_menu.account.items.profile.title'),
        url: (0,routes/* MEMBER_PROFILE_URL */.G0B)(userId)
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(AccountLinks_AccountLink, {
        title: translate('header.user_menu.account.items.settings.title'),
        url: routes/* PROFILE_SETTINGS_URL */.Svv,
        suffix: renderSettingsSuffix(),
        testId: "settings-account-link"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(AccountLinks_AccountLink, {
        title: translate('header.user_menu.account.items.personalization.title'),
        url: routes/* USER_PERSONALIZATION_SIZES_URL */.pLL
      }), isPaymentsEnabled && /*#__PURE__*/(0,jsx_runtime.jsx)(AccountLinks_AccountLink, {
        title: translate('header.user_menu.account.items.wallet.title'),
        url: routes/* GO_TO_WALLET_URL */.cz_
      }), isMyOrdersEnabled && /*#__PURE__*/(0,jsx_runtime.jsx)(AccountLinks_AccountLink, {
        title: translate('header.user_menu.account.items.my_orders.title'),
        url: (0,routes/* MY_ORDERS_URL */.JGG)({
          type: isMyOrdersNavAndFiltersEnabled ? my_orders/* OrdersType.Sold */.Ns.Sold : my_orders/* OrdersType.All */.Ns.All
        })
      }), showFundraiser && /*#__PURE__*/(0,jsx_runtime.jsx)(AccountLinks_AccountLink, {
        title: translate('header.user_menu.account.items.donations.title'),
        url: routes/* DONATIONS_SETTINGS_URL */.V55,
        onClick: handleFundraiserClick
      }), !isPaymentsEnabled && /*#__PURE__*/(0,jsx_runtime.jsx)(AccountLinks_AccountLink, {
        title: translate('header.user_menu.account.items.invoices.title'),
        url: routes/* WALLET_INVOICES_URL */.A_o
      }), isReferralsEnabled && /*#__PURE__*/(0,jsx_runtime.jsx)(AccountLinks_AccountLink, {
        title: translate('header.user_menu.account.items.referrals.title'),
        url: routes/* REFERRALS_URL */.Aof
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(AccountLinks_AccountLink, {
        title: translate('header.user_menu.account.items.logout.title'),
        onClick: handleLogoutClick
      })]
    })]
  });
};

/* harmony default export */ var AccountLinks_AccountLinks = (AccountLinks);
;// CONCATENATED MODULE: ../app/components/Header/SideNavigation/CategoriesSection/CategoriesSection.tsx










const CategoriesSection = _ref => {
  let {
    categories
  } = _ref;
  const translate = (0,useTranslate/* default */.Z)('header.side_bar');
  const {
    track
  } = (0,useTracking/* default */.Z)();

  const handleTitleClick = _ref2 => {
    let {
      id
    } = _ref2;
    return () => {
      const trakingEvent = (0,events/* selectCatalogEvent */.bc)({
        catalogIds: [id],
        attributeId: catalog/* CatalogAttribute.Navigation */.Oj.Navigation
      });
      track(trakingEvent);
    };
  };

  const renderCategoriesItem = item => {
    var _item$photo;

    return /*#__PURE__*/(0,jsx_runtime.jsx)(Cell/* default */.Z, {
      type: Cell/* default.Type.Navigating */.Z.Type.Navigating,
      prefix: /*#__PURE__*/(0,jsx_runtime.jsx)(Image/* ImageWithForwardedRef */.U, {
        src: (_item$photo = item.photo) === null || _item$photo === void 0 ? void 0 : _item$photo.url,
        scaling: Image/* ImageWithForwardedRef.Scaling.Cover */.U.Scaling.Cover,
        size: Image/* ImageWithForwardedRef.Size.Regular */.U.Size.Regular
      }),
      body: /*#__PURE__*/(0,jsx_runtime.jsx)(Text/* default */.Z, {
        truncate: true,
        children: item.title
      }),
      url: item.url,
      urlProps: {
        title: item.title
      },
      onClick: handleTitleClick(item),
      testId: "sidebar-category-item-".concat(item.id),
      aria: {
        'aria-label': item.title
      }
    }, item.id);
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Label/* default */.Z, {
      styling: Label/* default.Styling.Wide */.Z.Styling.Wide,
      text: translate('categories')
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(SeparatedList/* default */.Z, {
      separator: /*#__PURE__*/(0,jsx_runtime.jsx)(Divider/* default */.Z, {}),
      children: categories.map(renderCategoriesItem)
    })]
  });
};

/* harmony default export */ var CategoriesSection_CategoriesSection = (CategoriesSection);
// EXTERNAL MODULE: ../node_modules/.pnpm/@vinted+web-ui@39.0.0_@types+react@18.2.21_react-dom@18.2.0_react-lottie-player@1.5.4_react@18.2.0/node_modules/@vinted/web-ui/dist/esm/lib/Container/Container.js
var Container = __webpack_require__(55913);
;// CONCATENATED MODULE: ../app/components/Header/SideNavigation/LoginSection/LoginSection.tsx














const LoginSection = _ref => {
  let {
    user
  } = _ref;
  const translate = (0,useTranslate/* default */.Z)('header.side_bar');
  const dispatch = (0,es/* useDispatch */.I0)();
  const {
    track
  } = (0,useTracking/* default */.Z)();

  const openAuthModal = () => {
    dispatch(auth_slice/* actions.openAuthModal */.Nw.openAuthModal());
    const trakingEvent = (0,events/* clickEvent */.Q5)({
      target: clickable_elements/* ClickableElement.Login */.U.Login
    });
    track(trakingEvent);
  };

  const handleSellNow = () => {
    const trakingEvent = (0,events/* clickEvent */.Q5)({
      target: clickable_elements/* ClickableElement.UploadItem */.U.UploadItem
    });
    track(trakingEvent);
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)(Container/* default */.Z, {
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(SeparatedList/* default */.Z, {
      separator: /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* default */.Z, {}),
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Button/* ButtonWithForwardedRef */.I, {
        text: translate('sell_now'),
        styling: Button/* ButtonWithForwardedRef.Styling.Filled */.I.Styling.Filled,
        url: routes/* ITEM_UPLOAD_URL */.UNR,
        onClick: handleSellNow,
        testId: "side-bar-sell-btn"
      }), !user && /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* ButtonWithForwardedRef */.I, {
        text: translate('sign_in'),
        onClick: openAuthModal,
        testId: "side-bar-signin-btn"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* ButtonWithForwardedRef */.I, {
        text: translate('guide'),
        styling: Button/* ButtonWithForwardedRef.Styling.Flat */.I.Styling.Flat,
        testId: "side-bar-guide-btn",
        url: (0,utils_url/* urlWithParams */.Iq)(routes/* GUIDE_ENTRIES_URL */.$MB, {
          access_channel: constants/* AccessChannel.VintedGuide */.Si.VintedGuide
        })
      })]
    })
  });
};

/* harmony default export */ var LoginSection_LoginSection = (LoginSection);
;// CONCATENATED MODULE: ../app/components/Header/SideNavigation/OtherSection/OtherLink/OtherLink.tsx



const OtherLink = _ref => {
  let {
    title,
    url,
    onClick
  } = _ref;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Cell/* default */.Z, {
    type: Cell/* default.Type.Navigating */.Z.Type.Navigating,
    body: /*#__PURE__*/(0,jsx_runtime.jsx)(Text/* default */.Z, {
      text: title,
      truncate: true
    }),
    url: url,
    urlProps: {
      title
    },
    onClick: onClick
  });
};

/* harmony default export */ var OtherLink_OtherLink = (OtherLink);
;// CONCATENATED MODULE: ../app/components/Header/SideNavigation/OtherSection/Discover/Discover.tsx









const Discover = _ref => {
  let {
    isBusinessAccountLinksVisible
  } = _ref;
  const translate = (0,useTranslate/* default */.Z)('header.main_navigation.about.discover');
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Label/* default */.Z, {
      styling: Label/* default.Styling.Wide */.Z.Styling.Wide,
      text: translate('title')
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(SeparatedList/* default */.Z, {
      separator: /*#__PURE__*/(0,jsx_runtime.jsx)(Divider/* default */.Z, {}),
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(OtherLink_OtherLink, {
        url: routes/* HOW_IT_WORKS_URL */.OkD,
        title: translate('items.how_it_works')
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(OtherLink_OtherLink, {
        url: routes/* APP_LANDING_URL */.QwI,
        title: translate('items.app')
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(OtherLink_OtherLink, {
        url: routes/* HELP_CENTER_URL */.lw5,
        title: translate('items.help')
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(OtherLink_OtherLink, {
        url: routes/* INFOBOARD_URL */.Ga_,
        title: translate('items.infoboard')
      }), isBusinessAccountLinksVisible && /*#__PURE__*/(0,jsx_runtime.jsx)(OtherLink_OtherLink, {
        url: routes/* BUSINESS_ACCOUNTS_HOMEPAGE */.Jo,
        title: translate('items.pro')
      }), isBusinessAccountLinksVisible && /*#__PURE__*/(0,jsx_runtime.jsx)(OtherLink_OtherLink, {
        url: routes/* BUSINESS_ACCOUNTS_GUIDE_URL */._qi,
        title: translate('items.pro_guide')
      })]
    })]
  });
};

/* harmony default export */ var Discover_Discover = (Discover);
;// CONCATENATED MODULE: ../app/components/Header/SideNavigation/OtherSection/Company/Company.tsx
















const Company = () => {
  const translate = (0,useTranslate/* default */.Z)('header.main_navigation.about.company');
  const locale = (0,es/* useSelector */.v9)(intl_selectors/* getLocale */.K);
  const {
    track
  } = (0,useTracking/* default */.Z)();
  const isSustainabilityPageEnabled = (0,es/* useSelector */.v9)((0,feature_switches_selectors/* getIsFeatureSwitchEnabled */.z)('sustainability_page_press_center_link'));
  const isPressMenuEnabled = (0,es/* useSelector */.v9)((0,feature_switches_selectors/* getIsFeatureSwitchEnabled */.z)('press_menu'));
  const isJobsPageEnabled = (0,es/* useSelector */.v9)((0,feature_switches_selectors/* getIsFeatureSwitchEnabled */.z)('jobs_page'));
  const isPressCenterLinkEnabled = (0,es/* useSelector */.v9)((0,feature_switches_selectors/* getIsFeatureSwitchEnabled */.z)('web_press_center_link'));
  const isNewJobsUrlEnabled = (0,es/* useSelector */.v9)((0,feature_switches_selectors/* getIsFeatureSwitchEnabled */.z)('new_jobs_career_portal'));
  const shortLocale = locale.substring(0, 2);
  const pressUrl = isPressCenterLinkEnabled ? (0,press_center/* getPressCenterUrl */.J)(shortLocale) : routes/* PRESS_URL */.v6v;
  const jobsUrl = isNewJobsUrlEnabled ? routes/* JOBS_URL_NEW */.VHG : routes/* JOBS_URL */.Ch7;

  const handleSustainabilityClick = () => {
    track((0,events/* clickEvent */.Q5)({
      target: clickable_elements/* ClickableElement.SustainabilityPageLink */.U.SustainabilityPageLink,
      targetDetails: 'navigation_web'
    }));
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Label/* default */.Z, {
      styling: Label/* default.Styling.Wide */.Z.Styling.Wide,
      text: translate('title')
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(SeparatedList/* default */.Z, {
      separator: /*#__PURE__*/(0,jsx_runtime.jsx)(Divider/* default */.Z, {}),
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(OtherLink_OtherLink, {
        title: translate('items.about'),
        url: routes/* MAIN_NAVIGATION_ABOUT_TAB_URL */.ouD
      }), isJobsPageEnabled && /*#__PURE__*/(0,jsx_runtime.jsx)(OtherLink_OtherLink, {
        title: translate('items.jobs'),
        url: jobsUrl
      }), isSustainabilityPageEnabled && /*#__PURE__*/(0,jsx_runtime.jsx)(OtherLink_OtherLink, {
        title: translate('items.sustainability'),
        url: (0,press_center/* getSustainabilityUrl */.E)(shortLocale),
        onClick: handleSustainabilityClick
      }), isPressMenuEnabled && /*#__PURE__*/(0,jsx_runtime.jsx)(OtherLink_OtherLink, {
        title: translate('items.press'),
        url: pressUrl
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(OtherLink_OtherLink, {
        title: translate('items.advertising'),
        url: routes/* ADVERTISING_URL */.E2e
      })]
    })]
  });
};

/* harmony default export */ var Company_Company = (Company);
;// CONCATENATED MODULE: ../app/components/Header/SideNavigation/OtherSection/Policies/Policies.tsx









const Policies = _ref => {
  let {
    impressumUrl,
    isBusinessAccountLinksVisible
  } = _ref;
  const translate = (0,useTranslate/* default */.Z)('header.main_navigation.about.policies');
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Label/* default */.Z, {
      styling: Label/* default.Styling.Wide */.Z.Styling.Wide,
      text: translate('title')
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(SeparatedList/* default */.Z, {
      separator: /*#__PURE__*/(0,jsx_runtime.jsx)(Divider/* default */.Z, {}),
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(OtherLink_OtherLink, {
        title: translate('items.safety'),
        url: routes/* HELP_SAFETY_URL */.c1u
      }), impressumUrl && /*#__PURE__*/(0,jsx_runtime.jsx)(OtherLink_OtherLink, {
        title: translate('items.impressum'),
        url: impressumUrl
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(OtherLink_OtherLink, {
        title: translate('items.privacy_policy'),
        url: routes/* PRIVACY_POLICY_URL */.hOY
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(OtherLink_OtherLink, {
        title: translate('items.terms_and_conditions'),
        url: routes/* TERMS_URL */.qyY
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(OtherLink_OtherLink, {
        title: translate('items.cookie_policy'),
        url: routes/* COOKIE_POLICY_URL */.ljN
      }), isBusinessAccountLinksVisible && /*#__PURE__*/(0,jsx_runtime.jsx)(OtherLink_OtherLink, {
        title: translate('items.pro_terms_of_sale'),
        url: routes/* BUSINESS_TERMS_OF_SALE_URL */.$ru
      }), isBusinessAccountLinksVisible && /*#__PURE__*/(0,jsx_runtime.jsx)(OtherLink_OtherLink, {
        title: translate('items.pro_terms_of_use'),
        url: routes/* BUSINESS_TERMS_URL */.vK_
      })]
    })]
  });
};

/* harmony default export */ var Policies_Policies = (Policies);
;// CONCATENATED MODULE: ../app/components/Header/SideNavigation/OtherSection/Privacy/Privacy.tsx









const Privacy = () => {
  const translate = (0,useTranslate/* default */.Z)('header.main_navigation.about.privacy');

  const handleCookiesClick = event => {
    event.preventDefault();
    (0,utils_window/* toggleOneTrustInfoDisplay */.ap)();
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Label/* default */.Z, {
      styling: Label/* default.Styling.Wide */.Z.Styling.Wide,
      text: translate('title')
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(OtherLink_OtherLink, {
      url: catalog/* NAVIGATION_COOKIES_URL */.bd,
      title: translate('items.cookies'),
      onClick: handleCookiesClick
    })]
  });
};

/* harmony default export */ var Privacy_Privacy = (Privacy);
;// CONCATENATED MODULE: ../app/components/Header/SideNavigation/OtherSection/Communities/Communities.tsx










const Communities = () => {
  const translate = (0,useTranslate/* default */.Z)('header.main_navigation.about.communities');
  const user = (0,es/* useSelector */.v9)(session_selectors/* getUser */.PR);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Label/* default */.Z, {
      styling: Label/* default.Styling.Wide */.Z.Styling.Wide,
      text: translate('title')
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(OtherLink_OtherLink, {
      title: translate('items.forum'),
      url: routes/* FORUM_HOME_URL */.R1Q
    }), !!(user !== null && user !== void 0 && user.favourite_topic_count) && /*#__PURE__*/(0,jsx_runtime.jsx)(OtherLink_OtherLink, {
      title: translate('items.forum_favourite_topics'),
      url: routes/* FORUM_FAVOURITE_TOPICS_URL */.Nei
    }), !!user && /*#__PURE__*/(0,jsx_runtime.jsx)(OtherLink_OtherLink, {
      title: translate('items.forum_own_topics'),
      url: routes/* FORUM_OWN_TOPICS_URL */.AnP
    })]
  });
};

/* harmony default export */ var Communities_Communities = (Communities);
;// CONCATENATED MODULE: ../app/components/Header/SideNavigation/OtherSection/OtherSection.tsx











const OtherSection = _ref => {
  let {
    impressumUrl,
    isBusinessAccountLinksVisible
  } = _ref;
  const isForumDisabled = (0,es/* useSelector */.v9)((0,feature_switches_selectors/* getIsFeatureSwitchEnabled */.z)('disable_forum_web'));
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Discover_Discover, {
      isBusinessAccountLinksVisible: isBusinessAccountLinksVisible
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Company_Company, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(Policies_Policies, {
      impressumUrl: impressumUrl,
      isBusinessAccountLinksVisible: isBusinessAccountLinksVisible
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Privacy_Privacy, {}), !isForumDisabled && /*#__PURE__*/(0,jsx_runtime.jsx)(Communities_Communities, {})]
  });
};

/* harmony default export */ var OtherSection_OtherSection = (OtherSection);
;// CONCATENATED MODULE: ../app/components/Header/SideNavigation/SideNavigation.tsx















const SideNavigation = _ref => {
  let {
    catalogTree,
    impressumUrl,
    isBusinessAccountLinksVisible
  } = _ref;
  const userDto = (0,es/* useSelector */.v9)(session_selectors/* getUser */.PR);
  const transformedUser = (0,react.useMemo)(() => userDto ? (0,user/* transformUserDto */.oE)(userDto) : null, [userDto]);
  const transformedTree = (0,react.useMemo)(() => (0,transformers_catalog/* transformCatalogDtoList */.Dx)(catalogTree), [catalogTree]);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(SeparatedList/* default */.Z, {
    separator: /*#__PURE__*/(0,jsx_runtime.jsx)(Divider/* default */.Z, {}),
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(LoginSection_LoginSection, {
      user: transformedUser
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(CategoriesSection_CategoriesSection, {
      categories: transformedTree
    }), userDto && /*#__PURE__*/(0,jsx_runtime.jsx)(AccountLinks_AccountLinks, {
      userId: userDto.id
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(LanguageSelector/* default */.Z, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(OtherSection_OtherSection, {
      impressumUrl: impressumUrl,
      isBusinessAccountLinksVisible: isBusinessAccountLinksVisible
    })]
  });
};

/* harmony default export */ var SideNavigation_SideNavigation = (SideNavigation);
// EXTERNAL MODULE: ../app/data/utils/user.ts
var utils_user = __webpack_require__(95943);
// EXTERNAL MODULE: ../app/data/api/index.ts + 1 modules
var api = __webpack_require__(96535);
// EXTERNAL MODULE: ../app/libs/utils/formatString.ts
var formatString = __webpack_require__(99920);
// EXTERNAL MODULE: ../app/data/transformers/wallet.ts
var wallet = __webpack_require__(70178);
;// CONCATENATED MODULE: ../app/components/Header/UserMenu/CurrentWalletAmount/CurrentWalletAmount.tsx










const CurrentWalletAmount = () => {
  const locale = (0,es/* useSelector */.v9)(intl_selectors/* getLocale */.K);
  const currentUserId = (0,es/* useSelector */.v9)(session_selectors/* getUserId */.n5);
  const {
    0: balance,
    1: setBalance
  } = (0,react.useState)();
  (0,react.useEffect)(() => {
    const fetchData = async () => {
      if (!currentUserId) return;
      const response = await (0,api/* getWalletBalance */.pdA)(currentUserId);
      if ('errors' in response) return;
      setBalance((0,wallet/* transformWalletBalanceDto */.K)(response.user_balance));
    };

    fetchData();
  }, [currentUserId]);
  if (!balance) return null;
  const {
    availableAmount
  } = balance;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Text/* default */.Z, {
    type: Text/* default.Type.Caption */.Z.Type.Caption,
    text: (0,formatString/* formatCurrencyAmount */.ZO)(availableAmount, locale)
  });
};

/* harmony default export */ var CurrentWalletAmount_CurrentWalletAmount = (CurrentWalletAmount);
// EXTERNAL MODULE: ../node_modules/.pnpm/@vinted+web-ui@39.0.0_@types+react@18.2.21_react-dom@18.2.0_react-lottie-player@1.5.4_react@18.2.0/node_modules/@vinted/web-ui/dist/esm/shared/useFloating-80b7427c.js
var useFloating_80b7427c = __webpack_require__(49661);
// EXTERNAL MODULE: ../node_modules/.pnpm/@vinted+web-ui@39.0.0_@types+react@18.2.21_react-dom@18.2.0_react-lottie-player@1.5.4_react@18.2.0/node_modules/@vinted/web-ui/dist/esm/constants/spacing.js
var spacing = __webpack_require__(55140);
;// CONCATENATED MODULE: ../app/components/Header/UserMenu/UserMenuDropdown/UserMenuDropdown.tsx








const UserMenuDropdown = _ref => {
  let {
    userName,
    userPhoto,
    children
  } = _ref;
  const {
    0: isOpen,
    1: setIsOpen
  } = (0,react.useState)(false);

  const handleMenuButtonClick = () => setIsOpen(prevIsOpen => !prevIsOpen);

  const handleOutsideClick = () => setIsOpen(false);

  const {
    floaterRef,
    triggerRef,
    floaterStyle
  } = (0,useFloating_80b7427c.u)({
    middleware: [(0,useFloating_80b7427c.o)(spacing/* Spacing.Medium */.K.Medium), (0,useFloating_80b7427c.f)({
      mainAxis: false
    }), (0,useFloating_80b7427c.s)()],
    placement: 'bottom-end',
    shouldAutoUpdate: true,
    isFloaterVisible: isOpen
  });
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(OutsideClick/* default */.Z, {
    onOutsideClick: handleOutsideClick,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      id: "user-menu-button",
      role: "button",
      tabIndex: 0,
      ref: triggerRef,
      onClick: handleMenuButtonClick,
      className: classnames_default()({
        open: isOpen
      }),
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("figure", {
        className: "photo-centered-parent header-avatar u-cursor-pointer",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(Image/* ImageWithForwardedRef */.U, {
          src: userPhoto,
          alt: userName,
          styling: Image/* ImageWithForwardedRef.Styling.Circle */.U.Styling.Circle
        })
      })
    }), isOpen && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      ref: floaterRef,
      style: floaterStyle,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Card/* default */.Z, {
        styling: Card/* default.Styling.Elevated */.Z.Styling.Elevated,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(ScrollableArea/* default */.Z, {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "user-menu-groups",
            children: children
          })
        })
      })
    })]
  });
};

/* harmony default export */ var UserMenuDropdown_UserMenuDropdown = (UserMenuDropdown);
;// CONCATENATED MODULE: ../app/components/Header/UserMenu/UserMenuGroup/UserMenuGroupItem/UserMenuGroupItem.tsx





const UserMenuGroupItem = _ref => {
  let {
    title,
    children
  } = _ref;

  const renderChildItem = child => /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
    className: "nav-item",
    children: child
  });

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
    className: "nav nav-stacked nav-dropdown nav-detailed user-menu-group__item",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
      className: "label label--small nav__label",
      children: title
    }), react.Children.map((0,lodash.compact)(children), renderChildItem)]
  }, title);
};

/* harmony default export */ var UserMenuGroupItem_UserMenuGroupItem = (UserMenuGroupItem);
;// CONCATENATED MODULE: ../app/components/Header/UserMenu/UserMenuGroup/UserMenuGroupAction/UserMenuGroupAction.tsx


const UserMenuGroupAction = _ref => {
  let {
    href,
    onClick,
    children
  } = _ref;
  return /*#__PURE__*/(0,react.createElement)(href ? 'a' : 'button', {
    href,
    onClick,
    className: 'nav-link'
  }, children);
};

/* harmony default export */ var UserMenuGroupAction_UserMenuGroupAction = (UserMenuGroupAction);
;// CONCATENATED MODULE: ../app/components/Header/UserMenu/UserMenuGroup/UserMenuGroup.tsx




const UserMenuGroup = _ref => {
  let {
    children
  } = _ref;
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: "user-menu-group",
    children: children
  });
};

UserMenuGroup.Item = UserMenuGroupItem_UserMenuGroupItem;
UserMenuGroup.Action = UserMenuGroupAction_UserMenuGroupAction;
/* harmony default export */ var UserMenuGroup_UserMenuGroup = (UserMenuGroup);
;// CONCATENATED MODULE: ../app/components/Header/UserMenu/UserMenuInjected/UserMenuInjected.tsx




const UserMenuInjected = _ref => {
  let {
    injectedMenus
  } = _ref;
  if (!injectedMenus) return null;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
    children: injectedMenus.filter(group => group.length).map((group, index) => /*#__PURE__*/(0,jsx_runtime.jsx)(UserMenuGroup_UserMenuGroup, {
      children: group.map(_ref2 => {
        let {
          title,
          items
        } = _ref2;
        return /*#__PURE__*/(0,jsx_runtime.jsx)(UserMenuGroup_UserMenuGroup.Item, {
          title: title,
          children: items.map(_ref3 => {
            let {
              title: itemTitle,
              href
            } = _ref3;
            return /*#__PURE__*/(0,jsx_runtime.jsx)(UserMenuGroup_UserMenuGroup.Action, {
              href: href,
              children: itemTitle
            }, href);
          })
        }, title);
      })
    }, index))
  });
};

/* harmony default export */ var UserMenuInjected_UserMenuInjected = (UserMenuInjected);
;// CONCATENATED MODULE: ../app/components/Header/UserMenu/UserMenu.tsx























const UserMenu = _ref => {
  let {
    injectedMenus
  } = _ref;
  const user = (0,es/* useSelector */.v9)(session_selectors/* getUser */.PR);
  const translate = (0,useTranslate/* default */.Z)();
  const tracker = (0,useTracking/* default */.Z)();
  const isPaymentsEnabled = (0,es/* useSelector */.v9)((0,feature_switches_selectors/* getIsFeatureSwitchEnabled */.z)('payments'));
  const isMyOrdersNavAndFiltersEnabled = (0,es/* useSelector */.v9)((0,feature_switches_selectors/* getIsFeatureSwitchEnabled */.z)('my_orders_nav_and_filters'));
  const isMyOrdersEnabled = (0,es/* useSelector */.v9)((0,feature_switches_selectors/* getIsFeatureSwitchEnabled */.z)('next_page_my_orders'));
  const showFundraiser = (0,es/* useSelector */.v9)(state_selectors/* getShowFundraiser */.Gf);
  const isReferralsEnabled = (0,es/* useSelector */.v9)(state_selectors/* getIsReferralsEnabled */.QA);
  const shouldShowDarkModeAdoption = (0,useShouldShowDarkModeBanner/* default */.Z)();
  if (!user) return null;
  const userPhoto = (0,utils_user/* getUserThumbnail */.Iw)(user.photo);

  const handleLogoutClick = async () => {
    const response = await (0,account/* logoutUser */.TX)();
    if (response) (0,utils_window/* navigateToPage */.ru)(routes/* ROOT_URL */.mYc);
  };

  const handleFundraiserClick = () => tracker.track((0,events/* donationsClickEvent */.a8)({
    target: clickable_elements/* ClickableElement.EnterDonationsFromWebMenu */.U.EnterDonationsFromWebMenu
  }));

  const renderWalletAction = () => /*#__PURE__*/(0,jsx_runtime.jsx)(UserMenuGroup_UserMenuGroup.Action, {
    href: routes/* GO_TO_WALLET_URL */.cz_,
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
      className: "u-flexbox u-justify-content-between u-align-items-center",
      children: [translate('header.user_menu.account.items.wallet.title'), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
        className: "u-ui-padding-left-regular",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(CurrentWalletAmount_CurrentWalletAmount, {})
      })]
    })
  });

  const renderMyOrdersAction = () => /*#__PURE__*/(0,jsx_runtime.jsx)(UserMenuGroup_UserMenuGroup.Action, {
    href: (0,routes/* MY_ORDERS_URL */.JGG)({
      type: isMyOrdersNavAndFiltersEnabled ? my_orders/* OrdersType.Sold */.Ns.Sold : my_orders/* OrdersType.All */.Ns.All
    }),
    children: translate('header.user_menu.account.items.my_orders.title')
  });

  const renderFundraiserAction = () => /*#__PURE__*/(0,jsx_runtime.jsx)(UserMenuGroup_UserMenuGroup.Action, {
    href: routes/* DONATIONS_SETTINGS_URL */.V55,
    onClick: handleFundraiserClick,
    children: translate('header.user_menu.account.items.donations.title')
  });

  const renderLogoutAction = () => /*#__PURE__*/(0,jsx_runtime.jsx)(UserMenuGroup_UserMenuGroup.Action, {
    onClick: handleLogoutClick,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
      className: "u-color-red",
      children: translate('header.user_menu.account.items.logout.title')
    })
  });

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(UserMenuDropdown_UserMenuDropdown, {
    userName: user.login,
    userPhoto: userPhoto,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(UserMenuInjected_UserMenuInjected, {
      injectedMenus: injectedMenus
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(UserMenuGroup_UserMenuGroup, {
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(UserMenuGroup_UserMenuGroup.Item, {
        title: translate('header.user_menu.account.title'),
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(UserMenuGroup_UserMenuGroup.Action, {
          href: (0,routes/* MEMBER_PROFILE_URL */.G0B)(user.id),
          children: translate('header.user_menu.account.items.profile.title')
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(UserMenuGroup_UserMenuGroup.Action, {
          href: routes/* PROFILE_SETTINGS_URL */.Svv,
          children: [translate('header.user_menu.account.items.settings.title'), shouldShowDarkModeAdoption && /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* default */.Z, {
              orientation: Spacer/* default.Orientation.Vertical */.Z.Orientation.Vertical,
              size: Spacer/* default.Size.Small */.Z.Size.Small
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(Badge/* default */.Z, {
              theme: "primary",
              content: translate('common.new_badge')
            })]
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(UserMenuGroup_UserMenuGroup.Action, {
          href: routes/* USER_PERSONALIZATION_SIZES_URL */.pLL,
          children: translate('header.user_menu.account.items.personalization.title')
        }), isPaymentsEnabled && renderWalletAction(), isMyOrdersEnabled && renderMyOrdersAction(), showFundraiser && renderFundraiserAction(), !isPaymentsEnabled && /*#__PURE__*/(0,jsx_runtime.jsx)(UserMenuGroup_UserMenuGroup.Action, {
          href: routes/* WALLET_INVOICES_URL */.A_o,
          children: translate('header.user_menu.account.items.invoices.title')
        }), isReferralsEnabled && /*#__PURE__*/(0,jsx_runtime.jsx)(UserMenuGroup_UserMenuGroup.Action, {
          href: routes/* REFERRALS_URL */.Aof,
          children: translate('header.user_menu.account.items.referrals.title')
        }), renderLogoutAction()]
      })
    })]
  });
};

/* harmony default export */ var UserMenu_UserMenu = (UserMenu);
;// CONCATENATED MODULE: ../app/components/Header/Header.tsx






























const Header = _ref => {
  let {
    languages,
    catalogTree,
    isInCatalog,
    searchType,
    portal,
    impressumUrl,
    isBusinessAccountLinksVisible,
    isOurPlatformVisible,
    injectedMenus
  } = _ref;
  const userId = (0,es/* useSelector */.v9)(session_selectors/* getUserId */.n5);
  const screenName = (0,es/* useSelector */.v9)(screen_selectors/* getScreenName */.G);
  const webToAppAbTest = (0,es/* useSelector */.v9)((0,ab_tests_selectors/* getAbTestByName */.uw)('web_2_app_conversion_v1'));
  const isPopularCatalog = (0,es/* useSelector */.v9)(catalog_filters_selectors/* getIsPopularInCatalog */.Vm);
  const showSearchSubscribeButton = isInCatalog && userId && !isPopularCatalog;
  const {
    0: isSideNavigationOpen,
    1: setIsSideNavigationOpen
  } = (0,react.useState)(false);

  function toggleSideNavigation() {
    setIsSideNavigationOpen(prevState => !prevState);
  }

  function renderAppBannerAbTest() {
    if ((webToAppAbTest === null || webToAppAbTest === void 0 ? void 0 : webToAppAbTest.variant) === 'on' && screenName === screens/* Screen.NewsFeed */.l.NewsFeed) {
      return /*#__PURE__*/(0,jsx_runtime.jsx)(AppBanner_AppBanner, {
        isHeader: true
      });
    }

    return null;
  }

  function renderHeaderHelpButton() {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(FaqEntryUrl/* default */.Z, {
      type: faq_entry/* FaqEntryType.VintedGuide */.Z.VintedGuide,
      accessChannel: constants/* AccessChannel.VintedGuide */.Si.VintedGuide,
      render: url => /*#__PURE__*/(0,jsx_runtime.jsx)(HeaderHelpButton_HeaderHelpButton, {
        url: url
      })
    });
  }

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: classnames_default()('l-header js-header', {
        'is-active': isSideNavigationOpen
      }),
      children: [renderAppBannerAbTest(), /*#__PURE__*/(0,jsx_runtime.jsx)("header", {
        className: "l-header__main",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "container u-flexbox u-align-items-center u-fill-height",
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: "l-header__content",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(HeaderLogo_HeaderLogo, {
              portal: portal
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: "l-header__search",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(SearchBar_SearchBar, {
                isInCatalog: isInCatalog,
                searchType: searchType
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: "l-header__actions",
              children: [userId && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: "user-actions",
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(HeaderUserActions_HeaderUserActions, {})
              }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                className: "u-desktops-only u-flexbox u-align-items-center",
                children: [userId && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                  className: "u-position-relative u-ui-padding-left-regular u-ui-padding-right-x-large",
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)(UserMenu_UserMenu, {
                    injectedMenus: injectedMenus
                  })
                }), !userId && /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)(HeaderLoginButton_HeaderLoginButton, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* default */.Z, {
                    orientation: Spacer/* default.Orientation.Vertical */.Z.Orientation.Vertical
                  })]
                }), /*#__PURE__*/(0,jsx_runtime.jsx)(HeaderUploadItem_HeaderUploadItem, {}), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                  className: "u-ui-padding-left-regular",
                  children: renderHeaderHelpButton()
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                  className: "language-selector",
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)(LanguageSelector/* default */.Z, {
                    initialLanguages: languages
                  })
                })]
              })]
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: "l-header__toggle",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(HeaderToggleMobileMenu_HeaderToggleMobileMenu, {
                isActive: isSideNavigationOpen,
                onToggle: toggleSideNavigation
              })
            })]
          })
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "l-header__navigation",
        children: [isSideNavigationOpen && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "u-mobiles-only",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(SideNavigation_SideNavigation, {
            catalogTree: catalogTree,
            impressumUrl: impressumUrl,
            isBusinessAccountLinksVisible: isBusinessAccountLinksVisible
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "u-desktops-only",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "container",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(CatalogNavigation_CatalogNavigation, {
              tree: catalogTree,
              impressumUrl: impressumUrl,
              isBusinessAccountLinksVisible: isBusinessAccountLinksVisible,
              isOurPlatformVisible: isOurPlatformVisible
            })
          })
        })]
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "l-search",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Cell/* default */.Z, {
        styling: Cell/* default.Styling.Tight */.Z.Styling.Tight,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "u-ui-padding-vertical-regular",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "container",
            children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: "u-flexbox",
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: "u-fill-width",
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(SearchBar_SearchBar, {
                  isInCatalog: isInCatalog,
                  searchType: searchType
                })
              }), showSearchSubscribeButton && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: "u-phones-only u-ui-margin-left-medium",
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(SearchSubscribeButton_SearchSubscribeButton, {})
              })]
            })
          })
        })
      })
    }), !userId && /*#__PURE__*/(0,jsx_runtime.jsx)(AuthModal/* default */.Z, {})]
  });
};

/* harmony default export */ var Header_Header = (Header);
// EXTERNAL MODULE: ../app/hooks/useFetch.ts
var useFetch = __webpack_require__(54519);
// EXTERNAL MODULE: ../app/constants/verification.ts
var verification = __webpack_require__(67509);
// EXTERNAL MODULE: ../app/state/verifications/constants.ts
var verifications_constants = __webpack_require__(28251);
// EXTERNAL MODULE: ../app/state/verifications/selectors.ts
var verifications_selectors = __webpack_require__(77227);
;// CONCATENATED MODULE: ../app/components/HeaderNoNavigation/hooks/useEmailCodeTest.ts














const screenByEmailCodeView = {
  [verifications_constants/* EmailCodeView.EnterCode */.v.EnterCode]: screens/* Screen.MandatoryEmailVerificationEnterCode */.l.MandatoryEmailVerificationEnterCode,
  [verifications_constants/* EmailCodeView.NotReceiveEmail */.v.NotReceiveEmail]: screens/* Screen.MandatoryEmailVerificationResendCode */.l.MandatoryEmailVerificationResendCode,
  [verifications_constants/* EmailCodeView.Success */.v.Success]: screens/* Screen.MandatoryEmailVerificationSuccess */.l.MandatoryEmailVerificationSuccess
};
const useEmailCodeTest = () => {
  const user = (0,es/* useSelector */.v9)(session_selectors/* getUser */.PR);
  const view = (0,es/* useSelector */.v9)(verifications_selectors/* getEmailCodeView */.I);
  const {
    track
  } = (0,useTracking/* default */.Z)();
  const {
    fetch: fetchPrompts,
    data: prompts,
    error,
    isLoading: isLoadingPrompts
  } = (0,useFetch/* default */.Z)(api/* getVerificationPrompt */.YAs);
  const {
    relativeUrl
  } = (0,useLocation/* default */.Z)();
  const isEmailCodeMethod = prompts === null || prompts === void 0 ? void 0 : prompts.prompt.methods.includes(verification/* VerificationMethods.EmailCode */.Rq.EmailCode);
  const isInVerificationFlow = relativeUrl === routes/* USERS_VERIFICATION_URL */.O8U || relativeUrl === routes/* EMAIL_CODE_VERIFICATION_URL */.chM;
  (0,react.useEffect)(() => {
    if (!isInVerificationFlow) return;
    if (!(user !== null && user !== void 0 && user.id)) return;
    fetchPrompts(user.id);
  }, [user, isInVerificationFlow, fetchPrompts]);

  const trackEmailCodeSkipEvent = () => {
    if (error) return;
    if (!isEmailCodeMethod) return;
    if (prompts !== null && prompts !== void 0 && prompts.prompt.mandatory) return;
    track((0,events/* clickEvent */.Q5)({
      screen: screens/* Screen.MandatoryEmailVerificationStart */.l.MandatoryEmailVerificationStart,
      target: clickable_elements/* ClickableElement.Skip */.U.Skip
    }));
  };

  const handleDismissVerificationPrompt = async () => {
    if (!(user !== null && user !== void 0 && user.id)) return;
    if (error) return;
    if (!isEmailCodeMethod) return;
    if (prompts !== null && prompts !== void 0 && prompts.prompt.mandatory) return;
    await (0,api/* dismissVerificationPrompt */.DS3)(user.id);
  };

  const trackLogoutEvent = () => {
    if (!isEmailCodeMethod) return;
    const eventData = {
      screen: screens/* Screen.MandatoryEmailVerificationStart */.l.MandatoryEmailVerificationStart,
      target: clickable_elements/* ClickableElement.SessionsLogOut */.U.SessionsLogOut
    };

    if (relativeUrl === routes/* EMAIL_CODE_VERIFICATION_URL */.chM) {
      eventData.screen = screenByEmailCodeView[view];
    }

    track((0,events/* clickEvent */.Q5)(eventData));
  };

  return {
    trackLogoutEvent,
    trackEmailCodeSkipEvent,
    handleDismissVerificationPrompt,
    isLoadingPrompts
  };
};
;// CONCATENATED MODULE: ../app/components/HeaderNoNavigation/HeaderNoNavigation.tsx












const HeaderNoNavigation = _ref => {
  let {
    portal
  } = _ref;
  const user = (0,es/* useSelector */.v9)(session_selectors/* getUser */.PR);
  const translate = (0,useTranslate/* default */.Z)();
  const {
    trackLogoutEvent,
    isLoadingPrompts,
    trackEmailCodeSkipEvent,
    handleDismissVerificationPrompt
  } = useEmailCodeTest();

  const handleLogoutClick = async () => {
    const response = await (0,account/* logoutUser */.TX)();

    if (response) {
      trackLogoutEvent();
      (0,utils_window/* navigateToPage */.ru)(routes/* ROOT_URL */.mYc);
    }
  };

  const handleDismissPrompt = async () => {
    await handleDismissVerificationPrompt();
    (0,utils_window/* navigateToPage */.ru)(routes/* ROOT_URL */.mYc);
  };

  const handleLogoClick = event => {
    event.preventDefault();
    trackEmailCodeSkipEvent();
    handleDismissPrompt();
    return false;
  };

  const renderLogo = () => {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(HeaderLogo_HeaderLogo, {
      portal: portal,
      onClick: handleLogoClick
    });
  };

  const renderLogoutButton = () => {
    if (!user) return null;
    return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "l-header__actions",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* ButtonWithForwardedRef */.I, {
        theme: "muted",
        styling: Button/* ButtonWithForwardedRef.Styling.Flat */.I.Styling.Flat,
        size: Button/* ButtonWithForwardedRef.Size.Medium */.I.Size.Medium,
        onClick: handleLogoutClick,
        disabled: isLoadingPrompts,
        children: translate('header.actions.log_out')
      })
    });
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: "l-header",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("header", {
      className: "l-header__main",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "container u-flexbox u-align-items-center u-fill-height",
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "l-header__content",
          children: [renderLogo(), renderLogoutButton()]
        })
      })
    })
  });
};

/* harmony default export */ var HeaderNoNavigation_HeaderNoNavigation = (HeaderNoNavigation);
// EXTERNAL MODULE: ../app/components/Notification/Notification.tsx + 2 modules
var Notification = __webpack_require__(65443);
// EXTERNAL MODULE: ../app/containers/BrazeProvider/BrazeContext.ts
var BrazeContext = __webpack_require__(99451);
// EXTERNAL MODULE: ../app/data/transformers/braze.ts
var braze = __webpack_require__(19066);
;// CONCATENATED MODULE: ../app/libs/common/braze/hooks/useBrazeInAppMessage.ts




function useStore(store, transform) {
  const entity = (0,react.useSyncExternalStore)(store.subscribe, () => store.state, () => null);
  if (transform && entity) return transform(entity);
  return entity;
}

function useBrazeInAppMessage() {
  const context = (0,react.useContext)(BrazeContext/* default */.Z);
  const modalInAppMessage = useStore(context.modalInAppMessageStore, braze/* transformBrazeModalInAppMessageDto */.NA);
  const fullScreenInAppMessage = useStore(context.fullScreenInAppMessageStore, braze/* transformBrazeFullScreenInAppMessageDto */.vA);
  const slideUpInAppMessage = useStore(context.slideUpInAppMessageStore, braze/* transformBrazeSlideUpInAppMessageDto */.h8);
  return {
    modalInAppMessage: modalInAppMessage !== null && modalInAppMessage !== void 0 ? modalInAppMessage : fullScreenInAppMessage,
    notificationInAppMessage: slideUpInAppMessage
  };
}

/* harmony default export */ var hooks_useBrazeInAppMessage = (useBrazeInAppMessage);
// EXTERNAL MODULE: ../app/libs/common/braze/utils/event-loggers.ts
var event_loggers = __webpack_require__(17987);
;// CONCATENATED MODULE: ../app/components/InAppMessage/NotificationInAppMessage/NotificationInAppMessage.tsx




const ONE_SECOND_IN_MILISECONDS = 1000;

const NotificationInAppMessage = _ref => {
  let {
    inAppMessage,
    onClose,
    onLinkClick,
    onEnter
  } = _ref;
  (0,react.useEffect)(onEnter, [onEnter]);

  const buildLink = children => {
    if (!inAppMessage.url) return children;
    const target = inAppMessage.shouldOpenLinkInNewTab ? '_target' : undefined;
    return /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
      href: inAppMessage.url,
      target: target,
      onClick: onLinkClick,
      children: children
    });
  };

  const renderBody = () => {
    return buildLink( /*#__PURE__*/(0,jsx_runtime.jsx)(Text/* default */.Z, {
      text: inAppMessage.message,
      html: true
    }));
  };

  const renderImage = () => {
    if (!inAppMessage.imageUrl) return undefined;
    return buildLink( /*#__PURE__*/(0,jsx_runtime.jsx)(Image/* ImageWithForwardedRef */.U, {
      src: inAppMessage.imageUrl,
      size: Image/* ImageWithForwardedRef.Size.Large */.U.Size.Large
    }));
  };

  const miliSecondsToSeconds = duration => Math.ceil(duration / ONE_SECOND_IN_MILISECONDS);

  return /*#__PURE__*/(0,jsx_runtime.jsx)(Notification/* default */.ZP, {
    deprecatedIcon: renderImage(),
    body: renderBody(),
    displayDuration: inAppMessage.duration && miliSecondsToSeconds(inAppMessage.duration),
    forceVisibility: !inAppMessage.duration,
    position: inAppMessage.position,
    onNotificationClose: onClose,
    testId: "in-app-message-notification"
  });
};

/* harmony default export */ var NotificationInAppMessage_NotificationInAppMessage = (NotificationInAppMessage);
// EXTERNAL MODULE: ../app/types/models/in-app-message.ts
var in_app_message = __webpack_require__(92593);
// EXTERNAL MODULE: ../app/hooks/useBreakpoint.ts
var useBreakpoint = __webpack_require__(19367);
;// CONCATENATED MODULE: ../app/components/InAppMessage/ModalInAppMessage/ModalInAppMessage.tsx








 // TODO: split the component into three components:
// SplashInAppModal
// FullScreenSplashInAppModal
// CoverInAppModal

const ModalInAppMessage = _ref => {
  let {
    inAppMessage,
    isOpen,
    onClose,
    onEnter,
    onPrimaryButtonClick,
    onSecondaryButtonClick,
    onLinkClick
  } = _ref;
  const breakpoints = (0,useBreakpoint/* default */.Z)(); // TODO: infer whether the link is external and add rel attributes

  const urlProps = inAppMessage.shouldOpenLinkInNewTab ? {
    target: '_blank'
  } : undefined;
  const isSplash = inAppMessage.type === in_app_message/* InAppModalMessageType.Splash */.j.Splash;
  const isCover = inAppMessage.type === in_app_message/* InAppModalMessageType.Cover */.j.Cover;
  const showCloseButton = (0,react.useMemo)(() => {
    if (inAppMessage.secondaryButtonText) {
      return Boolean(inAppMessage.primaryButtonUrl && inAppMessage.secondaryButtonUrl);
    }

    return Boolean(inAppMessage.primaryButtonUrl);
  }, [inAppMessage]);

  const handleMessageClick = event => {
    if (!(event.target instanceof HTMLAnchorElement)) return;
    const url = event.target.href;
    if (!url) return;
    onLinkClick(url);
  };

  const renderMessage = () => {
    if (!inAppMessage.message) return null;
    return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      onClick: handleMessageClick,
      className: "u-text-wrap",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* default */.Z, {
        size: Spacer/* default.Size.Large */.Z.Size.Large
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Text/* default */.Z, {
        text: (0,utils_url/* linkifyString */.Kw)(inAppMessage.message),
        html: true,
        format: true,
        theme: isCover ? 'inverse' : undefined,
        alignment: Text/* default.Alignment.Center */.Z.Alignment.Center
      })]
    });
  };

  const renderCoverSecondaryButton = () => {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* ButtonWithForwardedRef */.I, {
      onClick: onSecondaryButtonClick,
      styling: Button/* ButtonWithForwardedRef.Styling.Flat */.I.Styling.Flat,
      url: inAppMessage.secondaryButtonUrl,
      urlProps: urlProps,
      testId: "in-app-message-secondary-button",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Text/* default */.Z, {
        theme: "inverse",
        text: inAppMessage.secondaryButtonText,
        alignment: Text/* default.Alignment.Center */.Z.Alignment.Center
      })
    });
  };

  const renderSecondaryButton = () => {
    if (isCover) return renderCoverSecondaryButton();
    return /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* ButtonWithForwardedRef */.I, {
      text: inAppMessage.secondaryButtonText,
      onClick: onSecondaryButtonClick,
      styling: Button/* ButtonWithForwardedRef.Styling.Flat */.I.Styling.Flat,
      url: inAppMessage.secondaryButtonUrl,
      urlProps: urlProps,
      testId: "in-app-message-secondary-button"
    });
  };

  const renderImage = () => {
    const classes = classnames_default()({
      'u-fill-width u-fill-height u-position-absolute': isCover,
      'modal-in-app-message__splash-image': !isCover
    });
    return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: classes,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Image/* ImageWithForwardedRef */.U, {
        src: inAppMessage.imageUrl,
        scaling: Image/* ImageWithForwardedRef.Scaling.Cover */.U.Scaling.Cover
      })
    });
  };

  const classes = classnames_default()('u-justify-content-between u-flexbox u-flex-direction-column u-fill-height');
  const messageClasses = classnames_default()({
    'u-margin-auto': isCover
  });
  const modalClasses = classnames_default()('u-position-relative u-flexbox', {
    'u-fill-height u-fill-width': !isSplash && breakpoints.phones,
    'modal-in-app-message--cover': isCover
  });
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Modal/* default */.Z, {
    closeOnOverlay: true,
    testId: "in-app-message-modal",
    show: isOpen,
    className: modalClasses,
    hasScrollableContent: isSplash || breakpoints.tabletsUp,
    defaultCallback: onClose,
    onAfterOpen: onEnter,
    isFramed: isSplash,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "u-overflow-auto u-fill-width",
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: classes,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "u-position-absolute u-fill-width",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(Navigation/* default */.Z, {
            theme: "transparent",
            right: showCloseButton && /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* ButtonWithForwardedRef */.I, {
              testId: "close-modal-button",
              styling: Button/* ButtonWithForwardedRef.Styling.Flat */.I.Styling.Flat,
              inline: true,
              onClick: onClose,
              deprecatedIconName: "x",
              deprecatedIconColor: DeprecatedIcon/* default.Color.GreyscaleLevel7 */.Z.Color.GreyscaleLevel7
            })
          })
        }), renderImage(), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "u-justify-content-between u-flexbox u-fill-height u-flex-direction-column",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: messageClasses,
            children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Cell/* default */.Z, {
              theme: isCover ? 'transparent' : undefined,
              children: [inAppMessage.header && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: "u-text-wrap",
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(Text/* default */.Z, {
                  text: inAppMessage.header,
                  type: Text/* default.Type.Heading */.Z.Type.Heading,
                  theme: isCover ? 'inverse' : undefined,
                  width: Text/* default.Width.Parent */.Z.Width.Parent,
                  alignment: Text/* default.Alignment.Center */.Z.Alignment.Center
                })
              }), renderMessage()]
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(Cell/* default */.Z, {
            theme: isCover ? 'transparent' : undefined,
            children: /*#__PURE__*/(0,jsx_runtime.jsxs)(SeparatedList/* default */.Z, {
              separator: /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* default */.Z, {
                size: Spacer/* default.Size.Large */.Z.Size.Large
              }),
              children: [inAppMessage.primaryButtonText && /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* ButtonWithForwardedRef */.I, {
                text: inAppMessage.primaryButtonText,
                onClick: onPrimaryButtonClick,
                styling: Button/* ButtonWithForwardedRef.Styling.Filled */.I.Styling.Filled,
                url: inAppMessage.primaryButtonUrl,
                urlProps: urlProps,
                testId: "in-app-message-primary-button"
              }), inAppMessage.secondaryButtonText && renderSecondaryButton()]
            })
          })]
        })]
      })
    })
  });
};

/* harmony default export */ var ModalInAppMessage_ModalInAppMessage = (ModalInAppMessage);
;// CONCATENATED MODULE: ../app/components/InAppMessage/InAppMessage.tsx












const InAppMessage = () => {
  const {
    0: isModalOpen,
    1: setIsModalOpen
  } = (0,react.useState)(true);
  const {
    track
  } = (0,useTracking/* default */.Z)();
  const {
    notificationInAppMessage,
    modalInAppMessage
  } = hooks_useBrazeInAppMessage();
  const anyInAppMessage = notificationInAppMessage !== null && notificationInAppMessage !== void 0 ? notificationInAppMessage : modalInAppMessage;

  const trackDismissal = inAppMessage => {
    if (!inAppMessage) return;
    const targetDetails = JSON.stringify({
      campaign_name: inAppMessage.campaignName,
      campaign_message_name: inAppMessage.campaignMessageName,
      canvas_name: inAppMessage.canvasName,
      canvas_variant_name: inAppMessage.canvasVariantName
    });
    track((0,events/* clickEvent */.Q5)({
      target: clickable_elements/* ClickableElement.CrmInAppMessageDismiss */.U.CrmInAppMessageDismiss,
      screen: screens/* Screen.CrmInAppMessage */.l.CrmInAppMessage,
      targetDetails
    }));
  };

  const closeModal = () => {
    setIsModalOpen(false);
    trackDismissal(modalInAppMessage);
  };

  const handlePrimaryButtonClick = () => {
    if (!modalInAppMessage) return;
    if (!modalInAppMessage.primaryButtonUrl) closeModal();
    (0,event_loggers/* brazeLogInAppMessageButtonClick */.Ew)(modalInAppMessage, 0);
  };

  const handleSecondaryButtonClick = () => {
    if (!modalInAppMessage) return;
    if (!modalInAppMessage.secondaryButtonUrl) closeModal();
    (0,event_loggers/* brazeLogInAppMessageButtonClick */.Ew)(modalInAppMessage, 1);
  };

  const handleModalLinkClick = url => {
    if (!modalInAppMessage) return;
    const targetDetails = JSON.stringify({
      campaign_name: modalInAppMessage.campaignName,
      campaign_message_name: modalInAppMessage.campaignMessageName,
      canvas_name: modalInAppMessage.canvasName,
      canvas_variant_name: modalInAppMessage.canvasVariantName,
      url
    });
    track((0,events/* clickEvent */.Q5)({
      target: clickable_elements/* ClickableElement.CrmMessageLink */.U.CrmMessageLink,
      screen: screens/* Screen.CrmInAppMessage */.l.CrmInAppMessage,
      targetDetails
    }));
  };

  const handleNotificationClose = closeType => {
    if (notificationInAppMessage !== null && notificationInAppMessage !== void 0 && notificationInAppMessage.url || closeType === Notification/* CloseType.Auto */.ot.Auto) {
      trackDismissal(notificationInAppMessage);
      return;
    }

    if (notificationInAppMessage) {
      (0,event_loggers/* brazeLogInAppMessageClick */.ms)(notificationInAppMessage);
    }
  };

  const handleNotificationLinkClick = () => {
    if (!(notificationInAppMessage !== null && notificationInAppMessage !== void 0 && notificationInAppMessage.url)) return;
    (0,event_loggers/* brazeLogInAppMessageClick */.ms)(notificationInAppMessage);
  };

  const handleInAppMessageEnter = (0,react.useCallback)(() => {
    if (!anyInAppMessage) return;
    (0,event_loggers/* brazeLogInAppMessageImpression */.ph)(anyInAppMessage);
  }, [anyInAppMessage]);

  if (notificationInAppMessage) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(NotificationInAppMessage_NotificationInAppMessage, {
      onEnter: handleInAppMessageEnter,
      inAppMessage: notificationInAppMessage,
      onClose: handleNotificationClose,
      onLinkClick: handleNotificationLinkClick
    });
  }

  if (modalInAppMessage) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(ModalInAppMessage_ModalInAppMessage, {
      isOpen: isModalOpen,
      inAppMessage: modalInAppMessage,
      onClose: closeModal,
      onLinkClick: handleModalLinkClick,
      onEnter: handleInAppMessageEnter,
      onPrimaryButtonClick: handlePrimaryButtonClick,
      onSecondaryButtonClick: handleSecondaryButtonClick
    });
  }

  return null;
};

/* harmony default export */ var InAppMessage_InAppMessage = (InAppMessage);
// EXTERNAL MODULE: ../app/components/MainFooter/MainFooter.tsx + 6 modules
var MainFooter = __webpack_require__(69496);
// EXTERNAL MODULE: ../app/constants/consent.ts
var consent = __webpack_require__(23168);
// EXTERNAL MODULE: ../app/state/consent/selectors.ts
var consent_selectors = __webpack_require__(48412);
;// CONCATENATED MODULE: ../app/components/PolicyFooter/PolicyFooter.tsx














const PolicyFooter = _ref => {
  let {
    isDigitalLawEnabled,
    isBusinessInfoLinksEnabled,
    onlineComplaintUrl,
    isStatic,
    noDivider
  } = _ref;
  const translate = (0,useTranslate/* default */.Z)('footer.policy.items');
  const isCookieConsentVersion = (0,es/* useSelector */.v9)(consent_selectors/* getIsCookieConsentVersion */.C);
  const cookieConsentVersion = (0,es/* useSelector */.v9)(consent_selectors/* getCookieConsentVersion */.K);
  const {
    host
  } = (0,useLocation/* default */.Z)();
  const className = classnames_default()('privacy-footer', isStatic && 'privacy-footer--static');
  const cookieSettingsText = cookieConsentVersion === consent/* CookieConsentVersion.California */.I1.California ? translate('cookie_settings_us') : translate('cookie_settings');

  function handleCookieSettingsClick() {
    (0,utils_window/* toggleOneTrustInfoDisplay */.ap)();
  }

  return /*#__PURE__*/(0,jsx_runtime.jsx)("footer", {
    className: className,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "privacy-footer__content",
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "container",
        children: [!noDivider && /*#__PURE__*/(0,jsx_runtime.jsx)(Divider/* default */.Z, {}), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "privacy-footer__content__links",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("a", {
            href: (0,utils_url/* getOldHostRedirectUrl */.E_)(host) + routes/* PRIVACY_POLICY_URL */.hOY,
            children: translate('privacy_policy')
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
            href: routes/* COOKIE_POLICY_URL */.ljN,
            children: translate('cookie_policy')
          }), isCookieConsentVersion && /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
            type: "button",
            onClick: handleCookieSettingsClick,
            children: cookieSettingsText
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
            href: routes/* TERMS_URL */.qyY,
            children: translate('terms_and_conditions')
          }), isDigitalLawEnabled && /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
            href: routes/* OUR_PLATFORM_URL */.Nc0,
            children: translate('our_platform')
          }), isBusinessInfoLinksEnabled && /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("a", {
              href: routes/* BUSINESS_TERMS_OF_SALE_URL */.$ru,
              "data-testid": "privacy-footer-pro-sale-term-link",
              children: translate('pro_terms_of_sale')
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
              href: routes/* BUSINESS_TERMS_URL */.vK_,
              "data-testid": "privacy-footer-pro-use-term-link",
              children: translate('pro_terms_of_use')
            })]
          }), onlineComplaintUrl && /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
            href: onlineComplaintUrl,
            children: translate('online_complaints')
          })]
        })]
      })
    })
  });
};

/* harmony default export */ var PolicyFooter_PolicyFooter = (PolicyFooter);
;// CONCATENATED MODULE: ../app/components/VacationNotification/VacationNotification.tsx







 // TODO: Icon should be confirmed or replaced before scaling



const VacationNotification = () => {
  const user = (0,es/* useSelector */.v9)(session_selectors/* getUser */.PR);
  const isPortalClosed = (0,es/* useSelector */.v9)((0,feature_switches_selectors/* getIsFeatureSwitchEnabled */.z)('portal_closure_stage_3'));
  const {
    0: isLoading,
    1: setIsLoading
  } = (0,react.useState)(false);
  const translate = (0,useTranslate/* default */.Z)('vacation_notification');

  async function handleClick() {
    if (!user) return;
    setIsLoading(true);
    await (0,api/* disableUserHoliday */.KB9)(user.id);
    (0,utils_window/* reloadPage */.sl)();
  }

  if (isPortalClosed) return null;
  if (!(user !== null && user !== void 0 && user.is_on_holiday)) return null;
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: "u-ui-margin-vertical-x-large",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(Card/* default */.Z, {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Cell/* default */.Z, {
        styling: Cell/* default.Styling.Wide */.Z.Styling.Wide,
        prefix: /*#__PURE__*/(0,jsx_runtime.jsx)(DeprecatedIcon/* default */.Z, {
          name: "umbrella",
          color: DeprecatedIcon/* default.Color.GreyscaleLevel3 */.Z.Color.GreyscaleLevel3
        }),
        body: translate('title'),
        suffix: /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* ButtonWithForwardedRef */.I, {
          text: translate('actions.end'),
          onClick: handleClick,
          styling: Button/* ButtonWithForwardedRef.Styling.Filled */.I.Styling.Filled,
          size: Button/* ButtonWithForwardedRef.Size.Medium */.I.Size.Medium,
          isLoading: isLoading,
          disabled: isLoading
        }),
        testId: "vacation-notification"
      })
    })
  });
};

/* harmony default export */ var VacationNotification_VacationNotification = (VacationNotification);
// EXTERNAL MODULE: ../app/state/ads/actions.ts
var ads_actions = __webpack_require__(44557);
;// CONCATENATED MODULE: ../app/containers/AdsProvider/AdsProvider.tsx



 // From the first look it might seem that it only
// dispatches action to call `loadAdsPlacements`
// saga. And that is true, but that is a starting
// point for a bigger things to come.
//
// Ideally, this Provider should be able to Provide a
// Context that would hold information if ads need
// to be shown at all. Also, it could handle certain
// procedures that are currently handled in ad-manager
// to make setup faster and more dummy-proof.
//
// Also, ideally, it should also hold ad placements
// fetch logic so we could abandon using redux for
// ad placements.

const AdsProvider = _ref => {
  let {
    children
  } = _ref;
  const screenName = (0,es/* useSelector */.v9)(screen_selectors/* getScreenName */.G);
  const dispatch = (0,es/* useDispatch */.I0)();
  (0,react.useEffect)(() => {
    dispatch((0,ads_actions/* loadAdsPlacements */.d)());
  }, [dispatch, screenName]);
  return children;
};

/* harmony default export */ var AdsProvider_AdsProvider = (AdsProvider);
// EXTERNAL MODULE: ../app/components/GlobalTwoFAModal/GlobalTwoFAModal.tsx + 1 modules
var GlobalTwoFAModal = __webpack_require__(10299);
// EXTERNAL MODULE: ../app/components/ErrorBoundary/ErrorBoundary.tsx + 4 modules
var ErrorBoundary = __webpack_require__(63753);
// EXTERNAL MODULE: ../app/state/system-configuration/selectors.ts
var system_configuration_selectors = __webpack_require__(44210);
// EXTERNAL MODULE: ../node_modules/.pnpm/next@12.3.3_@babel+core@7.14.3_react-dom@18.2.0_react@18.2.0_sass@1.49.9/node_modules/next/script.js
var script = __webpack_require__(35776);
var script_default = /*#__PURE__*/__webpack_require__.n(script);
// EXTERNAL MODULE: ../app/hooks/useIsConsentGroupEnabled/useIsConsentGroupEnabled.ts
var useIsConsentGroupEnabled = __webpack_require__(50049);
;// CONCATENATED MODULE: ./components/AdScripts/setups/DigitalMatter/utils.ts
// TODO: Add unit tests
function initDigitalMatter(hasConsentedTargeting) {
  if (!hasConsentedTargeting) return;
  window.dimatter = window.dimatter || [];
  window.dimatter.push('standalone');
  window.dimatter.push(['_initialize']);
}
;// CONCATENATED MODULE: ./components/AdScripts/setups/DigitalMatter/DigitalMatter.tsx







const DigitalMatter = () => {
  const isTargetingConsentGroupEnabled = (0,useIsConsentGroupEnabled/* default */.Z)(consent/* ConsentGroup.Targeting */.R0.Targeting);
  (0,react.useEffect)(() => {
    initDigitalMatter(isTargetingConsentGroupEnabled);
  }, [isTargetingConsentGroupEnabled]);
  if (!isTargetingConsentGroupEnabled) return null;
  return /*#__PURE__*/(0,jsx_runtime.jsx)((script_default()), {
    id: "digital-matter-script",
    "data-testid": "digital-matter-script",
    src: "https://core.dimatter.ai/pubs/vinted-lt.min.js",
    strategy: "lazyOnload"
  });
};

/* harmony default export */ var DigitalMatter_DigitalMatter = (DigitalMatter);
;// CONCATENATED MODULE: ./components/AdScripts/components/DirectSetup/DirectSetup.tsx



const DirectSetup = () => {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(DigitalMatter_DigitalMatter, {});
};

/* harmony default export */ var DirectSetup_DirectSetup = (DirectSetup);
// EXTERNAL MODULE: ../app/hooks/useAbTest/useAbTest.ts
var useAbTest = __webpack_require__(30741);
;// CONCATENATED MODULE: ./components/AdScripts/setups/Google/utils.ts
// TODO: Add unit tests

function yieldbirdOptimization() {
  const {
    targetingValue
  } = {
    targetingValue(name) {
      switch (name) {
        case 'bm':
          return Math.random() >= 0.1 ? '1' : '0';

        case 'ab':
          return targetingValue.dool ? 'b' : "a".concat(Math.floor(Math.random() * 10));

        case 'dc':
          return targetingValue.dool ? 'd' : "c".concat(Math.floor(Math.random() * 20));

        case 'mx':
          return targetingValue.dool ? "m".concat(Math.floor(Math.random() * 180)) : 'x';

        case 'tt':
          return "tt".concat(Math.floor(Math.random() * 10));

        default:
          return '';
      }
    },

    dool: Math.random() >= 0.1
  };
  const date = new Date();
  const minute = date.getUTCMinutes();
  let hour = date.getUTCHours() - 8;
  let day = date.getUTCDay();

  if (hour < 0) {
    hour += 24;
    day -= 1;
  }

  if (day < 0) {
    day += 7;
  }

  window.googletag.cmd.push(() => {
    window.googletag.pubads().setTargeting('yb_bm', targetingValue('bm'));
    window.googletag.pubads().setTargeting('yb_ab', targetingValue('ab'));
    window.googletag.pubads().setTargeting('yb_dc', targetingValue('dc'));
    window.googletag.pubads().setTargeting('yb_mx', targetingValue('mx'));
    window.googletag.pubads().setTargeting('yb_tt', targetingValue('tt'));
    window.googletag.pubads().setTargeting('yb_ff', "".concat(Math.round(Math.random())));
    window.googletag.pubads().setTargeting('yb_tm', minute.toString());
    window.googletag.pubads().setTargeting('yb_th', hour.toString());
    window.googletag.pubads().setTargeting('yb_wd', day.toString());
  });
}
function initGoogletag() {
  window.googletag = window.googletag || {
    cmd: []
  };
}
function seNonPersonalizedAds(nonPersonalizedAds) {
  window.googletag.cmd.push(() => {
    window.googletag.pubads().setPrivacySettings({
      nonPersonalizedAds
    });
  });
}
function setAdsGenderValue(genderValue) {
  if (!genderValue) return;
  window.googletag.cmd.push(() => {
    window.googletag.pubads().setTargeting(ads/* GOOGLETAG_GENDER_VALUE_KEY */.Q0, genderValue);
  });
}
function setAdsSegments(adsSegmentIds) {
  if (!adsSegmentIds.length) return;
  window.googletag.cmd.push(() => {
    adsSegmentIds.forEach(adsSegmentId => window.googletag.pubads().setTargeting("adus_".concat(adsSegmentId), '1'));
  });
}
function setupGoogletagServices() {
  window.googletag.cmd.push(() => {
    window.googletag.pubads().enableSingleRequest();
    window.googletag.pubads().disableInitialLoad();
    window.googletag.pubads().collapseEmptyDivs();
    yieldbirdOptimization();
    window.googletag.enableServices();
  });
}
;// CONCATENATED MODULE: ./components/AdScripts/setups/Google/Google.tsx











const Google = () => {
  const user = (0,es/* useSelector */.v9)(session_selectors/* getUser */.PR);
  const adsSegmentIds = (0,es/* useSelector */.v9)(selectors/* getSegmentIds */.YC);
  const hasConsentedTargeting = (0,useIsConsentGroupEnabled/* default */.Z)(consent/* ConsentGroup.Targeting */.R0.Targeting);
  const adsGenderValue = (0,react.useMemo)(() => user && ads/* MapUserGenderToAdGender */.LJ[user.gender], [user]);
  (0,react.useEffect)(() => {
    initGoogletag();
    setupGoogletagServices();
  }, []);
  (0,react.useEffect)(() => {
    seNonPersonalizedAds(!hasConsentedTargeting);
  }, [hasConsentedTargeting]);
  (0,react.useEffect)(() => {
    setAdsGenderValue(adsGenderValue);
  }, [adsGenderValue]);
  (0,react.useEffect)(() => {
    setAdsSegments(adsSegmentIds);
  }, [adsSegmentIds]);
  return /*#__PURE__*/(0,jsx_runtime.jsx)((script_default()), {
    id: "googletag-script",
    "data-testid": "googletag-script",
    src: "https://securepubads.g.doubleclick.net/tag/js/gpt.js",
    strategy: "lazyOnload"
  });
};

/* harmony default export */ var Google_Google = (Google);
;// CONCATENATED MODULE: ./components/AdScripts/setups/Pubstack/utils.ts


function getPubstackDomainKey(hostname) {
  const normalizedHostname = (0,utils_url/* normalizeHost */.tb)(hostname);
  if (!(0,utils_url/* isInternalHostname */.SB)(normalizedHostname)) return null;
  return ads/* MapHostnameToPubstackKey */.us[normalizedHostname];
}
;// CONCATENATED MODULE: ./components/AdScripts/setups/Pubstack/Pubstack.tsx





const Pubstack = () => {
  const pubstackDomainKey = getPubstackDomainKey((0,useLocation/* default */.Z)().host);
  if (!pubstackDomainKey) return null;
  return /*#__PURE__*/(0,jsx_runtime.jsx)((script_default()), {
    id: "pubstack-script",
    "data-testid": "pubstack-script",
    src: "https://boot.pbstck.com/v1/tag/".concat(pubstackDomainKey),
    strategy: "lazyOnload"
  });
};

/* harmony default export */ var Pubstack_Pubstack = (Pubstack);
;// CONCATENATED MODULE: ./components/AdScripts/setups/Amazon/utils.ts


function utils_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function utils_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? utils_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : utils_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

// TODO: add unit tests


function pushToAmazonQueue(name, args) {
  // eslint-disable-next-line no-underscore-dangle
  window.apstag._Q.push([name, args]);
}
function setupAmazonPublisherAudienceServiceScript() {
  window.apstag = utils_objectSpread(utils_objectSpread({}, window.apstag), {}, {
    dpa() {
      for (var _len = arguments.length, rest = new Array(_len), _key = 0; _key < _len; _key++) {
        rest[_key] = arguments[_key];
      }

      pushToAmazonQueue('di', rest);
    },

    rpa() {
      for (var _len2 = arguments.length, rest = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        rest[_key2] = arguments[_key2];
      }

      pushToAmazonQueue('ri', rest);
    },

    upa() {
      for (var _len3 = arguments.length, rest = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        rest[_key3] = arguments[_key3];
      }

      pushToAmazonQueue('ui', rest);
    }

  });
}
function setupApsServiceScript(isAmazonPublisherAudienceEnabled) {
  if (window.apstag) return;
  window.apstag = {
    init() {
      for (var _len4 = arguments.length, rest = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
        rest[_key4] = arguments[_key4];
      }

      pushToAmazonQueue('i', rest);
    },

    fetchBids() {
      for (var _len5 = arguments.length, rest = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
        rest[_key5] = arguments[_key5];
      }

      pushToAmazonQueue('f', rest);
    },

    targetingKeys() {
      return [];
    },

    setDisplayBids() {
      (0,lodash.noop)();
    },

    _Q: []
  };

  if (isAmazonPublisherAudienceEnabled) {
    setupAmazonPublisherAudienceServiceScript();
  }
}
function initApsServices() {
  window.apstag.init({
    pubID: ads/* APSTAG_PUB_ID */.$8,
    adServer: 'googletag',
    deals: true
  });
}
;// CONCATENATED MODULE: ./components/AdScripts/setups/Amazon/Amazon.tsx









const Amazon = () => {
  const hasConsentedTargeting = (0,useIsConsentGroupEnabled/* default */.Z)(consent/* ConsentGroup.Targeting */.R0.Targeting);
  const isAmazonPublisherAudienceEnabled = (0,es/* useSelector */.v9)((0,feature_switches_selectors/* getIsFeatureSwitchEnabled */.z)('web_ads_amazon_publisher_audience'));
  (0,react.useEffect)(() => {
    if (!hasConsentedTargeting) return;
    setupApsServiceScript(isAmazonPublisherAudienceEnabled);
    initApsServices();
  }, [hasConsentedTargeting, isAmazonPublisherAudienceEnabled]);
  if (!hasConsentedTargeting) return null;
  return /*#__PURE__*/(0,jsx_runtime.jsx)((script_default()), {
    id: "amazon-tag",
    "data-testid": "amazon-tag",
    src: "https://c.amazon-adsystem.com/aax2/apstag.js",
    strategy: "lazyOnload"
  });
};

/* harmony default export */ var Amazon_Amazon = (Amazon);
;// CONCATENATED MODULE: ./components/AdScripts/setups/Prebid/utils.ts

function initPrebidSetup() {
  window.pbjs = window.pbjs || {};
  window.pbjs.que = window.pbjs.que || [];
  window.pbjs.que.push(() => {
    window.pbjs.bidderSettings = {
      adagio: {
        storageAllowed: true
      }
    };
    window.pbjs.setConfig({
      useBidCache: true,
      priceGranularity: {
        buckets: [{
          precision: 2,
          min: 0,
          max: 20,
          increment: 0.01
        }, {
          precision: 2,
          min: 21,
          max: 99,
          increment: 1
        }]
      },
      enableSendAllBids: false,
      currency: {
        adServerCurrency: 'EUR',
        granularityMultiplier: 1
      },
      timeoutBuffer: 200,
      userSync: {
        filterSettings: {
          iframe: {
            bidders: '*',
            filter: 'include'
          }
        },
        userIds: [{
          name: 'id5Id',
          params: {
            partner: 700
          },
          storage: {
            type: 'html5',
            name: 'id5id',
            expires: 90,
            refreshInSeconds: 8 * 3600
          }
        }, {
          name: 'criteo'
        }],
        auctionDelay: 50
      }
    });
  });
}
function setPrebidConsentManagement(isCookieConsentVersion) {
  if (!isCookieConsentVersion) return;
  window.pbjs.que.push(() => {
    window.pbjs.mergeConfig({
      consentManagement: {
        gdpr: {
          cmpApi: ads/* PrebidConsentManagementCmpApiType.IAB */._j.IAB,
          defaultGdprScope: true
        },
        usp: {
          cmpApi: ads/* PrebidConsentManagementCmpApiType.IAB */._j.IAB
        }
      }
    });
  });
}
;// CONCATENATED MODULE: ./components/AdScripts/setups/Prebid/Prebid.tsx








const Prebid = () => {
  const isCookieConsentVersion = (0,es/* useSelector */.v9)(consent_selectors/* getIsCookieConsentVersion */.C);
  (0,react.useEffect)(() => {
    initPrebidSetup();
  }, []);
  (0,react.useEffect)(() => {
    setPrebidConsentManagement(isCookieConsentVersion);
  }, [isCookieConsentVersion]);
  return /*#__PURE__*/(0,jsx_runtime.jsx)((script_default()), {
    id: "prebid-script",
    "data-testid": "prebid-script",
    src: "".concat(constants/* CDN_ADS_URL */.GC, "/prebid.js"),
    strategy: "lazyOnload"
  });
};

/* harmony default export */ var Prebid_Prebid = (Prebid);
;// CONCATENATED MODULE: ./components/AdScripts/setups/SmartAdServer/utils.ts


function getSmartAdServerSiteId(host) {
  const normalizedHostname = (0,utils_url/* normalizeHost */.tb)(host);
  if (!(0,utils_url/* isInternalHostname */.SB)(normalizedHostname)) return null;
  return ads/* MapHostnameToSasSiteId */.W9[normalizedHostname];
}
function initSmartAdServer(smartAdServerSiteId, smartAdServerPageId) {
  window.sas = window.sas || {};
  window.sas.cmd = window.sas.cmd || [];
  window.sas.cmd.push(() => {
    window.sas.setup({
      networkid: ads/* SMART_ADSERVER_NETWORK_ID */.V8,
      domain: '//www8.smartadserver.com',
      async: true,
      renderMode: 2
    });
  });
  window.sas.adCallConfig = {
    siteId: smartAdServerSiteId,
    pageId: smartAdServerPageId,
    target: '',
    formats: []
  };

  window.sas.callSmart = () => {
    window.sas.cmd.push(() => {
      window.sas.call('onecall', window.sas.adCallConfig);
    });
    window.sas.render();
  };
}
;// CONCATENATED MODULE: ./components/AdScripts/setups/SmartAdServer/SmartAdServer.tsx










const SmartAdServer = () => {
  const screenName = (0,es/* useSelector */.v9)(screen_selectors/* getScreenName */.G);
  const isCookieConsentVersion = (0,es/* useSelector */.v9)(consent_selectors/* getIsCookieConsentVersion */.C);
  const smartAdServerSiteId = getSmartAdServerSiteId((0,useLocation/* default */.Z)().host);
  const smartAdServerPageId = ads/* MapScreenToSasPageId */.VS[screenName];
  const isSmartAdServerIds = !!smartAdServerSiteId && !!smartAdServerPageId;
  const shouldRenderSmartAdServer = !isCookieConsentVersion && isSmartAdServerIds;
  (0,react.useEffect)(() => {
    if (shouldRenderSmartAdServer) {
      initSmartAdServer(smartAdServerSiteId, smartAdServerPageId);
    }
  }, [shouldRenderSmartAdServer, smartAdServerSiteId, smartAdServerPageId]);
  if (!shouldRenderSmartAdServer) return null;
  return /*#__PURE__*/(0,jsx_runtime.jsx)((script_default()), {
    id: "smart-adserver-script",
    "data-testid": "smart-adserver-script",
    src: "//ced.sascdn.com/tag/3230/smart.js",
    strategy: "lazyOnload"
  });
};

/* harmony default export */ var SmartAdServer_SmartAdServer = (SmartAdServer);
// EXTERNAL MODULE: ../app/constants/hostnames.ts
var hostnames = __webpack_require__(46635);
;// CONCATENATED MODULE: ./components/AdScripts/setups/Yieldbird/utils.ts


function Yieldbird_utils_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function Yieldbird_utils_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Yieldbird_utils_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Yieldbird_utils_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




function getYieldbirdDomainKey(hostname) {
  const normalizedHostname = (0,utils_url/* normalizeHost */.tb)(hostname);
  if (!(0,utils_url/* isInternalHostname */.SB)(normalizedHostname)) return ads/* MapHostnameToYieldbirdKey */.nu[hostnames/* Hostname.Pl */.Lp.Pl];
  return ads/* MapHostnameToYieldbirdKey */.nu[normalizedHostname];
}
function initYieldbird() {
  window.googletag = window.googletag || {
    cmd: []
  };
  window.ybConfiguration = window.ybConfiguration || {};
  window.ybConfiguration = Yieldbird_utils_objectSpread(Yieldbird_utils_objectSpread({}, window.ybConfiguration), {}, {
    integrationMethod: 'open_tag',
    smartRefreshDisabled: false
  });
  window.Yieldbird = window.Yieldbird || {
    cmd: []
  };
}
;// CONCATENATED MODULE: ./components/AdScripts/setups/Yieldbird/YieldbirdNew.tsx






const YieldbirdNew = () => {
  const yieldbirdDomainKey = getYieldbirdDomainKey((0,useLocation/* default */.Z)().host);
  (0,react.useEffect)(() => {
    initYieldbird();
  }, []);
  if (!yieldbirdDomainKey) return null;
  return /*#__PURE__*/(0,jsx_runtime.jsx)((script_default()), {
    id: "yieldbird-script",
    "data-testid": "yieldbird-script",
    src: "//cdn.qwtag.com/".concat(yieldbirdDomainKey, "/qw.js"),
    strategy: "lazyOnload"
  });
};

/* harmony default export */ var Yieldbird_YieldbirdNew = (YieldbirdNew);
;// CONCATENATED MODULE: ./components/AdScripts/setups/Yieldbird/YieldbirdOld.tsx



const YieldbirdOld = () => /*#__PURE__*/(0,jsx_runtime.jsx)((script_default()), {
  id: "yieldbird-script",
  "data-testid": "yieldbird-script",
  src: "//jscdn.yieldbird.com/d67edacf-d1f9-4edd-a8ea-a94a7f86c921/yb.js",
  strategy: "lazyOnload"
});

/* harmony default export */ var Yieldbird_YieldbirdOld = (YieldbirdOld);
;// CONCATENATED MODULE: ./components/AdScripts/setups/Yieldbird/Yieldbird.tsx






const Yieldbird = () => {
  const isUpdatedYieldBirdScriptEnabled = (0,es/* useSelector */.v9)((0,feature_switches_selectors/* getIsFeatureSwitchEnabled */.z)('web_ads_yieldbird_script_updated'));
  return isUpdatedYieldBirdScriptEnabled ? /*#__PURE__*/(0,jsx_runtime.jsx)(Yieldbird_YieldbirdNew, {}) : /*#__PURE__*/(0,jsx_runtime.jsx)(Yieldbird_YieldbirdOld, {});
};

/* harmony default export */ var Yieldbird_Yieldbird = (Yieldbird);
;// CONCATENATED MODULE: ./components/AdScripts/setups/Confiant/Confiant.tsx





const Confiant = () => {
  const isTargetingConsentGroupEnabled = (0,useIsConsentGroupEnabled/* default */.Z)(consent/* ConsentGroup.Targeting */.R0.Targeting);
  if (!isTargetingConsentGroupEnabled) return null;
  return /*#__PURE__*/(0,jsx_runtime.jsx)((script_default()), {
    id: "confiant-script",
    "data-testid": "confiant-script",
    src: "https://cdn.confiant-integrations.net/BvGg6QCjGuFUb4-LOhdNdnITfpg/gpt_and_prebid/config.js",
    strategy: "lazyOnload"
  });
};

/* harmony default export */ var Confiant_Confiant = (Confiant);
;// CONCATENATED MODULE: ./components/AdScripts/setups/Rokt/Rokt.tsx









const Rokt = () => {
  const resolveRef = (0,react.useRef)();
  const screenName = (0,es/* useSelector */.v9)(screen_selectors/* getScreenName */.G);
  const hasConsentedTargeting = (0,useIsConsentGroupEnabled/* default */.Z)(consent/* ConsentGroup.Targeting */.R0.Targeting);
  const hasConsentedPersonalisedAds = (0,useIsConsentGroupEnabled/* default */.Z)(consent/* ConsentGroup.PersonalisedAds */.R0.PersonalisedAds);
  const isInInbox = [screens/* Screen.ConversationList */.l.ConversationList, screens/* Screen.ConversationNew */.l.ConversationNew, screens/* Screen.ConversationReply */.l.ConversationReply].includes(screenName);
  const isScriptAvailable = isInInbox && hasConsentedTargeting && hasConsentedPersonalisedAds;

  function getRoktLauncher() {
    return window.Rokt.createLauncher({
      accountId: '3105142925732150316'
    });
  }

  function onRoktLoad() {
    var _resolveRef$current;

    (_resolveRef$current = resolveRef.current) === null || _resolveRef$current === void 0 ? void 0 : _resolveRef$current.call(resolveRef, getRoktLauncher());
  }

  (0,react.useEffect)(() => {
    if (!isScriptAvailable) return;
    window.RoktLauncher = new Promise(resolve => {
      resolveRef.current = resolve;
      if (!window.Rokt) return;
      resolve(getRoktLauncher());
    });
  }, [isScriptAvailable]);
  if (!isScriptAvailable) return null;
  return /*#__PURE__*/(0,jsx_runtime.jsx)((script_default()), {
    crossOrigin: "anonymous",
    id: "rokt-launcher",
    src: "https://apps.rokt.com/wsdk/integrations/launcher.js",
    strategy: "lazyOnload",
    onLoad: onRoktLoad
  });
};

/* harmony default export */ var Rokt_Rokt = (Rokt);
;// CONCATENATED MODULE: ./components/AdScripts/setups/Blockthrough/Blockthrough.tsx





const Blockthrough = () => {
  const domainName = (0,utils_url/* normalizeHost */.tb)((0,useLocation/* default */.Z)().host);
  return /*#__PURE__*/(0,jsx_runtime.jsx)((script_default()), {
    crossOrigin: "anonymous",
    id: "blockthrough-loader",
    src: "https://btloader.com/tag?o=5146663562248192&domain=".concat(domainName, "&upapi=true"),
    strategy: "lazyOnload"
  });
};

/* harmony default export */ var Blockthrough_Blockthrough = (Blockthrough);
;// CONCATENATED MODULE: ./components/AdScripts/components/RtbSetup/RtbSetup.tsx






















const RtbSetup = () => {
  const isSmartAdServerEnabled = (0,es/* useSelector */.v9)((0,feature_switches_selectors/* getIsFeatureSwitchEnabled */.z)('web_smart_adserver'));
  const isYieldBirdScriptEnabled = (0,es/* useSelector */.v9)((0,feature_switches_selectors/* getIsFeatureSwitchEnabled */.z)('web_ads_yieldbird_script'));
  const isRoktScriptEnabled = (0,es/* useSelector */.v9)((0,feature_switches_selectors/* getIsFeatureSwitchEnabled */.z)('web_ads_rokt_script'));
  const isRoktAbTestEnabled = (0,es/* useSelector */.v9)((0,ab_tests_selectors/* getIsAbTestOn */.Kn)('web_ads_rokt'));
  const isRoktEnabled = isRoktScriptEnabled && isRoktAbTestEnabled;
  const screenName = (0,es/* useSelector */.v9)(screen_selectors/* getScreenName */.G);
  const isBlockthroughScriptEnabled = (0,es/* useSelector */.v9)((0,feature_switches_selectors/* getIsFeatureSwitchEnabled */.z)('web_ads_blockthrough_script'));
  const isAdsPlatformWeb = ad_manager/* default.getAdsPlatform */.Z.getAdsPlatform() === ads/* AdPlatform.Web */.vU.Web;
  const isBlockthroughAbTestPage = [screens/* Screen.ConversationList */.l.ConversationList, screens/* Screen.ConversationNew */.l.ConversationNew, screens/* Screen.ConversationReply */.l.ConversationReply, screens/* Screen.Catalog */.l.Catalog, screens/* Screen.Item */.l.Item].includes(screenName);
  const isBlockthroughAbTestEnabled = isBlockthroughScriptEnabled && isAdsPlatformWeb && isBlockthroughAbTestPage;
  const adblockMonetisationAbTest = (0,useAbTest/* default */.Z)({
    abTestName: 'web_adblock_monetisation',
    shouldTrackExpose: isBlockthroughAbTestEnabled
  });
  const isBlockthroughFeatureEnabled = isBlockthroughAbTestEnabled && (adblockMonetisationAbTest === null || adblockMonetisationAbTest === void 0 ? void 0 : adblockMonetisationAbTest.variant) !== 'off';
  (0,react.useEffect)(() => {
    window.adPlacements = {};
  }, []);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Google_Google, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(Pubstack_Pubstack, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(Amazon_Amazon, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(Prebid_Prebid, {}), isSmartAdServerEnabled && /*#__PURE__*/(0,jsx_runtime.jsx)(SmartAdServer_SmartAdServer, {}), isYieldBirdScriptEnabled && /*#__PURE__*/(0,jsx_runtime.jsx)(Yieldbird_Yieldbird, {}), isRoktEnabled && /*#__PURE__*/(0,jsx_runtime.jsx)(Rokt_Rokt, {}), isBlockthroughFeatureEnabled && /*#__PURE__*/(0,jsx_runtime.jsx)(Blockthrough_Blockthrough, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(Confiant_Confiant, {})]
  });
};

/* harmony default export */ var RtbSetup_RtbSetup = (RtbSetup);
;// CONCATENATED MODULE: ./components/AdScripts/AdScripts.tsx







const AdScripts = () => {
  const systemConfiguration = (0,es/* useSelector */.v9)(system_configuration_selectors/* getSystemConfiguration */.q0);
  const placements = (0,es/* useSelector */.v9)(selectors/* getPlacements */.Qn);
  if (!placements.length) return null;
  const isLtUser = (systemConfiguration === null || systemConfiguration === void 0 ? void 0 : systemConfiguration.userCountry) === 'lt';
  return isLtUser ? /*#__PURE__*/(0,jsx_runtime.jsx)(DirectSetup_DirectSetup, {}) : /*#__PURE__*/(0,jsx_runtime.jsx)(RtbSetup_RtbSetup, {});
};

/* harmony default export */ var AdScripts_AdScripts = (AdScripts);
// EXTERNAL MODULE: ./libs/server-utils/hoc.tsx
var hoc = __webpack_require__(91890);
;// CONCATENATED MODULE: ./layouts/FullPage/FullPage.tsx


























 // TODO: figure out if we want to stick with using tracking screen names for logic




const policyFooterScreens = [screens/* Screen.ItemUpload */.l.ItemUpload, screens/* Screen.MessageList */.l.MessageList, screens/* Screen.MessageNew */.l.MessageNew, screens/* Screen.MessageReply */.l.MessageReply, screens/* Screen.PhoneVerification */.l.PhoneVerification, screens/* Screen.Checkout */.l.Checkout];
const inboxScreens = [screens/* Screen.MessageList */.l.MessageList, screens/* Screen.MessageNew */.l.MessageNew, screens/* Screen.MessageReply */.l.MessageReply];
const noSpacerBeforeMainFooterScreens = [screens/* Screen.Sustainability */.l.Sustainability, screens/* Screen.BusinessHomepage */.l.BusinessHomepage, screens/* Screen.About */.l.About, screens/* Screen.HowItWorks */.l.HowItWorks];

const resolveHeaderSearchType = pathname => {
  const FIRST_VALUE_AFTER_SLASH_INDEX = 1;
  const firstValueAfterSlash = pathname.split('/')[FIRST_VALUE_AFTER_SLASH_INDEX];
  if (firstValueAfterSlash === 'forum') return search/* SearchBarSearchType.Forum */.lz.Forum;
  if (firstValueAfterSlash === 'member') return search/* SearchBarSearchType.User */.lz.User;
  if (firstValueAfterSlash === 'help') return search/* SearchBarSearchType.Faq */.lz.Faq;
  return search/* SearchBarSearchType.Item */.lz.Item;
};

const FullPageLayout = _ref => {
  let {
    languages,
    catalogTree,
    shouldBreakoutLayout,
    hasNoNavigation,
    domainLinks,
    userAgent,
    children,
    isWhiteBackground = true
  } = _ref;
  const systemConfiguration = (0,es/* useSelector */.v9)(system_configuration_selectors/* getSystemConfiguration */.q0);
  const isWebGa4AnalyticsEnabled = (0,es/* useSelector */.v9)((0,feature_switches_selectors/* getIsFeatureSwitchEnabled */.z)('web_ga4_analytics'));
  const isContentOnly = (0,es/* useSelector */.v9)(session_selectors/* getIsContentOnlyView */.pJ);
  const screenName = (0,es/* useSelector */.v9)(screen_selectors/* getScreenName */.G);
  const router = (0,next_router.useRouter)();
  if (!systemConfiguration) return null;

  const renderHeader = () => {
    if (isContentOnly) return null;

    if (hasNoNavigation) {
      return /*#__PURE__*/(0,jsx_runtime.jsx)(HeaderNoNavigation_HeaderNoNavigation, {
        portal: systemConfiguration.portal
      });
    }

    return /*#__PURE__*/(0,jsx_runtime.jsx)(Header_Header, {
      languages: languages,
      catalogTree: catalogTree,
      searchType: resolveHeaderSearchType(router.pathname) // TODO: we should get isInCatalog value from the link same as it done in the BE https://github.com/vinted/core/blob/fb15dcd53ab6fd1dee5c46de2d07f55bd44b83a3/app/helpers/catalog_helper.rb#L29-L31
      ,
      isInCatalog: false,
      portal: systemConfiguration.portal,
      impressumUrl: systemConfiguration.urls.impressum,
      isBusinessAccountLinksVisible: systemConfiguration.businessAccountInformationalLinksVisible,
      isOurPlatformVisible: !!systemConfiguration.urls.ourPlatform
    });
  };

  const renderFooter = () => {
    if (isContentOnly) return null;
    const isInPolicyFooterScreen = policyFooterScreens.includes(screenName);

    if (!isInPolicyFooterScreen && !hasNoNavigation) {
      return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [!noSpacerBeforeMainFooterScreens.includes(screenName) && /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* default */.Z, {
          size: Spacer/* default.Size.X5Large */.Z.Size.X5Large
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "u-ui-margin-top-auto",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(MainFooter/* default */.Z, {
            isBusinessInfoLinksEnabled: systemConfiguration.businessAccountInformationalLinksVisible,
            isDigitalLawEnabled: !!systemConfiguration.urls.ourPlatform,
            onlineComplaintUrl: systemConfiguration.urls.onlineComplaints
          })
        })]
      });
    }

    const isInInboxScreen = inboxScreens.includes(screenName);
    return /*#__PURE__*/(0,jsx_runtime.jsx)(PolicyFooter_PolicyFooter, {
      isDigitalLawEnabled: !!systemConfiguration.urls.ourPlatform,
      isBusinessInfoLinksEnabled: systemConfiguration.businessAccountInformationalLinksVisible,
      onlineComplaintUrl: systemConfiguration.urls.onlineComplaints,
      isStatic: isInInboxScreen,
      noDivider: isInInboxScreen
    });
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(AdsProvider_AdsProvider, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(AdScripts_AdScripts, {}), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: classnames_default()('fullpage-layout is-wide', {
        'u-background-white': isWhiteBackground
      }),
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(InAppMessage_InAppMessage, {}), domainLinks && /*#__PURE__*/(0,jsx_runtime.jsx)(DomainSelectModal_DomainSelectModal, {
        domainLinks: domainLinks
      }), renderHeader(), /*#__PURE__*/(0,jsx_runtime.jsx)("main", {
        className: "site",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "site-wrapper",
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)(ErrorBoundary/* default */.Z, {
            FallbackComponent: ErrorBoundary/* default.LayoutError */.Z.LayoutError,
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Advertisement/* default */.Z, {
              shape: ads/* AdShape.Leaderboard */.In.Leaderboard
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("section", {
              className: "site-content",
              children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                className: classnames_default()({
                  container: !shouldBreakoutLayout
                }),
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                  className: classnames_default()({
                    container: shouldBreakoutLayout
                  }),
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)(VacationNotification_VacationNotification, {})
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                  className: "row u-position-relative",
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)("section", {
                    id: "content",
                    className: "site-content__content-section grid12",
                    children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                      className: "body-content",
                      children: children
                    })
                  })
                })]
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(AppBanner_AppBanner, {
              userAgent: userAgent
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(AdvertisementBlockCheck_AdvertisementBlockCheck, {}), isWebGa4AnalyticsEnabled && /*#__PURE__*/(0,jsx_runtime.jsx)(Analytics_GoogleAnalyticsTracker, {})]
          })
        })
      }), renderFooter(), /*#__PURE__*/(0,jsx_runtime.jsx)(GlobalTwoFAModal/* default */.Z, {})]
    })]
  });
};
/* harmony default export */ var FullPage = ((0,hoc/* withLayout */.X)(FullPageLayout));

/***/ }),

/***/ 52340:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_intl__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(80150);
/* harmony import */ var libs_utils_date__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(20868);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(35250);




const FormattedRelativeTime = _ref => {
  let {
    value
  } = _ref;
  if (Number.isNaN(value)) return null;
  const {
    value: selectedUnitValue,
    unit
  } = (0,libs_utils_date__WEBPACK_IMPORTED_MODULE_1__/* .selectUnit */ .WZ)(value);
  const formattedDate = new Date(value).toLocaleDateString(undefined, {
    hour: 'numeric',
    minute: 'numeric',
    second: 'numeric'
  });
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
    title: formattedDate,
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_intl__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
      unit: unit,
      value: selectedUnitValue
    })
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (FormattedRelativeTime);

/***/ }),

/***/ 41098:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Advertisement_Advertisement; }
});

// EXTERNAL MODULE: ../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(70079);
// EXTERNAL MODULE: ../node_modules/.pnpm/react-redux@7.2.8_react-dom@18.2.0_react@18.2.0/node_modules/react-redux/es/index.js + 22 modules
var es = __webpack_require__(3283);
// EXTERNAL MODULE: ../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/lodash.js
var lodash = __webpack_require__(61888);
// EXTERNAL MODULE: ../node_modules/.pnpm/classnames@2.2.6/node_modules/classnames/index.js
var classnames = __webpack_require__(3997);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ../app/state/ads/selectors.ts
var selectors = __webpack_require__(21021);
// EXTERNAL MODULE: ../app/state/screen/selectors.ts
var screen_selectors = __webpack_require__(10707);
// EXTERNAL MODULE: ../app/state/feature-switches/selectors.ts
var feature_switches_selectors = __webpack_require__(84353);
// EXTERNAL MODULE: ../app/constants/ads.ts
var ads = __webpack_require__(12196);
// EXTERNAL MODULE: ../app/constants/ui.ts
var ui = __webpack_require__(55370);
// EXTERNAL MODULE: ../app/constants/tracking/screens.ts
var screens = __webpack_require__(81898);
// EXTERNAL MODULE: ../app/hooks/useAbTest/useAbTest.ts
var useAbTest = __webpack_require__(30741);
// EXTERNAL MODULE: ../app/libs/common/ad-manager/ad-manager.ts + 1 modules
var ad_manager = __webpack_require__(68387);
// EXTERNAL MODULE: ../app/constants/consent.ts
var consent = __webpack_require__(23168);
// EXTERNAL MODULE: ../app/hooks/useIsConsentGroupEnabled/useIsConsentGroupEnabled.ts
var useIsConsentGroupEnabled = __webpack_require__(50049);
// EXTERNAL MODULE: ../app/hooks/useDebounce.ts
var useDebounce = __webpack_require__(58557);
;// CONCATENATED MODULE: ../app/components/Advertisement/useAdRenderedCheck/useAdRenderedCheck.ts





function useAdRenderedCheck(_ref) {
  let {
    targetElement,
    onAdRender = lodash.noop
  } = _ref;
  const debouncedOnAdRender = (0,useDebounce/* default */.Z)(onAdRender);
  const handleMutationObserver = (0,react.useCallback)(() => {
    const adElementHeight = (targetElement === null || targetElement === void 0 ? void 0 : targetElement.clientHeight) || 0;
    debouncedOnAdRender(adElementHeight >= ads/* SMALLEST_AD_HEIGHT */.UW);
  }, [debouncedOnAdRender, targetElement]);
  (0,react.useEffect)(() => {
    if (!targetElement) return lodash.noop;
    const observer = new MutationObserver(handleMutationObserver);
    observer.observe(targetElement, {
      attributes: true,
      childList: true,
      subtree: true
    });
    return () => observer.disconnect();
  }, [handleMutationObserver, targetElement]);
}

/* harmony default export */ var useAdRenderedCheck_useAdRenderedCheck = (useAdRenderedCheck);
// EXTERNAL MODULE: ../node_modules/.pnpm/@vinted+web-ui@39.0.0_@types+react@18.2.21_react-dom@18.2.0_react-lottie-player@1.5.4_react@18.2.0/node_modules/@vinted/web-ui/dist/esm/lib/Text/Text.js
var Text = __webpack_require__(10956);
// EXTERNAL MODULE: ../app/hooks/useTranslate.ts
var useTranslate = __webpack_require__(77895);
// EXTERNAL MODULE: ../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(35250);
;// CONCATENATED MODULE: ../app/components/Advertisement/AdInfo/AdInfo.tsx




const AdInfo = () => {
  const translate = (0,useTranslate/* default */.Z)('advertisements');
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: "ad-info",
    "data-testid": "ad-info",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(Text/* default */.Z, {
      type: Text/* default.Type.Caption */.Z.Type.Caption,
      theme: "muted",
      text: translate('advertisement')
    })
  });
};

/* harmony default export */ var AdInfo_AdInfo = (AdInfo);
;// CONCATENATED MODULE: ../app/components/Advertisement/DirectAdvertisement/DirectAdvertisement.tsx










const DirectAdvertisement = _ref => {
  let {
    id,
    config,
    onAdRender = lodash.noop
  } = _ref;
  const {
    0: adDivElement,
    1: setAdDivElement
  } = (0,react.useState)(null);
  const {
    0: isAdInfoVisible,
    1: setIsAdInfoVisible
  } = (0,react.useState)(false);
  const isConsentGroupEnabled = (0,useIsConsentGroupEnabled/* default */.Z)(consent/* ConsentGroup.Targeting */.R0.Targeting);
  const handleAdRender = (0,react.useCallback)(isAdVisible => {
    onAdRender(isAdVisible);
    setIsAdInfoVisible(isAdVisible);
  }, [onAdRender]);
  useAdRenderedCheck_useAdRenderedCheck({
    targetElement: adDivElement,
    onAdRender: handleAdRender
  });
  (0,react.useEffect)(() => {
    if (!adDivElement || !window.dimatter) return;
    window.dimatter.push([config.code]);
    window.dimatter.push(['_requestBanners', config.code]);
  }, [adDivElement, config, isConsentGroupEnabled]);
  if (!isConsentGroupEnabled) return null;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [isAdInfoVisible && /*#__PURE__*/(0,jsx_runtime.jsx)(AdInfo_AdInfo, {}), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      "data-testid": "direct-advertisement",
      id: id,
      ref: setAdDivElement,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        id: config.code,
        "data-testid": "direct-advertisement-node"
      })
    })]
  });
};

/* harmony default export */ var DirectAdvertisement_DirectAdvertisement = (DirectAdvertisement);
// EXTERNAL MODULE: ../app/libs/common/event-tracker/events.ts
var events = __webpack_require__(77368);
// EXTERNAL MODULE: ../app/hooks/useTracking/useTracking.ts
var useTracking = __webpack_require__(22390);
;// CONCATENATED MODULE: ../app/hooks/useIsConsentBannerLoaded/useIsConsentBannerLoaded.ts


const useIsConsentBannerLoaded = () => {
  const {
    0: isBannerLoaded,
    1: setIsBannerLoaded
  } = (0,react.useState)( true && !!window.OneTrust);
  const handleBannerLoaded = (0,react.useCallback)(() => {
    setIsBannerLoaded(true);
  }, []);
  (0,react.useEffect)(() => {
    window.addEventListener('bannerLoaded', handleBannerLoaded);
    return () => {
      window.removeEventListener('bannerLoaded', handleBannerLoaded);
    };
  }, [handleBannerLoaded]);
  return (0,react.useMemo)(() => isBannerLoaded, [isBannerLoaded]);
};

/* harmony default export */ var useIsConsentBannerLoaded_useIsConsentBannerLoaded = (useIsConsentBannerLoaded);
// EXTERNAL MODULE: ../app/state/consent/selectors.ts
var consent_selectors = __webpack_require__(48412);
// EXTERNAL MODULE: ../app/components/Advertisement/useAdLoadtimeLogging/useAdLoadtimeLogging.ts
var useAdLoadtimeLogging = __webpack_require__(55349);
;// CONCATENATED MODULE: ../app/components/Advertisement/RtbAdvertisement/RtbAdvertisement.tsx

















const RtbAdvertisement = _ref => {
  let {
    id,
    config,
    isManuallyRendered = false,
    isManuallyRefreshed = false,
    onAdRender = lodash.noop
  } = _ref;
  const placementSizeRef = (0,react.useRef)([0, 0]);
  const placementRegisteredRef = (0,react.useRef)(false);
  const {
    0: isAdInfoVisible,
    1: setIsAdInfoVisible
  } = (0,react.useState)(false);
  const {
    0: adDivElement,
    1: setAdDivElement
  } = (0,react.useState)(null);
  const isRefreshEnabled = (0,react.useMemo)(() => ad_manager/* default.getAdsPlatform */.Z.getAdsPlatform() === ads/* AdPlatform.Web */.vU.Web || config.shape === ads/* AdShape.Leaderboard */.In.Leaderboard, [config]);
  const translate = (0,useTranslate/* default */.Z)('advertisements');
  const {
    track
  } = (0,useTracking/* default */.Z)();
  const isCookieConsentVersion = (0,es/* useSelector */.v9)(consent_selectors/* getIsCookieConsentVersion */.C);
  const isConsentBannerLoaded = useIsConsentBannerLoaded_useIsConsentBannerLoaded();
  const {
    onRequest,
    onLoad
  } = (0,useAdLoadtimeLogging/* default */.Z)();
  const normalizePlacementSize = (0,react.useCallback)(size => {
    // Advertisement size is sometimes 1x1 or similar, even though the actual rendered ad is
    // of different size.
    if (!size) return size;
    if (typeof size === 'string') return size;
    const adCreativeElement = adDivElement === null || adDivElement === void 0 ? void 0 : adDivElement.firstElementChild;
    const [width, height] = size;
    let normalizedSize = [width, height];

    if (width <= 1 && adCreativeElement instanceof HTMLElement) {
      normalizedSize = [adCreativeElement.offsetWidth, adCreativeElement.offsetHeight];
    }

    return normalizedSize;
  }, [adDivElement]);
  const handleOnImpressionViewable = (0,react.useCallback)(event => {
    track((0,events/* viewAdEvent */.RK)({
      adUnitPath: event.slot.getAdUnitPath(),
      size: placementSizeRef.current,
      shape: config.shape,
      isMobileWeb: ad_manager/* default.getAdsPlatform */.Z.getAdsPlatform() === ads/* AdPlatform.Mobile */.vU.Mobile
    }));
  }, [track, config]);
  const handleOnPlacementRenderEnded = (0,react.useCallback)(event => {
    if (event.isEmpty || !event.size) return;
    placementSizeRef.current = normalizePlacementSize(event.size);
  }, [normalizePlacementSize]);
  const handleOnPlacementLoad = (0,react.useCallback)(event => {
    setIsAdInfoVisible(true);
    if (!event.slot) return;
    track((0,events/* receivedAdEvent */.Ef)({
      adUnitPath: event.slot.getAdUnitPath(),
      isMobileWeb: ad_manager/* default.getAdsPlatform */.Z.getAdsPlatform() === ads/* AdPlatform.Mobile */.vU.Mobile
    }));
    onLoad(event.slot.getAdUnitPath());
  }, [track, onLoad]);
  const registerPlacement = (0,react.useCallback)(() => {
    if (placementRegisteredRef.current) return;
    ad_manager/* default.registerPlacement */.Z.registerPlacement({
      placementConfig: config,
      id,
      onPlacementLoad: handleOnPlacementLoad,
      onPlacementRequest: onRequest,
      onPlacementRenderEnded: handleOnPlacementRenderEnded,
      onImpressionViewable: handleOnImpressionViewable,
      isRefreshEnabled,
      isManuallyRendered,
      isManuallyRefreshed,
      iframeTitle: translate('advertisement')
    });
    placementRegisteredRef.current = true;
  }, [config, id, handleOnPlacementLoad, handleOnPlacementRenderEnded, handleOnImpressionViewable, isManuallyRendered, isManuallyRefreshed, isRefreshEnabled, translate, onRequest]);
  const handleAdRender = (0,react.useCallback)(isAdVisible => {
    onAdRender(isAdVisible);
    setIsAdInfoVisible(isAdVisible);
  }, [onAdRender]);
  useAdRenderedCheck_useAdRenderedCheck({
    targetElement: adDivElement,
    onAdRender: handleAdRender
  });
  (0,react.useEffect)(() => {
    if (!adDivElement) return;
    const isConsentValuesLoaded = isCookieConsentVersion && isConsentBannerLoaded;

    if (isConsentValuesLoaded || !isCookieConsentVersion) {
      registerPlacement();
    }
  }, [adDivElement, registerPlacement, isCookieConsentVersion, isConsentBannerLoaded]);
  (0,react.useEffect)(() => {
    return () => {
      if (!placementRegisteredRef.current) return;
      ad_manager/* default.unregisterPlacement */.Z.unregisterPlacement(id);
    };
  }, [id]);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [isAdInfoVisible && /*#__PURE__*/(0,jsx_runtime.jsx)(AdInfo_AdInfo, {}), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      "data-testid": "rtb-advertisement",
      id: id,
      ref: setAdDivElement
    })]
  });
};

/* harmony default export */ var RtbAdvertisement_RtbAdvertisement = (RtbAdvertisement);
;// CONCATENATED MODULE: ../app/components/Advertisement/AdContent/AdContent.tsx





const AdContent = _ref => {
  let {
    id,
    placementConfig,
    isManuallyRefreshed,
    isManuallyRendered,
    onAdRender
  } = _ref;
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: "ad-content",
    children: placementConfig.kind === ads/* AdKind.Rtb */.$_.Rtb ? /*#__PURE__*/(0,jsx_runtime.jsx)(RtbAdvertisement_RtbAdvertisement, {
      id: id,
      config: placementConfig,
      isManuallyRendered: isManuallyRendered,
      isManuallyRefreshed: isManuallyRefreshed,
      onAdRender: onAdRender
    }) : /*#__PURE__*/(0,jsx_runtime.jsx)(DirectAdvertisement_DirectAdvertisement, {
      id: id,
      config: placementConfig,
      onAdRender: onAdRender
    })
  });
};

/* harmony default export */ var AdContent_AdContent = (AdContent);
// EXTERNAL MODULE: ../node_modules/.pnpm/@vinted+web-ui@39.0.0_@types+react@18.2.21_react-dom@18.2.0_react-lottie-player@1.5.4_react@18.2.0/node_modules/@vinted/web-ui/dist/esm/lib/Image/Image.js
var Image = __webpack_require__(37417);
// EXTERNAL MODULE: ../app/constants/index.ts
var constants = __webpack_require__(58814);
// EXTERNAL MODULE: ../app/hooks/useIsDarkMode.ts
var useIsDarkMode = __webpack_require__(54967);
;// CONCATENATED MODULE: ../app/components/Advertisement/AdPlaceholder/AdPlaceholder.tsx










const placeholderVariations = [{
  shape: ads/* AdShape.Leaderboard */.In.Leaderboard,
  placeholders: {
    desktop: ['/ads/placeholders/leaderboard/desktop-1', '/ads/placeholders/leaderboard/desktop-2', '/ads/placeholders/leaderboard/desktop-3'],
    mobile: ['/ads/placeholders/leaderboard/mobile-1', '/ads/placeholders/leaderboard/mobile-2', '/ads/placeholders/leaderboard/mobile-3']
  }
}];

const getAdPlaceholderImageSrc = (shape, isDarkMode, isMobile) => {
  var _placeholderVariation;

  const placeholders = (_placeholderVariation = placeholderVariations.find(_ref => {
    let {
      shape: variationShape
    } = _ref;
    return variationShape === shape;
  })) === null || _placeholderVariation === void 0 ? void 0 : _placeholderVariation.placeholders;
  if (!placeholders) return null;
  const darkModeSuffix = isDarkMode ? '-dark' : '';
  const platformPlaceholders = isMobile ? placeholders.mobile : placeholders.desktop;
  const randomIndex = Math.floor(Math.random() * platformPlaceholders.length);
  return "".concat(constants/* CDN_IMAGES_URL */.cJ).concat(platformPlaceholders[randomIndex]).concat(darkModeSuffix, ".png");
};

const AdPlaceholder = _ref2 => {
  let {
    shape
  } = _ref2;
  const translate = (0,useTranslate/* default */.Z)('advertisements');
  const isDarkMode = (0,useIsDarkMode/* default */.Z)();
  const isMobile = ad_manager/* default.getAdsPlatform */.Z.getAdsPlatform() === ads/* AdPlatform.Mobile */.vU.Mobile;
  const adPlaceholderImageSrc = (0,react.useMemo)(() => getAdPlaceholderImageSrc(shape, isDarkMode, isMobile), [shape, isDarkMode, isMobile]);
  if (!adPlaceholderImageSrc) return null;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: classnames_default()('ad-placeholder', "ad-placeholder--".concat(shape)),
    "data-testid": "ad-placeholder",
    "aria-hidden": "true",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Image/* ImageWithForwardedRef */.U, {
      testId: "ad-placeholder-image",
      src: adPlaceholderImageSrc
    }), !isMobile && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "ad-placeholder__text",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Text/* default */.Z, {
        type: Text/* default.Type.Subtitle */.Z.Type.Subtitle,
        theme: "primary",
        bold: true,
        text: translate('placeholder')
      })
    })]
  });
};

/* harmony default export */ var AdPlaceholder_AdPlaceholder = (AdPlaceholder);
// EXTERNAL MODULE: ../app/components/ErrorBoundary/ErrorBoundary.tsx + 4 modules
var ErrorBoundary = __webpack_require__(63753);
;// CONCATENATED MODULE: ../app/components/Advertisement/AdErrorBoundary/AdErrorBoundary.tsx






const AdErrorBoundary = _ref => {
  let {
    id,
    children,
    pageName,
    kind,
    dfpCode
  } = _ref;
  const {
    track
  } = (0,useTracking/* default */.Z)();
  const handleErrorBoundary = (0,react.useCallback)(error => {
    track((0,events/* crashAdComponentEvent */.kd)({
      error: error ? error.toString() : '',
      placementId: id,
      pageName,
      kind,
      dfpCode
    }));
  }, [id, dfpCode, pageName, kind, track]);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(ErrorBoundary/* default */.Z, {
    onError: handleErrorBoundary,
    children: children
  });
};

/* harmony default export */ var AdErrorBoundary_AdErrorBoundary = (AdErrorBoundary);
;// CONCATENATED MODULE: ../app/components/Advertisement/useStickyOptions/useStickyOptions.ts



function useStickyOptions(_ref) {
  let {
    isSticky,
    isRailsComponent,
    parentElement
  } = _ref;
  const {
    0: stickyOptions,
    1: setStickyOptions
  } = (0,react.useState)();
  (0,react.useEffect)(() => {
    var _document$querySelect;

    if (!document || !isSticky) {
      setStickyOptions(undefined);
      return;
    }

    const headerHeight = ((_document$querySelect = document.querySelector('.js-header')) === null || _document$querySelect === void 0 ? void 0 : _document$querySelect.offsetHeight) || 0;
    setStickyOptions({
      offset: headerHeight + ads/* STICKY_AD_SPACING */.E1
    });
  }, [isSticky]);
  (0,react.useEffect)(() => {
    // This is needed while we use react-on-rails
    // to output our React components
    //
    // TODO: Remove after we move to next.js
    if (!isRailsComponent || !parentElement || !stickyOptions) return; // eslint-disable-next-line no-param-reassign

    parentElement.style.top = "".concat(stickyOptions.offset, "px");
    parentElement.classList.add('ad-sticky');
  }, [isRailsComponent, parentElement, stickyOptions]);
  return stickyOptions;
}

/* harmony default export */ var useStickyOptions_useStickyOptions = (useStickyOptions);
;// CONCATENATED MODULE: ../app/components/Advertisement/Advertisement.tsx



















function useBlockthroughMediation() {
  // This utility is temporary, just to separate A/B test
  // related logic from the Advertisement component.
  //
  // TODO: Clean this up
  // When scaling web_adblock_monetisation (AB test)
  // And/or web_blockthrough_ads_script (Feature switch)
  const screenName = (0,es/* useSelector */.v9)(screen_selectors/* getScreenName */.G);
  const isBlockthroughScriptEnabled = (0,es/* useSelector */.v9)((0,feature_switches_selectors/* getIsFeatureSwitchEnabled */.z)('web_ads_blockthrough_script'));
  const isAdsPlatformWeb = ad_manager/* default.getAdsPlatform */.Z.getAdsPlatform() === ads/* AdPlatform.Web */.vU.Web;
  const isBlockthroughAbTestPage = [screens/* Screen.ConversationList */.l.ConversationList, screens/* Screen.ConversationNew */.l.ConversationNew, screens/* Screen.ConversationReply */.l.ConversationReply, screens/* Screen.Catalog */.l.Catalog, screens/* Screen.Item */.l.Item].includes(screenName);
  const isBlockthroughAbTestEnabled = isBlockthroughScriptEnabled && isAdsPlatformWeb && isBlockthroughAbTestPage;
  const adblockMonetisationAbTest = (0,useAbTest/* default */.Z)({
    abTestName: 'web_adblock_monetisation'
  });
  if (!isBlockthroughAbTestEnabled || !adblockMonetisationAbTest || adblockMonetisationAbTest.variant === 'off') return null;
  return "bt-test-".concat(adblockMonetisationAbTest.variant);
}

const Advertisement = _ref => {
  var _ref$current;

  let {
    id: propsId,
    shape,
    railsComponent,
    mediation = null,
    config,
    isManuallyRendered = false,
    isManuallyRefreshed = false,
    onAdRender = lodash.noop
  } = _ref;
  const ref = (0,react.useRef)(null);
  const {
    0: isAdRendered,
    1: setIsAdRendered
  } = (0,react.useState)(false);
  const blockthroughMediation = useBlockthroughMediation();
  const uiState = (0,es/* useSelector */.v9)(selectors/* getUiState */.gr);
  const placement = (0,es/* useSelector */.v9)((0,selectors/* getPlacementByShape */.ep)(shape, blockthroughMediation || mediation));
  const id = (0,react.useMemo)(() => propsId || ad_manager/* default.generatePlacementId */.Z.generatePlacementId(), [propsId]);
  const placementConfig = (0,react.useMemo)(() => config || placement, [config, placement]);
  const stickyOptions = useStickyOptions_useStickyOptions({
    isSticky: placementConfig === null || placementConfig === void 0 ? void 0 : placementConfig.options.isSticky,
    isRailsComponent: railsComponent,
    parentElement: (_ref$current = ref.current) === null || _ref$current === void 0 ? void 0 : _ref$current.parentElement
  });
  const handleAdRender = (0,react.useCallback)(isAdVisible => {
    onAdRender(isAdVisible);
    setIsAdRendered(isAdVisible);
  }, [onAdRender]);
  if (!placementConfig || uiState !== ui/* UiState.Idle */.C.Idle) return null;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(AdErrorBoundary_AdErrorBoundary, {
    id: id,
    pageName: placementConfig.page || ads/* AdPage.Unknown */.bu.Unknown,
    kind: placementConfig.kind,
    dfpCode: placementConfig.kind === ads/* AdKind.Rtb */.$_.Rtb ? placementConfig.dfpCode : placementConfig.code,
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: classnames_default()('ad-container', "ad-container--".concat(shape), !!stickyOptions && !railsComponent && 'ad-sticky', isAdRendered && 'ad-container--rendered'),
      "data-testid": "advertisement",
      style: railsComponent ? undefined : {
        top: stickyOptions === null || stickyOptions === void 0 ? void 0 : stickyOptions.offset
      },
      ref: ref,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(AdPlaceholder_AdPlaceholder, {
        shape: shape
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(AdContent_AdContent, {
        id: id,
        placementConfig: placementConfig,
        isManuallyRefreshed: isManuallyRefreshed,
        isManuallyRendered: isManuallyRendered,
        onAdRender: handleAdRender
      })]
    })
  });
};

/* harmony default export */ var Advertisement_Advertisement = (Advertisement);

/***/ }),

/***/ 55349:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(70079);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3283);
/* harmony import */ var state_feature_switches_selectors__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(84353);
/* harmony import */ var libs_common_event_tracker_events__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(77368);
/* harmony import */ var hooks_useTracking_useTracking__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(22390);






function useAdRenderedCheck() {
  const isAdsLoadTimeLoggingEnabled = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useSelector */ .v9)((0,state_feature_switches_selectors__WEBPACK_IMPORTED_MODULE_2__/* .getIsFeatureSwitchEnabled */ .z)('web_ads_load_time_logging'));
  const {
    track
  } = (0,hooks_useTracking_useTracking__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)();
  const adRequestTimestampRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(0);
  const onRequest = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(() => {
    if (!isAdsLoadTimeLoggingEnabled) return;
    adRequestTimestampRef.current = Date.now();
  }, [isAdsLoadTimeLoggingEnabled]);
  const onLoad = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(trackingCode => {
    if (!adRequestTimestampRef.current || !isAdsLoadTimeLoggingEnabled) return;
    const adLoadTime = Date.now() - adRequestTimestampRef.current;
    track((0,libs_common_event_tracker_events__WEBPACK_IMPORTED_MODULE_4__/* .timingEvent */ .bR)({
      section: 'ad_load',
      duration: adLoadTime,
      completionState: 'succeeded',
      data: trackingCode
    }));
  }, [track, isAdsLoadTimeLoggingEnabled]);
  return {
    onRequest,
    onLoad
  };
}

/* harmony default export */ __webpack_exports__["Z"] = (useAdRenderedCheck);

/***/ }),

/***/ 45736:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3283);
/* harmony import */ var _vinted_web_ui__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(37417);
/* harmony import */ var hooks_useTracking__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(22390);
/* harmony import */ var hooks_useTranslate__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(77895);
/* harmony import */ var constants_hostnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(46635);
/* harmony import */ var constants_index__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(58814);
/* harmony import */ var constants_tracking_clickable_elements__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(82722);
/* harmony import */ var libs_common_event_tracker_events__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(77368);
/* harmony import */ var state_intl_selectors__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(12761);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(35250);










var Platform;

(function (Platform) {
  Platform["Android"] = "android";
  Platform["Ios"] = "ios";
})(Platform || (Platform = {}));

const url = {
  [Platform.Android]: "https://".concat(constants_hostnames__WEBPACK_IMPORTED_MODULE_2__/* .Hostname.Fr */ .Lp.Fr, "/l/app-android-landing"),
  [Platform.Ios]: "https://".concat(constants_hostnames__WEBPACK_IMPORTED_MODULE_2__/* .Hostname.Fr */ .Lp.Fr, "/l/app-ios-landing")
};
const clickTarget = {
  [Platform.Android]: constants_tracking_clickable_elements__WEBPACK_IMPORTED_MODULE_3__/* .ClickableElement.DownloadAndroidApp */ .U.DownloadAndroidApp,
  [Platform.Ios]: constants_tracking_clickable_elements__WEBPACK_IMPORTED_MODULE_3__/* .ClickableElement.DownloadIosApp */ .U.DownloadIosApp
};

const AppButton = _ref => {
  let {
    platform
  } = _ref;
  const {
    track
  } = (0,hooks_useTracking__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)();
  const translate = (0,hooks_useTranslate__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)('app_store_buttons');
  const locale = (0,react_redux__WEBPACK_IMPORTED_MODULE_0__/* .useSelector */ .v9)(state_intl_selectors__WEBPACK_IMPORTED_MODULE_6__/* .getLocale */ .K);
  const imageDir = "".concat(constants_index__WEBPACK_IMPORTED_MODULE_7__/* .STATIC_ASSETS_URL */ .Fv, "/assets/app-badges/").concat(platform);
  const language = locale.split('-')[0];

  function handleClick() {
    track((0,libs_common_event_tracker_events__WEBPACK_IMPORTED_MODULE_8__/* .clickEvent */ .Q5)({
      target: clickTarget[platform]
    }));
  }

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("a", {
    href: url[platform],
    target: "_blank",
    rel: "noopener noreferrer",
    onClick: handleClick,
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_vinted_web_ui__WEBPACK_IMPORTED_MODULE_9__/* .ImageWithForwardedRef */ .U, {
      src: "".concat(imageDir, "/").concat(language, ".svg"),
      fallbackSrc: "".concat(imageDir, "/default.svg"),
      alt: translate("a11y.".concat(platform))
    })
  });
};

AppButton.Platform = Platform;
/* harmony default export */ __webpack_exports__["Z"] = (AppButton);

/***/ }),

/***/ 97274:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_waypoint__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(72963);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(70079);
/* harmony import */ var _vinted_web_ui__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(37417);
/* harmony import */ var _vinted_web_ui__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(10956);
/* harmony import */ var _vinted_web_ui__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(54);
/* harmony import */ var components_support__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(52340);
/* harmony import */ var constants_inbox_notification__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(14067);
/* harmony import */ var constants_images__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(36391);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(35250);










const InboxNotificationItem = _ref => {
  let {
    notification,
    onClick,
    onEnter,
    defaultHighlighted
  } = _ref; // we are using `useState` to protect `isHighlighted` from unwanted `defaultHighlighted` changes
  // so the setter is unused
  // eslint-disable-next-line react/hook-use-state

  const {
    0: isHighlighted
  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(defaultHighlighted);

  const renderImage = () => /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_vinted_web_ui__WEBPACK_IMPORTED_MODULE_3__/* .ImageWithForwardedRef */ .U, {
    src: notification.photoUrl,
    fallbackSrc: notification.type === constants_inbox_notification__WEBPACK_IMPORTED_MODULE_4__/* .InboxNotificationType.Braze */ .R.Braze ? constants_images__WEBPACK_IMPORTED_MODULE_5__/* .VINTED_LOGO_IMAGE_PATH */ .mn : undefined,
    size: _vinted_web_ui__WEBPACK_IMPORTED_MODULE_3__/* .ImageWithForwardedRef.Size.Large */ .U.Size.Large,
    styling: notification.photoStyle // TODO: check if we can use single style, rather than dynamic

  });

  const renderBody = () => /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.Fragment, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_vinted_web_ui__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
      text: notification.body,
      html: true,
      width: _vinted_web_ui__WEBPACK_IMPORTED_MODULE_6__/* ["default"].Width.Parent */ .Z.Width.Parent
    }), !!notification.note && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_vinted_web_ui__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
      type: _vinted_web_ui__WEBPACK_IMPORTED_MODULE_6__/* ["default"].Type.Subtitle */ .Z.Type.Subtitle,
      width: _vinted_web_ui__WEBPACK_IMPORTED_MODULE_6__/* ["default"].Width.Parent */ .Z.Width.Parent,
      text: notification.note,
      html: true
    }) // TODO: check if this is needed
    , /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_vinted_web_ui__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
      text: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(components_support__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
        value: notification.time
      }),
      type: _vinted_web_ui__WEBPACK_IMPORTED_MODULE_6__/* ["default"].Type.Subtitle */ .Z.Type.Subtitle,
      width: _vinted_web_ui__WEBPACK_IMPORTED_MODULE_6__/* ["default"].Width.Parent */ .Z.Width.Parent
    })]
  });

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(react_waypoint__WEBPACK_IMPORTED_MODULE_0__/* .Waypoint */ .h, {
    onEnter: onEnter,
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("div", {
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_vinted_web_ui__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
        type: notification.link ? _vinted_web_ui__WEBPACK_IMPORTED_MODULE_8__/* ["default"].Type.Navigating */ .Z.Type.Navigating : undefined,
        onClick: onClick,
        highlighted: isHighlighted,
        prefix: renderImage(),
        body: renderBody(),
        url: notification.link || undefined,
        testId: "user-notification-item".concat(isHighlighted ? '-highlighted' : '')
      })
    })
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (InboxNotificationItem);

/***/ }),

/***/ 11150:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _app_node_modules_pnpm_next_12_3_3_babel_core_7_14_3_react_dom_18_2_0_react_18_2_0_sass_1_49_9_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(39565);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(70079);
/* harmony import */ var constants_keyboard__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(24773);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(35250);




const LOWER_LIMIT = 0;
const TAB_INDEX = 0;

class ListNavigator extends react__WEBPACK_IMPORTED_MODULE_0__.Component {
  constructor() {
    super(...arguments);

    (0,_app_node_modules_pnpm_next_12_3_3_babel_core_7_14_3_react_dom_18_2_0_react_18_2_0_sass_1_49_9_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(this, "state", {
      highlightedResultIndex: this.props.highlightedResultIndex
    });

    (0,_app_node_modules_pnpm_next_12_3_3_babel_core_7_14_3_react_dom_18_2_0_react_18_2_0_sass_1_49_9_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(this, "divRef", /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.createRef)());

    (0,_app_node_modules_pnpm_next_12_3_3_babel_core_7_14_3_react_dom_18_2_0_react_18_2_0_sass_1_49_9_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(this, "handleKeyNavigation", event => {
      const {
        itemCount,
        onSelect,
        onHighlightedResultChange
      } = this.props;
      const {
        highlightedResultIndex
      } = this.state;
      const {
        key
      } = event;
      const upperLimit = itemCount - 1;
      if (!itemCount) return;

      switch (key) {
        case constants_keyboard__WEBPACK_IMPORTED_MODULE_3__/* .KeyboardKey.ArrowDown */ .u.ArrowDown:
          event.preventDefault();
          this.setHighlightedSearchResult((highlightedResultIndex !== null && highlightedResultIndex !== void 0 ? highlightedResultIndex : LOWER_LIMIT - 1) < upperLimit, 1, LOWER_LIMIT, onHighlightedResultChange);
          break;

        case constants_keyboard__WEBPACK_IMPORTED_MODULE_3__/* .KeyboardKey.ArrowUp */ .u.ArrowUp:
          event.preventDefault();
          this.setHighlightedSearchResult((highlightedResultIndex !== null && highlightedResultIndex !== void 0 ? highlightedResultIndex : upperLimit + 1) > LOWER_LIMIT, -1, upperLimit, onHighlightedResultChange);
          break;

        case constants_keyboard__WEBPACK_IMPORTED_MODULE_3__/* .KeyboardKey.Enter */ .u.Enter:
          if (highlightedResultIndex === null) break;
          event.preventDefault();
          if (onSelect) onSelect(highlightedResultIndex, event);
          break;

        default:
          this.resetHighlightedResult();
      }
    });
  }

  focusResultsContainer() {
    const {
      current: resultsContainer
    } = this.divRef;
    if (!resultsContainer) return;
    resultsContainer.focus();
  }

  setHighlightedSearchResult(isValueInRange, modifier, nullModifier, callback) {
    if (isValueInRange) {
      this.setState(prevState => ({
        highlightedResultIndex: prevState.highlightedResultIndex === null ? nullModifier : prevState.highlightedResultIndex + modifier
      }), () => callback === null || callback === void 0 ? void 0 : callback(this.state.highlightedResultIndex));
    } else {
      this.resetHighlightedResult();
    }
  }

  resetHighlightedResult() {
    this.setState({
      highlightedResultIndex: null
    });
  }

  render() {
    const {
      isListeningToEvents
    } = this.props;
    const {
      highlightedResultIndex
    } = this.state;
    const renderChildrenWithProps = this.props.children({
      highlightedResultIndex,
      focusResultsContainer: this.focusResultsContainer,
      handleKeyNavigation: this.handleKeyNavigation
    });
    if (!isListeningToEvents) return renderChildrenWithProps;
    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
      ref: this.divRef,
      onKeyDown: this.handleKeyNavigation,
      tabIndex: TAB_INDEX,
      "data-testid": "list-navigator-container",
      children: renderChildrenWithProps
    });
  }

}

(0,_app_node_modules_pnpm_next_12_3_3_babel_core_7_14_3_react_dom_18_2_0_react_18_2_0_sass_1_49_9_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(ListNavigator, "defaultProps", {
  highlightedResultIndex: null,
  isListeningToEvents: false
});

/* harmony default export */ __webpack_exports__["Z"] = (ListNavigator);

/***/ }),

/***/ 69496:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ MainFooter_MainFooter; }
});

// EXTERNAL MODULE: ../node_modules/.pnpm/@vinted+web-ui@39.0.0_@types+react@18.2.21_react-dom@18.2.0_react-lottie-player@1.5.4_react@18.2.0/node_modules/@vinted/web-ui/dist/esm/lib/Divider/Divider.js
var Divider = __webpack_require__(30842);
// EXTERNAL MODULE: ../app/components/SeparatedList/SeparatedList.tsx
var SeparatedList = __webpack_require__(31214);
// EXTERNAL MODULE: ../node_modules/.pnpm/react-redux@7.2.8_react-dom@18.2.0_react@18.2.0/node_modules/react-redux/es/index.js + 22 modules
var es = __webpack_require__(3283);
// EXTERNAL MODULE: ../node_modules/.pnpm/@vinted+web-ui@39.0.0_@types+react@18.2.21_react-dom@18.2.0_react-lottie-player@1.5.4_react@18.2.0/node_modules/@vinted/web-ui/dist/esm/lib/Spacer/Spacer.js
var Spacer = __webpack_require__(94247);
// EXTERNAL MODULE: ../app/constants/routes/index.ts
var routes = __webpack_require__(98923);
// EXTERNAL MODULE: ../app/constants/tracking/clickable-elements.ts
var clickable_elements = __webpack_require__(82722);
// EXTERNAL MODULE: ../app/hooks/useTracking/useTracking.ts
var useTracking = __webpack_require__(22390);
// EXTERNAL MODULE: ../app/hooks/useTranslate.ts
var useTranslate = __webpack_require__(77895);
// EXTERNAL MODULE: ../app/libs/common/event-tracker/events.ts
var events = __webpack_require__(77368);
// EXTERNAL MODULE: ../app/libs/utils/press-center.ts
var press_center = __webpack_require__(6933);
// EXTERNAL MODULE: ../app/libs/utils/window.ts
var utils_window = __webpack_require__(25937);
// EXTERNAL MODULE: ../app/state/feature-switches/selectors.ts
var selectors = __webpack_require__(84353);
// EXTERNAL MODULE: ../app/state/session/selectors.ts
var session_selectors = __webpack_require__(32707);
// EXTERNAL MODULE: ../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(35250);
;// CONCATENATED MODULE: ../app/components/MainFooter/LinksSection/LinkSectionGroup/LinkSectionGroup.tsx



const LinkSectionGroup = _ref => {
  let {
    title,
    children
  } = _ref;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
    className: "main-footer__links-section-item",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "main-footer__links-section-label",
      children: title
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("ul", {
      className: "main-footer__links-section-group",
      children: children
    })]
  });
};

/* harmony default export */ var LinkSectionGroup_LinkSectionGroup = (LinkSectionGroup);
;// CONCATENATED MODULE: ../app/components/MainFooter/LinksSection/LinkSectionItem/LinkSectionItem.tsx


const LinkSectionItem = _ref => {
  let {
    text,
    url,
    onClick
  } = _ref;
  return /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
    className: "main-footer__links-section-row",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
      className: "main-footer__links-section-link",
      href: url,
      onClick: onClick,
      children: text
    })
  });
};

/* harmony default export */ var LinkSectionItem_LinkSectionItem = (LinkSectionItem);
;// CONCATENATED MODULE: ../app/components/MainFooter/LinksSection/LinksSection.tsx

















const LinksSection = _ref => {
  let {
    isBusinessInfoLinksEnabled
  } = _ref;
  const isJobsPageEnabled = (0,es/* useSelector */.v9)((0,selectors/* getIsFeatureSwitchEnabled */.z)('jobs_page'));
  const isForumDisabled = (0,es/* useSelector */.v9)((0,selectors/* getIsFeatureSwitchEnabled */.z)('disable_forum_web'));
  const isSustainabilityPageEnabled = (0,es/* useSelector */.v9)((0,selectors/* getIsFeatureSwitchEnabled */.z)('sustainability_page_press_center_link'));
  const isPressMenuEnabled = (0,es/* useSelector */.v9)((0,selectors/* getIsFeatureSwitchEnabled */.z)('press_menu'));
  const user = (0,es/* useSelector */.v9)(session_selectors/* getUser */.PR);
  const locale = (0,es/* useSelector */.v9)(utils_window/* getLocale */.Kd);
  const isPressCenterLinkEnabled = (0,es/* useSelector */.v9)((0,selectors/* getIsFeatureSwitchEnabled */.z)('web_press_center_link'));
  const isNewJobsUrlEnabled = (0,es/* useSelector */.v9)((0,selectors/* getIsFeatureSwitchEnabled */.z)('new_jobs_career_portal'));
  const shortLocale = locale.substring(0, 2);
  const pressUrl = isPressCenterLinkEnabled ? (0,press_center/* getPressCenterUrl */.J)(shortLocale) : routes/* PRESS_URL */.v6v;
  const jobsUrl = isNewJobsUrlEnabled ? routes/* JOBS_URL_NEW */.VHG : routes/* JOBS_URL */.Ch7;
  const translate = (0,useTranslate/* default */.Z)('footer');
  const {
    track
  } = (0,useTracking/* default */.Z)();

  function handleSustainabilityClick() {
    track((0,events/* clickEvent */.Q5)({
      target: clickable_elements/* ClickableElement.SustainabilityPageLink */.U.SustainabilityPageLink,
      targetDetails: 'navigation_web'
    }));
  }

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
    className: "main-footer__links-section",
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(LinkSectionGroup_LinkSectionGroup, {
      title: translate('company.title'),
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(LinkSectionItem_LinkSectionItem, {
        text: translate('company.items.about'),
        url: routes/* MAIN_NAVIGATION_ABOUT_TAB_URL */.ouD
      }), isJobsPageEnabled && /*#__PURE__*/(0,jsx_runtime.jsx)(LinkSectionItem_LinkSectionItem, {
        text: translate('company.items.jobs'),
        url: jobsUrl
      }), isSustainabilityPageEnabled && /*#__PURE__*/(0,jsx_runtime.jsx)(LinkSectionItem_LinkSectionItem, {
        text: translate('company.items.sustainability'),
        url: (0,press_center/* getSustainabilityUrl */.E)(shortLocale),
        onClick: handleSustainabilityClick
      }), isPressMenuEnabled && /*#__PURE__*/(0,jsx_runtime.jsx)(LinkSectionItem_LinkSectionItem, {
        text: translate('company.items.press'),
        url: pressUrl
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(LinkSectionItem_LinkSectionItem, {
        text: translate('company.items.advertising'),
        url: routes/* ADVERTISING_URL */.E2e
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(LinkSectionGroup_LinkSectionGroup, {
      title: translate('discover.title'),
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(LinkSectionItem_LinkSectionItem, {
        text: translate('discover.items.how_it_works'),
        url: routes/* HOW_IT_WORKS_URL */.OkD
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(LinkSectionItem_LinkSectionItem, {
        text: translate('discover.items.app'),
        url: routes/* APP_LANDING_URL */.QwI
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(LinkSectionItem_LinkSectionItem, {
        text: translate('discover.items.help'),
        url: routes/* HELP_CENTER_URL */.lw5
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(LinkSectionItem_LinkSectionItem, {
        text: translate('discover.items.infoboard'),
        url: routes/* INFOBOARD_URL */.Ga_
      }), isBusinessInfoLinksEnabled && /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(LinkSectionItem_LinkSectionItem, {
          text: translate('discover.items.pro'),
          url: routes/* BUSINESS_ACCOUNTS_HOMEPAGE */.Jo
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(LinkSectionItem_LinkSectionItem, {
          text: translate('discover.items.pro_guide'),
          url: routes/* BUSINESS_ACCOUNTS_GUIDE_URL */._qi
        })]
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(LinkSectionGroup_LinkSectionGroup, {
      title: translate('help.title'),
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(LinkSectionItem_LinkSectionItem, {
        text: translate('help.items.centre'),
        url: routes/* HELP_CENTER_URL */.lw5
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(LinkSectionItem_LinkSectionItem, {
        text: translate('help.items.selling'),
        url: routes/* HELP_SELLING_URL */.vXD
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(LinkSectionItem_LinkSectionItem, {
        text: translate('help.items.buying'),
        url: routes/* HELP_BUYING_URL */.dML
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(LinkSectionItem_LinkSectionItem, {
        text: translate('help.items.safety'),
        url: routes/* HELP_SAFETY_URL */.c1u
      })]
    }), isForumDisabled ? /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* default */.Z, {
      orientation: Spacer/* default.Orientation.Vertical */.Z.Orientation.Vertical
    }) : /*#__PURE__*/(0,jsx_runtime.jsxs)(LinkSectionGroup_LinkSectionGroup, {
      title: translate('community.title'),
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(LinkSectionItem_LinkSectionItem, {
        text: translate('community.items.forum'),
        url: routes/* FORUM_HOME_URL */.R1Q
      }), !!(user !== null && user !== void 0 && user.favourite_topic_count) && /*#__PURE__*/(0,jsx_runtime.jsx)(LinkSectionItem_LinkSectionItem, {
        text: translate('community.items.forum_favourite_topics'),
        url: routes/* FORUM_FAVOURITE_TOPICS_URL */.Nei
      }), !!user && /*#__PURE__*/(0,jsx_runtime.jsx)(LinkSectionItem_LinkSectionItem, {
        text: translate('community.items.forum_own_topics'),
        url: routes/* FORUM_OWN_TOPICS_URL */.AnP
      })]
    })]
  });
};

/* harmony default export */ var LinksSection_LinksSection = (LinksSection);
// EXTERNAL MODULE: ../app/hooks/useLocation/useLocation.ts
var useLocation = __webpack_require__(62889);
// EXTERNAL MODULE: ../app/constants/consent.ts
var consent = __webpack_require__(23168);
// EXTERNAL MODULE: ../app/libs/utils/url.ts
var url = __webpack_require__(18697);
// EXTERNAL MODULE: ../app/state/consent/selectors.ts
var consent_selectors = __webpack_require__(48412);
;// CONCATENATED MODULE: ../app/components/MainFooter/PrivacySection/SectionLink/SectionLink.tsx


const SectionLink = _ref => {
  let {
    text,
    url,
    testId
  } = _ref;
  return /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
    className: "main-footer__privacy-section-item",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
      className: "main-footer__privacy-section-link",
      href: url,
      "data-testid": testId,
      children: text
    })
  });
};

/* harmony default export */ var SectionLink_SectionLink = (SectionLink);
;// CONCATENATED MODULE: ../app/components/MainFooter/PrivacySection/PrivacySection.tsx













const PrivacySection = _ref => {
  let {
    isDigitalLawEnabled,
    isBusinessInfoLinksEnabled,
    onlineComplaintUrl
  } = _ref;
  const translate = (0,useTranslate/* default */.Z)('footer.policy.items');
  const isCookieConsentVersion = (0,es/* useSelector */.v9)(consent_selectors/* getIsCookieConsentVersion */.C);
  const cookieConsentVersion = (0,es/* useSelector */.v9)(consent_selectors/* getCookieConsentVersion */.K);
  const {
    host
  } = (0,useLocation/* default */.Z)();

  const handleCookieSettingsClick = () => {
    (0,utils_window/* toggleOneTrustInfoDisplay */.ap)();
  };

  const cookieSettingsText = cookieConsentVersion === consent/* CookieConsentVersion.California */.I1.California ? translate('cookie_settings_us') : translate('cookie_settings');
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
    className: "main-footer__privacy-section",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(SectionLink_SectionLink, {
      text: translate('privacy_policy'),
      url: (0,url/* getOldHostRedirectUrl */.E_)(host) + routes/* PRIVACY_POLICY_URL */.hOY
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(SectionLink_SectionLink, {
      text: translate('cookie_policy'),
      url: routes/* COOKIE_POLICY_URL */.ljN
    }), isCookieConsentVersion && /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
      className: "main-footer__privacy-section-item",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
        className: "main-footer__privacy-section-link",
        type: "button",
        onClick: handleCookieSettingsClick,
        children: cookieSettingsText
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(SectionLink_SectionLink, {
      text: translate('terms_and_conditions'),
      url: routes/* TERMS_URL */.qyY
    }), isDigitalLawEnabled && /*#__PURE__*/(0,jsx_runtime.jsx)(SectionLink_SectionLink, {
      text: translate('our_platform'),
      url: routes/* OUR_PLATFORM_URL */.Nc0
    }), isBusinessInfoLinksEnabled && /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(SectionLink_SectionLink, {
        text: translate('pro_terms_of_sale'),
        url: routes/* BUSINESS_TERMS_OF_SALE_URL */.$ru,
        testId: "privacy-footer-pro-sale-term-link"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(SectionLink_SectionLink, {
        text: translate('pro_terms_of_use'),
        url: routes/* BUSINESS_TERMS_URL */.vK_,
        testId: "privacy-footer-pro-use-term-link"
      })]
    }), onlineComplaintUrl && /*#__PURE__*/(0,jsx_runtime.jsx)(SectionLink_SectionLink, {
      text: translate('online_complaints'),
      url: onlineComplaintUrl
    })]
  });
};

/* harmony default export */ var PrivacySection_PrivacySection = (PrivacySection);
// EXTERNAL MODULE: ../node_modules/.pnpm/@vinted+web-ui@39.0.0_@types+react@18.2.21_react-dom@18.2.0_react-lottie-player@1.5.4_react@18.2.0/node_modules/@vinted/web-ui/dist/esm/lib/Image/Image.js
var Image = __webpack_require__(37417);
// EXTERNAL MODULE: ../app/constants/index.ts
var constants = __webpack_require__(58814);
// EXTERNAL MODULE: ../app/components/AppStoreButtons/AppButton/AppButton.tsx
var AppButton = __webpack_require__(45736);
;// CONCATENATED MODULE: ../app/components/MainFooter/SocialSection/SocialSection.tsx






const FACEBOOK_LOGO = "".concat(constants/* STATIC_ASSETS_URL */.Fv, "/assets/icons/social-media/facebook.svg");
const LINKEDIN_LOGO = "".concat(constants/* STATIC_ASSETS_URL */.Fv, "/assets/icons/social-media/linkedin.svg");
const INSTAGRAM_LOGO = "".concat(constants/* STATIC_ASSETS_URL */.Fv, "/assets/icons/social-media/instagram.svg");

const SocialSection = () => {
  const renderSocialItem = (url, logo) => /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
    className: "main-footer__social-media-item",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
      className: "main-footer__social-media-link",
      href: url,
      target: "_blank",
      rel: "noopener noreferrer",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Image/* ImageWithForwardedRef */.U, {
        src: logo
      })
    })
  });

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: "main-footer__social-section",
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
      className: "main-footer__social-section-media",
      children: [renderSocialItem(routes/* SOCIAL_FACEBOOK_URL */.tk0, FACEBOOK_LOGO), renderSocialItem(routes/* SOCIAL_LINKEDIN_URL */.q0m, LINKEDIN_LOGO), renderSocialItem(routes/* SOCIAL_INSTAGRAM_URL */.fds, INSTAGRAM_LOGO)]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
      className: "main-footer__social-section-app-store",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        className: "main-footer__social-app-store-item",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(AppButton/* default */.Z, {
          platform: AppButton/* default.Platform.Ios */.Z.Platform.Ios
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        className: "main-footer__social-app-store-item",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(AppButton/* default */.Z, {
          platform: AppButton/* default.Platform.Android */.Z.Platform.Android
        })
      })]
    })]
  });
};

/* harmony default export */ var SocialSection_SocialSection = (SocialSection);
;// CONCATENATED MODULE: ../app/components/MainFooter/MainFooter.tsx








const MainFooter = _ref => {
  let {
    isDigitalLawEnabled,
    isBusinessInfoLinksEnabled,
    onlineComplaintUrl
  } = _ref;
  return /*#__PURE__*/(0,jsx_runtime.jsx)("footer", {
    className: "main-footer",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "main-footer__content tear tear--top",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "container",
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)(SeparatedList/* default */.Z, {
          separator: /*#__PURE__*/(0,jsx_runtime.jsx)(Divider/* default */.Z, {}),
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(LinksSection_LinksSection, {
            isBusinessInfoLinksEnabled: isBusinessInfoLinksEnabled
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(SocialSection_SocialSection, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(PrivacySection_PrivacySection, {
            isDigitalLawEnabled: isDigitalLawEnabled,
            isBusinessInfoLinksEnabled: isBusinessInfoLinksEnabled,
            onlineComplaintUrl: onlineComplaintUrl
          })]
        })
      })
    })
  });
};

/* harmony default export */ var MainFooter_MainFooter = (MainFooter);

/***/ }),

/***/ 48846:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3997);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(35250);



const ScrollableArea = _ref => {
  let {
    children,
    maxWidth,
    maxHeight,
    className
  } = _ref;
  if (!children) return null;
  const classes = classnames__WEBPACK_IMPORTED_MODULE_0___default()('u-overflow-auto', className);
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
    className: classes,
    style: {
      maxWidth,
      maxHeight
    },
    children: children
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (ScrollableArea);

/***/ }),

/***/ 35045:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "DA": function() { return /* binding */ HC_SEARCH_SESSION_ID_COOKIE_KEY; },
/* harmony export */   "tj": function() { return /* binding */ HC_HOME_VISIBLE_TRANSACTION_COUNT; },
/* harmony export */   "vy": function() { return /* binding */ HC_ROOT_FAQ_ID; }
/* harmony export */ });
const HC_HOME_VISIBLE_TRANSACTION_COUNT = 3;
const HC_SEARCH_SESSION_ID_COOKIE_KEY = 'help_center_search_session_id';
const HC_ROOT_FAQ_ID = 3;

/***/ }),

/***/ 14067:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ InboxNotificationType; }
/* harmony export */ });
let InboxNotificationType;

(function (InboxNotificationType) {
  InboxNotificationType["Vinted"] = "vinted";
  InboxNotificationType["Braze"] = "braze";
})(InboxNotificationType || (InboxNotificationType = {}));

/***/ }),

/***/ 2685:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ns": function() { return /* binding */ OrdersType; },
/* harmony export */   "aQ": function() { return /* binding */ DEFAULT_PER_PAGE; },
/* harmony export */   "iF": function() { return /* binding */ OrderStatus; }
/* harmony export */ });
/* unused harmony export MyOrdersUserRole */
let MyOrdersUserRole;

(function (MyOrdersUserRole) {
  MyOrdersUserRole["Seller"] = "seller";
  MyOrdersUserRole["Buyer"] = "buyer";
})(MyOrdersUserRole || (MyOrdersUserRole = {}));

let OrdersType;

(function (OrdersType) {
  OrdersType["All"] = "all";
  OrdersType["Sold"] = "sold";
  OrdersType["Purchased"] = "purchased";
})(OrdersType || (OrdersType = {}));

let OrderStatus;

(function (OrderStatus) {
  OrderStatus["All"] = "all";
  OrderStatus["InProgress"] = "in_progress";
  OrderStatus["Completed"] = "completed";
  OrderStatus["Canceled"] = "canceled";
})(OrderStatus || (OrderStatus = {}));

const DEFAULT_PER_PAGE = 20;

/***/ }),

/***/ 80782:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "G": function() { return /* binding */ ViewableElement; }
/* harmony export */ });
let ViewableElement;

(function (ViewableElement) {
  ViewableElement["FacebookLikeButton"] = "facebook_like_button";
  ViewableElement["MyItemsGrid"] = "my_items_grid";
  ViewableElement["MyItemsList"] = "my_items_list";
  ViewableElement["MyFavoritesGrid"] = "my_favorites_grid";
  ViewableElement["MyFavoritesList"] = "my_favorites_list";
  ViewableElement["MeasurementsInfo"] = "measurements_info";
  ViewableElement["CatalogGrid"] = "catalog_grid";
  ViewableElement["CatalogList"] = "catalog_list";
  ViewableElement["NpsSurvey"] = "nps_survey";
  ViewableElement["SellTabSurvey"] = "sell_tab_survey";
  ViewableElement["SellerAfterUploadInstructions"] = "seller_after_upload_instructions";
  ViewableElement["SellerAfterSaleInstructions"] = "seller_after_sale_instructions";
  ViewableElement["SellerAfterTransactionCompleteInstructions"] = "seller_after_transaction_complete_instructions";
  ViewableElement["EmailConfirmation"] = "email_confirmation";
  ViewableElement["EmailConfirmed"] = "email_confirmed";
  ViewableElement["Video"] = "video";
  ViewableElement["SellerBanner"] = "seller_banner";
  ViewableElement["SellTabBanner"] = "sell_tab_banner";
  ViewableElement["SellerFunnelWelcomeSlide"] = "seller_funnel_welcome_slide";
  ViewableElement["WalletSetupSuccess"] = "wallet_setup_success";
  ViewableElement["WalletPayInSuccess"] = "wallet_pay_in_success";
  ViewableElement["NewsletterSubscriptionBanner"] = "newsletter_subscription_banner";
  ViewableElement["EditorialCampaignBanner"] = "editorial_campaign_banner";
  ViewableElement["CtaPrompty"] = "cta_prompt";
  ViewableElement["FeedPersonalizationBanner"] = "feed_personalization_banner";
  ViewableElement["PersonalizationBannerAfterFeed"] = "personalization_banner_after_feed";
  ViewableElement["AdBox"] = "ad_box";
  ViewableElement["BumpPromotion"] = "bump_promotion";
  ViewableElement["OnboardingModalCard"] = "onboarding_modal_card";
  ViewableElement["AppRatingDialog"] = "app_rating_dialog";
  ViewableElement["UploadOnboardingCarouselCard"] = "upload_onboarding_carousel_card";
  ViewableElement["Notification"] = "notification";
  ViewableElement["SeeWholeClosetCta"] = "see_whole_closet_cta";
  ViewableElement["CookieAndAdPersonalizationBanner"] = "cookie_and_ad_personalization_banner";
  ViewableElement["AdPersonalizationToggle"] = "ad_personalization_toggle";
  ViewableElement["ShippingPrice"] = "shipping_price";
  ViewableElement["TranslationHint"] = "translation_hint";
  ViewableElement["LocalSearchSuggestion"] = "local_search_suggestion";
  ViewableElement["BrandClusterSection"] = "brand_cluster_section";
  ViewableElement["PhotoPickerInfoBanner"] = "photo_picker_info_banner";
  ViewableElement["CrmMessageVideo"] = "crm_message_video";
  ViewableElement["FreeReturnLabelModal"] = "free_return_label_modal";
  ViewableElement["LabelTypeSelection"] = "label_type_selection";
  ViewableElement["PushUpOrderConfirmation"] = "push_up_order_confirm";
  ViewableElement["ReturnOrder"] = "return_order";
  ViewableElement["ShipFastBadgeDescription"] = "ship_fast_badge_description";
  ViewableElement["VideoStoryFeed"] = "video_story_feed";
  ViewableElement["VideoStory"] = "video_story";
  ViewableElement["PhysicalAuthenticityBuyerModal"] = "physical_auth_buyer";
  ViewableElement["OfflineVerificationSellerModal"] = "physical_auth_seller";
  ViewableElement["OfflineVerificationStatus"] = "physical_auth_eligible";
  ViewableElement["ValueSelectModal"] = "value_select_modal";
  ViewableElement["CtaPrompt"] = "cta_prompt";
})(ViewableElement || (ViewableElement = {}));

/***/ }),

/***/ 67509:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Rq": function() { return /* binding */ VerificationMethods; },
/* harmony export */   "br": function() { return /* binding */ VerificationActions; },
/* harmony export */   "ii": function() { return /* binding */ VerificationPromptCategory; }
/* harmony export */ });
let VerificationPromptCategory;

(function (VerificationPromptCategory) {
  VerificationPromptCategory["GoodActor"] = "good_actor";
  VerificationPromptCategory["BadActor"] = "bad_actor";
})(VerificationPromptCategory || (VerificationPromptCategory = {}));

let VerificationMethods;

(function (VerificationMethods) {
  VerificationMethods["Email"] = "email";
  VerificationMethods["Phone"] = "phone";
  VerificationMethods["EmailCode"] = "email_code";
  VerificationMethods["Google"] = "google";
})(VerificationMethods || (VerificationMethods = {}));

let VerificationActions;

(function (VerificationActions) {
  VerificationActions["BalanceWithdrawal"] = "balance_withdrawal";
  VerificationActions["AccountDeletion"] = "account_deletion";
  VerificationActions["DataExport"] = "data_export";
})(VerificationActions || (VerificationActions = {}));

/***/ }),

/***/ 88708:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ withTracking; }
/* harmony export */ });
/* harmony import */ var _app_node_modules_pnpm_next_12_3_3_babel_core_7_14_3_react_dom_18_2_0_react_18_2_0_sass_1_49_9_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(39565);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(70079);
/* harmony import */ var libs_utils_react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(45558);
/* harmony import */ var _TrackingContext__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67230);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(35250);


function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,_app_node_modules_pnpm_next_12_3_3_babel_core_7_14_3_react_dom_18_2_0_react_18_2_0_sass_1_49_9_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}





function withTracking(WrappedComponent) {
  var _class;

  return _class = class InjectTracking extends react__WEBPACK_IMPORTED_MODULE_1__.Component {
    render() {
      return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_TrackingContext__WEBPACK_IMPORTED_MODULE_3__/* ["default"].Consumer */ .Z.Consumer, {
        children: trackerProps => {
          if (!trackerProps) throw new Error('Missing tracking provider');
          return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(WrappedComponent, _objectSpread(_objectSpread({}, this.props), {}, {
            track: trackerProps.tracker.track
          }));
        }
      });
    }

  }, (0,_app_node_modules_pnpm_next_12_3_3_babel_core_7_14_3_react_dom_18_2_0_react_18_2_0_sass_1_49_9_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_class, "displayName", (0,libs_utils_react__WEBPACK_IMPORTED_MODULE_4__/* .getDisplayName */ .Gf)(WrappedComponent)), (0,_app_node_modules_pnpm_next_12_3_3_babel_core_7_14_3_react_dom_18_2_0_react_18_2_0_sass_1_49_9_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_class, "WrappedComponent", WrappedComponent), _class;
}

/***/ }),

/***/ 19066:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Hd": function() { return /* binding */ transformBrazeInboxMessageCardDto; },
/* harmony export */   "LP": function() { return /* binding */ transformBrazePromoBoxCardDto; },
/* harmony export */   "NA": function() { return /* binding */ transformBrazeModalInAppMessageDto; },
/* harmony export */   "h8": function() { return /* binding */ transformBrazeSlideUpInAppMessageDto; },
/* harmony export */   "su": function() { return /* binding */ transformBrazeInboxCardNotificationDto; },
/* harmony export */   "vA": function() { return /* binding */ transformBrazeFullScreenInAppMessageDto; }
/* harmony export */ });
/* unused harmony export transformInAppMessageTrackingData */
/* harmony import */ var _app_node_modules_pnpm_next_12_3_3_babel_core_7_14_3_react_dom_18_2_0_react_18_2_0_sass_1_49_9_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(39565);
/* harmony import */ var _vinted_web_ui__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(37417);
/* harmony import */ var types_components__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(83989);
/* harmony import */ var constants_images__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(36391);
/* harmony import */ var constants_index__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(14067);
/* harmony import */ var constants_index__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(80819);
/* harmony import */ var constants_index__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(7402);
/* harmony import */ var constants_index__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(58814);
/* harmony import */ var types_models_in_app_message__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(92593);
/* harmony import */ var libs_common_braze_utils_error_loggers__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(83663);


function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,_app_node_modules_pnpm_next_12_3_3_babel_core_7_14_3_react_dom_18_2_0_react_18_2_0_sass_1_49_9_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}







const transformInAppMessageTrackingData = dto => {
  let result;

  try {
    result = JSON.parse(dto.extras.tracking);
  } catch (_unused) {
    (0,libs_common_braze_utils_error_loggers__WEBPACK_IMPORTED_MODULE_1__/* .logContentParseError */ .Di)(dto.message, 'in-app-message', dto.extras.tracking);
    result = {};
  }

  return {
    campaignName: result.campaign_name,
    campaignMessageName: result.campaign_message_name,
    canvasName: result.canvas_name,
    canvasVariantName: result.canvas_variant_name
  };
};
const transformBrazeInboxCardNotificationDto = dto => ({
  id: dto.id,
  body: dto.description,
  link: dto.url,
  photoUrl: dto.extras.logoURL || constants_images__WEBPACK_IMPORTED_MODULE_2__/* .VINTED_LOGO_IMAGE_PATH */ .mn,
  photoStyle: _vinted_web_ui__WEBPACK_IMPORTED_MODULE_3__/* .ImageWithForwardedRef.Styling.Circle */ .U.Styling.Circle,
  time: dto.updated.getTime(),
  type: constants_index__WEBPACK_IMPORTED_MODULE_4__/* .InboxNotificationType.Braze */ .R.Braze,
  isViewed: dto.viewed,
  isControl: dto.extras.variant === 'control',
  note: null // TODO: check if we need to transform dto.description into note

});
const transformBrazeInboxMessageCardDto = dto => ({
  id: dto.id,
  messages: [],
  // braze message will be handled separately from context API to simplify parsing
  transactionId: undefined,
  isTranslated: false,
  oppositeUser: null,
  buyerId: undefined,
  isPaymentActionAvailable: false,
  translationType: constants_index__WEBPACK_IMPORTED_MODULE_5__/* .Translation.None */ .W.None,
  isReadByOppositeUser: dto.viewed,
  itemId: undefined,
  isReplyAllowed: true,
  isSuspicious: false,
  isBundleAvailable: false,
  transaction: null,
  suggestedMessages: undefined,
  item: null,
  education: null,
  moderatedItems: null,
  isControl: dto.extras.variant === 'control',
  userHasSupportRole: false
});
const transformBrazePromoBoxCardDto = dto => {
  var _dto$extras, _dto$extras2;

  const position = !dto.pinned && (_dto$extras = dto.extras) !== null && _dto$extras !== void 0 && _dto$extras.page && Number(dto.extras.page) ? (Number(dto.extras.page) - 1) * constants_index__WEBPACK_IMPORTED_MODULE_6__/* .PROMO_BOX_PAGE_LENGTH */ .jk + constants_index__WEBPACK_IMPORTED_MODULE_6__/* .PROMO_BOX_INDEX_IN_FEED_ROW */ .u9 : undefined;
  return {
    id: dto.id,
    url: dto.url,
    backgroundColor: undefined,
    imageUrl: dto.imageUrl,
    impressionUrl: null,
    isControl: ((_dto$extras2 = dto.extras) === null || _dto$extras2 === void 0 ? void 0 : _dto$extras2.variant) === 'control',
    type: dto.pinned ? constants_index__WEBPACK_IMPORTED_MODULE_7__/* .PromoBoxType.BrazeSticky */ .HM.BrazeSticky : constants_index__WEBPACK_IMPORTED_MODULE_7__/* .PromoBoxType.Braze */ .HM.Braze,
    position
  };
};

const resolveInAppDuration = inAppMessage => inAppMessage.dismissType === 'AUTO_DISMISS' ? inAppMessage.duration : undefined;

const resolveInAppButtonUrl = button => (button === null || button === void 0 ? void 0 : button.clickAction) === 'URI' ? button.uri : undefined;

const sortButtons = buttons => {
  const hasTwoButtons = buttons.length === constants_index__WEBPACK_IMPORTED_MODULE_6__/* .IN_APP_MAX_BUTTONS_COUNT */ .$2;

  if (hasTwoButtons) {
    return {
      primaryButton: buttons[0],
      secondaryButton: buttons[1]
    };
  }

  const button = buttons[0];
  const hasUrl = button.clickAction === 'URI';
  return {
    primaryButton: hasUrl ? button : undefined,
    secondaryButton: hasUrl ? undefined : button
  };
};

const transformBrazeSlideUpInAppMessageDto = dto => {
  return _objectSpread({
    message: dto.message,
    imageUrl: dto.imageUrl,
    duration: resolveInAppDuration(dto),
    url: dto.uri,
    position: dto.slideFrom === 'TOP' ? types_components__WEBPACK_IMPORTED_MODULE_8__/* .NotificationPosition.Top */ .E.Top : types_components__WEBPACK_IMPORTED_MODULE_8__/* .NotificationPosition.Bottom */ .E.Bottom,
    shouldOpenLinkInNewTab: dto.openTarget === 'BLANK',
    original: dto
  }, transformInAppMessageTrackingData(dto));
};
const transformBrazeModalInAppMessageDto = dto => {
  const {
    primaryButton,
    secondaryButton
  } = sortButtons(dto.buttons);
  return _objectSpread({
    header: dto.header,
    message: dto.message,
    imageUrl: dto.imageUrl,
    duration: resolveInAppDuration(dto),
    primaryButtonText: primaryButton === null || primaryButton === void 0 ? void 0 : primaryButton.text,
    secondaryButtonText: secondaryButton === null || secondaryButton === void 0 ? void 0 : secondaryButton.text,
    primaryButtonUrl: resolveInAppButtonUrl(primaryButton),
    secondaryButtonUrl: resolveInAppButtonUrl(secondaryButton),
    videoURL: undefined,
    type: types_models_in_app_message__WEBPACK_IMPORTED_MODULE_9__/* .InAppModalMessageType.Splash */ .j.Splash,
    shouldOpenLinkInNewTab: dto.openTarget === 'BLANK',
    original: dto
  }, transformInAppMessageTrackingData(dto));
};
const transformBrazeFullScreenInAppMessageDto = dto => {
  const type = dto.extras.inAppStyle === constants_index__WEBPACK_IMPORTED_MODULE_6__/* .FullScreenInAppStyle.Cover */ .Qd.Cover ? types_models_in_app_message__WEBPACK_IMPORTED_MODULE_9__/* .InAppModalMessageType.Cover */ .j.Cover : types_models_in_app_message__WEBPACK_IMPORTED_MODULE_9__/* .InAppModalMessageType.FullScreenSplash */ .j.FullScreenSplash;
  const videoURL = type === types_models_in_app_message__WEBPACK_IMPORTED_MODULE_9__/* .InAppModalMessageType.FullScreenSplash */ .j.FullScreenSplash && dto.extras.videoURL ? dto.extras.videoURL : undefined;
  const {
    primaryButton,
    secondaryButton
  } = sortButtons(dto.buttons);
  return _objectSpread({
    header: dto.header,
    message: dto.message,
    imageUrl: dto.imageUrl,
    duration: resolveInAppDuration(dto),
    primaryButtonText: primaryButton === null || primaryButton === void 0 ? void 0 : primaryButton.text,
    secondaryButtonText: secondaryButton === null || secondaryButton === void 0 ? void 0 : secondaryButton.text,
    primaryButtonUrl: resolveInAppButtonUrl(primaryButton),
    secondaryButtonUrl: resolveInAppButtonUrl(secondaryButton),
    videoURL,
    type,
    shouldOpenLinkInNewTab: dto.openTarget === 'BLANK',
    original: dto
  }, transformInAppMessageTrackingData(dto));
};

/***/ }),

/***/ 58557:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(70079);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(61888);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_1__);



const useDebounce = function useDebounce(callback) {
  let delay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 300;
  let leading = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  const callbackRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(callback);
  callbackRef.current = callback;
  return (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)((0,lodash__WEBPACK_IMPORTED_MODULE_1__.debounce)(function () {
    return callbackRef.current(...arguments);
  }, delay, {
    leading
  })).current;
};

/* harmony default export */ __webpack_exports__["Z"] = (useDebounce);

/***/ }),

/***/ 18475:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ hooks_useFetchInboxNotifications; }
});

// EXTERNAL MODULE: ../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(70079);
// EXTERNAL MODULE: ../app/data/api/index.ts + 1 modules
var api = __webpack_require__(96535);
// EXTERNAL MODULE: ../node_modules/.pnpm/@vinted+web-ui@39.0.0_@types+react@18.2.21_react-dom@18.2.0_react-lottie-player@1.5.4_react@18.2.0/node_modules/@vinted/web-ui/dist/esm/lib/Image/Image.js
var Image = __webpack_require__(37417);
// EXTERNAL MODULE: ../app/constants/inbox-notification.ts
var inbox_notification = __webpack_require__(14067);
;// CONCATENATED MODULE: ../app/data/transformers/generic-inbox-notification.ts


const transformUserNotificationDto = dto => ({
  id: String(dto.id),
  body: dto.body,
  link: dto.link,
  photoUrl: dto.small_photo_url,
  photoStyle: dto.photo_type === 'user' ? Image/* ImageWithForwardedRef.Styling.Circle */.U.Styling.Circle : Image/* ImageWithForwardedRef.Styling.Rounded */.U.Styling.Rounded,
  time: new Date(dto.updated_at).getTime(),
  type: inbox_notification/* InboxNotificationType.Vinted */.R.Vinted,
  isViewed: dto.is_read,
  note: dto.note,
  isControl: false
});
// EXTERNAL MODULE: ../app/data/transformers/braze.ts
var braze = __webpack_require__(19066);
// EXTERNAL MODULE: ../app/constants/ui.ts
var ui = __webpack_require__(55370);
;// CONCATENATED MODULE: ../app/libs/utils/notification.ts

const sortNotifications = notifications => {
  return [...notifications].sort((firstItem, secondItem) => secondItem.time - firstItem.time);
};
const sortPaginatedNotifications = (notifications, isEndReached) => {
  if (isEndReached) {
    return sortNotifications(notifications);
  }

  const userNotifications = notifications.filter(notification => notification.type === inbox_notification/* InboxNotificationType.Vinted */.R.Vinted);

  if (!userNotifications.length) {
    return sortNotifications(notifications);
  }

  const lastUserNotificationTime = userNotifications[userNotifications.length - 1].time; // Braze notifications, which are older than last user notification, should not be shown,
  // unless pagination end is reached

  const shownNotifications = notifications.filter(notification => notification.type === inbox_notification/* InboxNotificationType.Vinted */.R.Vinted || notification.time >= lastUserNotificationTime);
  return sortNotifications(shownNotifications);
};
// EXTERNAL MODULE: ../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/lodash.js
var lodash = __webpack_require__(61888);
// EXTERNAL MODULE: ../app/containers/BrazeProvider/BrazeContext.ts
var BrazeContext = __webpack_require__(99451);
;// CONCATENATED MODULE: ../app/libs/common/braze/hooks/useBrazeInboxNotificationCards.ts




function useBrazeInboxNotificationCards() {
  const {
    inboxNotificationCardStore
  } = (0,react.useContext)(BrazeContext/* default */.Z);
  const allNotificationCards = (0,react.useSyncExternalStore)(inboxNotificationCardStore.subscribe, () => inboxNotificationCardStore.state, () => null);
  const {
    0: brazeControlNotificationCards,
    1: brazeNotificationCards
  } = (0,react.useMemo)(() => allNotificationCards ? (0,lodash.partition)(allNotificationCards, card => card.extras.variant === 'control') : [undefined, undefined], [allNotificationCards]);
  return {
    brazeNotificationCards,
    brazeControlNotificationCards
  };
}

/* harmony default export */ var hooks_useBrazeInboxNotificationCards = (useBrazeInboxNotificationCards);
;// CONCATENATED MODULE: ../app/hooks/useFetchInboxNotifications.ts







const NOTIFICATIONS_PER_PAGE_DROPDOWN = 5; // TODO: currently, we resolve success state after backend notifications are fetched
// meaning Braze notifications could come later on and cause flickering

const useFetchInboxNotifications = function useFetchInboxNotifications() {
  let {
    perPage = NOTIFICATIONS_PER_PAGE_DROPDOWN,
    isPaginated
  } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  const {
    0: uiState,
    1: setUiState
  } = (0,react.useState)(ui/* UiState.Idle */.C.Idle);
  const {
    0: isFirstPageFetched,
    1: setIsFirstPageFetched
  } = (0,react.useState)(false);
  const {
    0: userNotifications,
    1: setUserNotifications
  } = (0,react.useState)([]);
  const {
    0: isEndReached,
    1: setIsEndReached
  } = (0,react.useState)(false);
  const currentPage = (0,react.useRef)(1);
  const {
    brazeNotificationCards,
    brazeControlNotificationCards
  } = hooks_useBrazeInboxNotificationCards();
  const brazeNotifications = (0,react.useMemo)(() => brazeNotificationCards ? brazeNotificationCards.map(card => (0,braze/* transformBrazeInboxCardNotificationDto */.su)(card)) : [], [brazeNotificationCards]);
  const brazeNotificationCount = brazeNotifications.filter(notification => !notification.isViewed).length;
  const unsortedNotifications = [...userNotifications, ...brazeNotifications];
  const sortedNotifications = isPaginated ? sortPaginatedNotifications(unsortedNotifications, isEndReached) : sortNotifications(unsortedNotifications);
  (0,react.useEffect)(() => {
    const fetchUserNotifications = async () => {
      const response = await (0,api/* getUserNotifications */.gGZ)({
        perPage,
        page: currentPage.current
      });

      if ('errors' in response) {
        setUiState(ui/* UiState.Failure */.C.Failure);
        setIsEndReached(true);
        return;
      }

      if (!response.notifications.length) {
        setUiState(ui/* UiState.Success */.C.Success);
        setIsEndReached(true);
        setIsFirstPageFetched(true);
        return;
      }

      currentPage.current += 1;
      const newNotifications = response.notifications.map(transformUserNotificationDto);
      setUserNotifications(prevNotifications => [...prevNotifications, ...newNotifications]);
      setIsFirstPageFetched(true);
      setUiState(ui/* UiState.Success */.C.Success);
      setIsEndReached(response.notifications.length < perPage);
    };

    if (uiState === ui/* UiState.Pending */.C.Pending) fetchUserNotifications();
  }, [uiState, perPage]);
  return {
    notifications: isFirstPageFetched ? sortedNotifications : [],
    setNotifications: setUserNotifications,
    controlNotificationCards: brazeControlNotificationCards,
    brazeNotificationCount,
    uiState,
    setUiState,
    isEndReached
  };
};

/* harmony default export */ var hooks_useFetchInboxNotifications = (useFetchInboxNotifications);

/***/ }),

/***/ 22194:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(70079);
/* harmony import */ var containers_BrazeProvider__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99451);
/* harmony import */ var constants_index__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(14067);
/* harmony import */ var libs_common_event_tracker_events__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(77368);
/* harmony import */ var constants_tracking_clickable_elements__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(82722);
/* harmony import */ var constants_tracking_viewable_elements__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(80782);
/* harmony import */ var _useTracking__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22390);








const useInboxNotificationEvents = () => {
  const {
    track
  } = (0,_useTracking__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)();
  const {
    logCardClick,
    logCardImpression,
    inboxNotificationCardStore
  } = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(containers_BrazeProvider__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z);
  const seenNotificationIds = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)([]);

  const handleNotificationClick = notification => () => {
    switch (notification.type) {
      case constants_index__WEBPACK_IMPORTED_MODULE_3__/* .InboxNotificationType.Vinted */ .R.Vinted:
        track((0,libs_common_event_tracker_events__WEBPACK_IMPORTED_MODULE_4__/* .clickEvent */ .Q5)({
          target: constants_tracking_clickable_elements__WEBPACK_IMPORTED_MODULE_5__/* .ClickableElement.Notification */ .U.Notification,
          targetDetails: JSON.stringify({
            notification_id: notification.id
          })
        }));
        break;

      case constants_index__WEBPACK_IMPORTED_MODULE_3__/* .InboxNotificationType.Braze */ .R.Braze:
        {
          if (!notification.link) return;
          logCardClick(notification.id);
          break;
        }

      default:
        break;
    }
  };

  const handleNotificationEnter = notification => () => {
    const isNotificationSeen = seenNotificationIds.current.includes(notification.id);
    if (!isNotificationSeen) seenNotificationIds.current.push(notification.id);
    const targetDetails = {
      notification_id: notification.id
    };

    switch (notification.type) {
      case constants_index__WEBPACK_IMPORTED_MODULE_3__/* .InboxNotificationType.Vinted */ .R.Vinted:
        if (isNotificationSeen) break;
        track((0,libs_common_event_tracker_events__WEBPACK_IMPORTED_MODULE_4__/* .viewEvent */ .rn)({
          target: constants_tracking_viewable_elements__WEBPACK_IMPORTED_MODULE_6__/* .ViewableElement.Notification */ .G.Notification,
          targetDetails: JSON.stringify(targetDetails)
        }));
        break;

      case constants_index__WEBPACK_IMPORTED_MODULE_3__/* .InboxNotificationType.Braze */ .R.Braze:
        {
          const viewedBefore = notification.isViewed;
          logCardImpression(notification.id).then(isLogged => {
            if (!isLogged || viewedBefore) return;

            if (inboxNotificationCardStore.state) {
              inboxNotificationCardStore.state = Array.from(inboxNotificationCardStore.state);
            }
          });
          break;
        }

      default:
        break;
    }
  };

  return {
    onClick: handleNotificationClick,
    onEnter: handleNotificationEnter
  };
};

/* harmony default export */ __webpack_exports__["Z"] = (useInboxNotificationEvents);

/***/ }),

/***/ 30249:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3283);
/* harmony import */ var constants_dark_mode__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(50538);
/* harmony import */ var libs_utils_localStorage__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(49097);
/* harmony import */ var state_feature_switches_selectors__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(84353);
/* harmony import */ var _useIsDarkMode__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(54967);






const useShouldShowDarkModeAdoption = () => {
  const isDarkModeAdoptionEnabled = (0,react_redux__WEBPACK_IMPORTED_MODULE_0__/* .useSelector */ .v9)((0,state_feature_switches_selectors__WEBPACK_IMPORTED_MODULE_1__/* .getIsFeatureSwitchEnabled */ .z)('web_dark_mode_adoption'));
  const isDarkMode = (0,_useIsDarkMode__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)();
  return isDarkModeAdoptionEnabled && !(0,libs_utils_localStorage__WEBPACK_IMPORTED_MODULE_3__/* .getLocalStorageItem */ .le)(constants_dark_mode__WEBPACK_IMPORTED_MODULE_4__/* .IS_DARK_MODE_BANNER_CLOSED_LOCAL_STORAGE_KEY */ .bV) && !isDarkMode;
};

/* harmony default export */ __webpack_exports__["Z"] = (useShouldShowDarkModeAdoption);

/***/ }),

/***/ 57190:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ useUserStats_useUserStats; }
});

// EXTERNAL MODULE: ../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(70079);
// EXTERNAL MODULE: ../node_modules/.pnpm/react-redux@7.2.8_react-dom@18.2.0_react@18.2.0/node_modules/react-redux/es/index.js + 22 modules
var es = __webpack_require__(3283);
// EXTERNAL MODULE: ../app/constants/ui.ts
var ui = __webpack_require__(55370);
// EXTERNAL MODULE: ../app/data/api/index.ts + 1 modules
var api = __webpack_require__(96535);
// EXTERNAL MODULE: ../app/state/session/selectors.ts
var selectors = __webpack_require__(32707);
// EXTERNAL MODULE: ../app/state/user-stats/constants.ts
var constants = __webpack_require__(74045);
;// CONCATENATED MODULE: ../app/state/user-stats/selectors.ts


const localState = state => state[constants/* stateName */.A];

const getUserStats = state => localState(state).stats;
const getRequestState = state => localState(state).requestState;
// EXTERNAL MODULE: ../app/state/user-stats/slice.ts + 1 modules
var slice = __webpack_require__(35965);
;// CONCATENATED MODULE: ../app/hooks/useUserStats/useUserStats.ts








const useUserStats = () => {
  const dispatch = (0,es/* useDispatch */.I0)();
  const userStats = (0,es/* useSelector */.v9)(getUserStats);
  const requestState = (0,es/* useSelector */.v9)(getRequestState);
  const userId = (0,es/* useSelector */.v9)(selectors/* getUserId */.n5);
  const handleApiResponse = (0,react.useCallback)(response => {
    if ('errors' in response) {
      dispatch(slice/* actions.getUserStatsFailure */.Nw.getUserStatsFailure());
      return;
    }

    dispatch(slice/* actions.getUserStatsSuccess */.Nw.getUserStatsSuccess({
      stats: response.stats
    }));
  }, [dispatch]);
  const fetchUserStats = (0,react.useCallback)(() => {
    if (!userId) return;
    dispatch(slice/* actions.getUserStatsRequest */.Nw.getUserStatsRequest());
    (0,api/* getUserStats */.X_6)(userId).then(handleApiResponse);
  }, [dispatch, userId, handleApiResponse]);
  (0,react.useEffect)(() => {
    if (userStats) return;
    if (requestState !== ui/* UiState.Idle */.C.Idle) return;
    fetchUserStats();
  }, [fetchUserStats, requestState, userStats]);
  return {
    userStats,
    fetchUserStats
  };
};

/* harmony default export */ var useUserStats_useUserStats = (useUserStats);

/***/ }),

/***/ 68387:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ ad_manager; }
});

// EXTERNAL MODULE: ../node_modules/.pnpm/next@12.3.3_@babel+core@7.14.3_react-dom@18.2.0_react@18.2.0_sass@1.49.9/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(39565);
// EXTERNAL MODULE: ../app/constants/ads.ts
var ads = __webpack_require__(12196);
// EXTERNAL MODULE: ../app/constants/consent.ts
var consent = __webpack_require__(23168);
// EXTERNAL MODULE: ../app/libs/utils/consentGroups.ts
var consentGroups = __webpack_require__(64703);
// EXTERNAL MODULE: ../app/libs/utils/environment.ts
var environment = __webpack_require__(61928);
// EXTERNAL MODULE: ../app/libs/utils/userAgentParser.ts
var userAgentParser = __webpack_require__(12618);
// EXTERNAL MODULE: ../app/libs/utils/window.ts
var utils_window = __webpack_require__(25937);
// EXTERNAL MODULE: ../app/libs/common/tracker.ts + 3 modules
var tracker = __webpack_require__(55654);
// EXTERNAL MODULE: ../app/libs/common/event-tracker/events.ts
var events = __webpack_require__(77368);
;// CONCATENATED MODULE: ../app/libs/common/ad-manager/utils.ts





function getPlacementById(id) {
  const {
    adPlacements
  } = window;
  return adPlacements === null || adPlacements === void 0 ? void 0 : adPlacements[id];
}
function getAdUnitPath(_ref) {
  let {
    dfpAccountId,
    dfpCode
  } = _ref;
  return "/".concat(dfpAccountId, "/").concat(dfpCode);
}
function getAdUnitName(_ref2) {
  let {
    shape,
    page,
    mediation
  } = _ref2;
  const adUnitNameParts = ['ad', shape, page];

  if (mediation) {
    adUnitNameParts.push(mediation);
  }

  return adUnitNameParts.join('-');
}
function setupGoogleEvents(googleSlot, callbacks) {
  const {
    googletag
  } = window;
  if (!googletag) return;
  Object.keys(callbacks).forEach(callbackKey => {
    const key = callbackKey;
    const callback = callbacks[key];
    if (!callback) return;
    googletag.pubads().addEventListener(key, event => {
      if (event.slot === googleSlot) callback(event);
    });
  });
}
function setupAdPlacement(_ref3) {
  let {
    id,
    placementConfig,
    node,
    isRefreshEnabled = false,
    isManuallyRendered = false,
    isManuallyRefreshed = false,
    isOutOfPageAd = false
  } = _ref3;

  if (!window.adPlacements) {
    window.adPlacements = {};
  }

  const {
    adPlacements
  } = window;
  const adUnitPath = getAdUnitPath(placementConfig);
  const adUnitName = getAdUnitName(placementConfig);
  adPlacements[id] = {
    code: id,
    adUnitPath,
    adUnitName,
    shape: placementConfig.shape,
    sizes: placementConfig.sizes,
    bids: placementConfig.bids,
    dfpCode: placementConfig.dfpCode,
    dfpAccountId: placementConfig.dfpAccountId,
    activeDuration: 0,
    isRefreshEnabled,
    isManuallyRendered,
    isManuallyRefreshed,
    isOutOfPageAd,
    node
  };
}
function setupGoogleSlot(placementId, callbacks, iframeTitle) {
  const placement = getPlacementById(placementId);
  const {
    googletag
  } = window;
  if (!googletag || !placement) return;
  const {
    adUnitPath,
    sizes
  } = placement;
  googletag.cmd.push(() => {
    if (iframeTitle) googletag.setAdIframeTitle(iframeTitle);
    const slot = googletag.defineSlot(adUnitPath, sizes, placementId);
    if (!slot) return;
    slot.addService(googletag.pubads());
    slot.setCollapseEmptyDiv(true);
    setupGoogleEvents(slot, callbacks);
    placement.googleSlot = slot;
  });
}
function handleSasNoAd(placementId, node) {
  const {
    pbjs
  } = window;
  if (!pbjs) return;
  const bid = pbjs.getHighestCpmBids(placementId)[0];

  if (bid && node) {
    const iframe = document.createElement('iframe');
    iframe.width = String(bid.width);
    iframe.height = String(bid.height);
    iframe.frameBorder = String(0);
    iframe.scrolling = 'no';
    node.appendChild(iframe);

    if (iframe.contentWindow) {
      pbjs.renderAd(iframe.contentWindow.document, bid.adId);
      iframe.contentWindow.document.body.style.padding = '0';
    }
  }
}
function setupSasFormat(placementId, shape) {
  const placement = getPlacementById(placementId);
  const {
    sas
  } = window;
  if (!sas || !placement || !ads/* MapSasFormatsToAdShape */.RW[shape]) return;
  const {
    node
  } = placement;
  sas.cmd.push(() => {
    sas.events.on(ads/* SmartAdServerEventName.NoAd */.I7.NoAd, () => handleSasNoAd(placementId, node), placementId);
    sas.adCallConfig.formats.push({
      id: ads/* MapSasFormatsToAdShape */.RW[shape],
      tagId: placementId
    });
  });
}
function sendConsentlessAdRequest(placementId, bid) {
  const {
    sas
  } = window;
  if (!sas) return;
  if (bid) sas.setHeaderBiddingWinner(placementId, bid);
  sas.callSmart();
  sas.cmd.push(() => {
    sas.render(placementId);
  });
}
function isBidderStateValid(requestManager, bidder) {
  return requestManager[bidder] === ads/* BidderState.Fetched */._b.Fetched;
}
function sendConsentedAdserverRequest(placementId, requestManager) {
  const {
    googletag,
    pbjs,
    apstag
  } = window;
  const {
    isManuallyRendered
  } = getPlacementById(placementId);
  googletag.cmd.push(() => {
    const placementSlot = googletag.pubads().getSlots().find(slot => slot.getSlotElementId() === placementId);
    if (isBidderStateValid(requestManager, ads/* Bidder.Prebid */.tO.Prebid)) pbjs.setTargetingForGPTAsync([placementId]);
    if (isBidderStateValid(requestManager, ads/* Bidder.Amazon */.tO.Amazon)) apstag.setDisplayBids();
    if (isManuallyRendered) googletag.display(placementId);
    if (placementSlot && !isManuallyRendered) googletag.pubads().refresh([placementSlot]);
  });
}
function isArrayOfNumbers(candidate) {
  return !!candidate && Array.isArray(candidate) && !candidate.find(candidateItem => {
    return Array.isArray(candidateItem) ? !!candidateItem.find(candidateItemItem => Number.isNaN(Number.parseInt(candidateItemItem, 10))) : Number.isNaN(Number.parseInt(candidateItem, 10));
  });
}
function fetchAmazonBids(placementId, onBidderBack) {
  let isRefresh = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  const placement = getPlacementById(placementId);
  const {
    apstag
  } = window;
  let hasTimedOut = false;
  if (!apstag || !placement) return;
  const {
    sizes,
    dfpCode
  } = placement;

  if (sizes === 'fluid' || !isArrayOfNumbers(sizes)) {
    onBidderBack(ads/* Bidder.Amazon */.tO.Amazon, placementId, ads/* BidderState.BadSizes */._b.BadSizes);
    return;
  }

  const config = {
    slots: [{
      slotID: placementId,
      slotName: dfpCode,
      sizes
    }],
    params: {
      adRefresh: isRefresh ? '1' : '0'
    }
  };
  const timeout = setTimeout(() => {
    hasTimedOut = true;
    onBidderBack(ads/* Bidder.Amazon */.tO.Amazon, placementId, ads/* BidderState.TimedOut */._b.TimedOut);
  }, ads/* ADS_BIDDER_TIMEOUT */.uB);
  apstag.fetchBids(config, () => {
    if (hasTimedOut) return;
    clearTimeout(timeout);
    onBidderBack(ads/* Bidder.Amazon */.tO.Amazon, placementId, ads/* BidderState.Fetched */._b.Fetched);
  });
}
function fetchPrebidBids(placementId, onBidderBack) {
  var _placement$bids;

  let isRefresh = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  const isTargetingEnabled = (0,consentGroups/* checkConsentGroup */.X)(consent/* ConsentGroup.Targeting */.R0.Targeting);
  const placement = getPlacementById(placementId);
  const {
    pbjs
  } = window;
  if (!pbjs || !placement) return;

  if (!(placement !== null && placement !== void 0 && (_placement$bids = placement.bids) !== null && _placement$bids !== void 0 && _placement$bids.length)) {
    if (isTargetingEnabled) onBidderBack(ads/* Bidder.Prebid */.tO.Prebid, placementId, ads/* BidderState.NoBids */._b.NoBids);
    return;
  }

  const {
    sizes,
    bids,
    adUnitName,
    adUnitPath,
    googleSlot
  } = placement;
  const prebidPlacement = {
    code: placementId,
    mediaTypes: {
      banner: {
        sizes
      }
    },
    bids: bids.reduce((acc, bid) => {
      const stringifiedBid = JSON.stringify(bid);
      const stringifiedBids = JSON.stringify(acc);
      if (stringifiedBids.includes(stringifiedBid)) return acc;
      return [...acc, bid];
    }, []),
    pubstack: {
      adUnitPath,
      adUnitName
    }
  };
  pbjs.que.push(() => {
    if (!isRefresh) pbjs.addAdUnits(prebidPlacement);
    pbjs.requestBids({
      adUnitCodes: [placementId],

      bidsBackHandler(_bids, timedOut) {
        if (timedOut) tracker/* tracker.track */.ap.track((0,events/* prebidTimedOutEvent */._m)());

        if (isTargetingEnabled) {
          if (isRefresh) googleSlot === null || googleSlot === void 0 ? void 0 : googleSlot.setTargeting('ad_refresh', 'true');
          if (timedOut) return onBidderBack(ads/* Bidder.Prebid */.tO.Prebid, placementId, ads/* BidderState.TimedOut */._b.TimedOut);
          return onBidderBack(ads/* Bidder.Prebid */.tO.Prebid, placementId, ads/* BidderState.Fetched */._b.Fetched);
        }

        const bid = pbjs.getHighestCpmBids(placementId)[0];
        return sendConsentlessAdRequest(placementId, bid);
      },

      timeout: ads/* ADS_BIDDER_TIMEOUT */.uB
    });
  });
}
;// CONCATENATED MODULE: ../app/libs/common/ad-manager/ad-manager.ts


function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}









const AdManager = (() => {
  let adCount = 0;
  const refreshManager = {
    isOn: false,
    lastActionTimestamp: Date.now(),
    refreshInterval: undefined,
    debounceTimer: undefined
  };
  const locationManager = {
    isLocationChangeEventSetup: false,
    lastHref: environment/* serverSide */.X ? '/' : window.location.href
  };
  const requestManager = Object.values(ads/* Bidder */.tO).reduce((acc, bidder) => _objectSpread(_objectSpread({}, acc), {}, {
    [bidder]: ads/* BidderState.Idle */._b.Idle
  }), {});
  const individualRequestManager = {};

  function areAllBidsBack(placementId) {
    const bidders = Object.values(ads/* Bidder */.tO);
    const backStates = [ads/* BidderState.Fetched */._b.Fetched, ads/* BidderState.TimedOut */._b.TimedOut, ads/* BidderState.BadSizes */._b.BadSizes, ads/* BidderState.NoBids */._b.NoBids];
    return bidders.map(bidder => individualRequestManager[placementId][bidder]).filter(bidderState => backStates.includes(bidderState)).length === bidders.length;
  }

  function headerBidderBack(bidder, placementId, state) {
    if (!individualRequestManager[placementId]) {
      individualRequestManager[placementId] = _objectSpread({}, requestManager);
    }

    individualRequestManager[placementId][bidder] = state;

    if (areAllBidsBack(placementId)) {
      sendConsentedAdserverRequest(placementId, individualRequestManager[placementId]);
    }
  }

  function requestHeaderBidding(id) {
    let refresh = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    if ((0,consentGroups/* checkConsentGroup */.X)(consent/* ConsentGroup.Targeting */.R0.Targeting)) fetchAmazonBids(id, headerBidderBack, refresh);
    fetchPrebidBids(id, headerBidderBack, refresh);
  }

  function isAdVisible(node) {
    if (!node) return false;
    const boundaries = node.getBoundingClientRect();
    if (!boundaries) return false;
    const offset = boundaries.height * ads/* AD_VISIBILITY_RATIO */.en;
    const isVisible = window.innerHeight > boundaries.top + offset && boundaries.bottom > offset;
    return isVisible;
  }

  function isUserActive() {
    const inactiveDuration = (Date.now() - refreshManager.lastActionTimestamp) / 1000;
    return !document.hidden && inactiveDuration < ads/* USER_INACTIVE_TIME */.mF;
  }

  function refreshAd(placementId) {
    const placement = getPlacementById(placementId);
    if (!placement || !individualRequestManager[placementId]) return;
    individualRequestManager[placementId] = _objectSpread({}, requestManager);
    requestHeaderBidding(placementId, true);
    window.adPlacements[placementId].activeDuration = 0;
  }

  function handleRefreshTick() {
    if (!window.adPlacements) return;
    if (!isUserActive()) return;
    Object.keys(window.adPlacements).filter(placementId => {
      const placement = getPlacementById(placementId);
      if (!placement) return false;
      const {
        isManuallyRefreshed,
        isRefreshEnabled
      } = placement;
      if (isRefreshEnabled && !isManuallyRefreshed) return true;
      return false;
    }).forEach(placementId => {
      const placement = getPlacementById(placementId);
      if (!placement) return;
      const {
        isOutOfPageAd,
        node,
        activeDuration
      } = placement;
      const isRefreshAvailable = isOutOfPageAd || isAdVisible(node);
      if (!isRefreshAvailable) return;

      if (activeDuration >= ads/* REFRESH_AD_TIME */.kh) {
        refreshAd(placementId);
      }

      window.adPlacements[placementId].activeDuration += 1;
    });
  }

  function handleActivityEvent() {
    refreshManager.lastActionTimestamp = Date.now();
  }

  function handleLocationChange() {
    if (window.location.href !== locationManager.lastHref && !!window.adPlacements && !refreshManager.debounceTimer) {
      refreshManager.debounceTimer = setTimeout(() => {
        refreshManager.debounceTimer = undefined;
      }, ads/* DEBOUNCE_TIME */.xE);
      Object.keys(window.adPlacements).forEach(placementId => {
        const placement = getPlacementById(placementId);
        if (!placement) return;
        const {
          node,
          isOutOfPageAd
        } = placement;
        if (!isOutOfPageAd && !node) return;
        refreshAd(placementId);
      });
    }

    locationManager.lastHref = window.location.href;
  }

  function setupUrlChangeHandler() {
    if (locationManager.isLocationChangeEventSetup || !('Proxy' in window)) return;
    window.history.pushState = new Proxy(window.history.pushState, {
      apply: (target, thisArg, argArray) => {
        window.dispatchEvent(new Event('locationchange'));
        return target.apply(thisArg, argArray);
      }
    });
    window.addEventListener('locationchange', handleLocationChange);
    locationManager.isLocationChangeEventSetup = true;
  }

  function setupRefresh() {
    refreshManager.isOn = true;
    refreshManager.refreshInterval = setInterval(handleRefreshTick, 1000);
    ads/* ACTIVITY_EVENTS.forEach */.D5.forEach(event => window.addEventListener(event, handleActivityEvent));
    setupUrlChangeHandler();
  }

  function stopAdRefresh() {
    if (refreshManager.refreshInterval) clearInterval(refreshManager.refreshInterval);
    refreshManager.isOn = false;
    ads/* ACTIVITY_EVENTS.forEach */.D5.forEach(event => window.removeEventListener(event, handleActivityEvent));
    window.removeEventListener('locationchange', handleLocationChange);
  }

  function generatePlacementId() {
    adCount += 1;
    return "adplacement-".concat(adCount);
  }

  function unregisterPlacement(placementId) {
    const {
      adPlacements
    } = window;
    if (!adPlacements) return;
    const adPlacement = adPlacements[placementId];
    if (!adPlacement) return;
    const {
      sas,
      googletag
    } = window;

    if (googletag && adPlacement.googleSlot) {
      const slot = adPlacement.googleSlot;
      googletag.cmd.push(() => {
        googletag.destroySlots([slot]);
      });
    }

    if (sas) {
      sas.cmd.push(() => {
        sas.clean(placementId);
      });
    }

    delete adPlacements[placementId];
    delete individualRequestManager[placementId];
    if (!Object.keys(adPlacements).length) stopAdRefresh();
  }

  function registerPlacement(_ref) {
    let {
      id,
      placementConfig,
      onPlacementLoad,
      onPlacementRenderEnded,
      onPlacementRequest,
      onImpressionViewable,
      isRefreshEnabled,
      isManuallyRendered = false,
      isManuallyRefreshed = false,
      iframeTitle
    } = _ref;
    const node = document.getElementById(id);
    if (!node) return;
    setupAdPlacement({
      id,
      placementConfig,
      node,
      isManuallyRendered,
      isManuallyRefreshed,
      isRefreshEnabled
    });
    setupGoogleSlot(id, {
      [ads/* GoogleEventName.SlotOnload */.g8.SlotOnload]: onPlacementLoad,
      [ads/* GoogleEventName.SlotRequested */.g8.SlotRequested]: onPlacementRequest,
      [ads/* GoogleEventName.SlotRenderEnded */.g8.SlotRenderEnded]: onPlacementRenderEnded,
      [ads/* GoogleEventName.ImpressionViewable */.g8.ImpressionViewable]: onImpressionViewable
    }, iframeTitle);
    setupSasFormat(id, placementConfig.shape);
    requestHeaderBidding(id);
    if (!refreshManager.isOn && isRefreshEnabled) setupRefresh();
  }

  function getAdsPlatform() {
    return (0,userAgentParser/* isMobile */.tq)((0,utils_window/* getUserAgent */.ij)()) ? ads/* AdPlatform.Mobile */.vU.Mobile : ads/* AdPlatform.Web */.vU.Web;
  }

  function sendManualAdRequest(placementId) {
    const placement = getPlacementById(placementId);
    if (!placement) return;
    googletag.cmd.push(() => {
      if (placement.googleSlot) googletag.pubads().refresh([placement.googleSlot]);
    });
  }

  return {
    generatePlacementId,
    unregisterPlacement,
    registerPlacement,
    getAdsPlatform,
    sendManualAdRequest
  };
})();

/* harmony default export */ var ad_manager = (AdManager);

/***/ }),

/***/ 78526:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(70079);
/* harmony import */ var containers_BrazeProvider__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(99451);



function useBrazeControlCardImpressionLogging(ids) {
  const {
    logCardImpression
  } = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(containers_BrazeProvider__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    ids.forEach(id => logCardImpression(id)); // we should not log an impression if the parent component decides to update
    // the reference of `ids`. So this small "hack" will ensure that we are protected
    // from random re-renders.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [JSON.stringify(ids)]);
}

/* harmony default export */ __webpack_exports__["Z"] = (useBrazeControlCardImpressionLogging);

/***/ }),

/***/ 4535:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(61888);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(70079);
/* harmony import */ var containers_BrazeProvider__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99451);




function useBrazeInboxMessageCards() {
  const {
    inboxMessageCardStore
  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(containers_BrazeProvider__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z);
  const allInboxMessageCards = (0,react__WEBPACK_IMPORTED_MODULE_1__.useSyncExternalStore)(inboxMessageCardStore.subscribe, () => inboxMessageCardStore.state, () => null);
  const {
    0: inboxControlMessageCards,
    1: inboxMessageCards
  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(() => allInboxMessageCards ? (0,lodash__WEBPACK_IMPORTED_MODULE_0__.partition)(allInboxMessageCards, card => card.extras.variant === 'control') : [undefined, undefined], [allInboxMessageCards]);
  return {
    inboxMessageCards,
    inboxControlMessageCards
  };
}

/* harmony default export */ __webpack_exports__["Z"] = (useBrazeInboxMessageCards);

/***/ }),

/***/ 6933:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ getSustainabilityUrl; },
/* harmony export */   "J": function() { return /* binding */ getPressCenterUrl; }
/* harmony export */ });
/* harmony import */ var constants_routes__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(98923);

const SUSTAINABILITY_REPORT_LOCALES = ['pl', 'nl', 'de', 'it', 'es'];
const PRESS_CENTER_LOCALES = ['en', 'fr', 'lt'];

const getLangParam = activeLocale => {
  const isLocaleSupported = SUSTAINABILITY_REPORT_LOCALES.includes(activeLocale);
  return isLocaleSupported ? "?lang=".concat(activeLocale) : '';
};

const getLocaleSubPath = activeLocale => PRESS_CENTER_LOCALES.includes(activeLocale) ? "/".concat(activeLocale) : '';

const getPressCenterUrl = activeLocale => "".concat(constants_routes__WEBPACK_IMPORTED_MODULE_0__/* .PRESS_CENTER_URL */ .n$u).concat(getLocaleSubPath(activeLocale));
const getSustainabilityUrl = activeLocale => "".concat(getPressCenterUrl(activeLocale), "/sustainability").concat(getLangParam(activeLocale));

/***/ }),

/***/ 12618:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Dt": function() { return /* binding */ isAndroid; },
/* harmony export */   "Hp": function() { return /* binding */ parseOS; },
/* harmony export */   "gn": function() { return /* binding */ isIOS; },
/* harmony export */   "tq": function() { return /* binding */ isMobile; }
/* harmony export */ });
const DEVICE_OS_ANDROID = 'Android';
const DEVICE_OS_IOS = 'iOS';
const DEVICE_OS_WINDOWS_PHONE = 'Windows Phone';
function parseOS(userAgent) {
  // Windows Phone must come first because its UA also contains "Android"
  if (/windows phone/i.test(userAgent)) {
    return DEVICE_OS_WINDOWS_PHONE;
  }

  if (/android/i.test(userAgent)) {
    return DEVICE_OS_ANDROID;
  } // iOS detection from: http://stackoverflow.com/a/9039885/177710


  if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
    return DEVICE_OS_IOS;
  }

  return null;
}

const isIOS = userAgent => parseOS(userAgent) === DEVICE_OS_IOS;

const isAndroid = userAgent => parseOS(userAgent) === DEVICE_OS_ANDROID;

const isMobile = userAgent => {
  return /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(userAgent);
};

/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (parseOS)));


/***/ }),

/***/ 77227:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I": function() { return /* binding */ getEmailCodeView; }
/* harmony export */ });
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(28251);


const localState = state => state[_constants__WEBPACK_IMPORTED_MODULE_0__/* .stateName */ .A];

const getEmailCodeView = state => localState(state).emailCodeView;

/***/ }),

/***/ 92593:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "j": function() { return /* binding */ InAppModalMessageType; }
/* harmony export */ });
let InAppModalMessageType;

(function (InAppModalMessageType) {
  InAppModalMessageType["Splash"] = "Splash";
  InAppModalMessageType["Cover"] = "Cover";
  InAppModalMessageType["FullScreenSplash"] = "FullScreenSplash";
})(InAppModalMessageType || (InAppModalMessageType = {}));

/***/ })

}]);